/* eslint-disable */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  BigInt: { input: any; output: any }
  Country: { input: any; output: any }
  ISO8601Date: { input: any; output: any }
  ISO8601DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
}

/** Autogenerated input type of AcceptSageGiftAccountDifferences */
export type AcceptSageGiftAccountDifferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of AcceptSageGiftAccountDifferences. */
export type AcceptSageGiftAccountDifferencesPayload = {
  __typename?: 'AcceptSageGiftAccountDifferencesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  results: Array<SageGiftAccountDifferenceActionResult>
}

export type AccountingEvent = {
  __typename?: 'AccountingEvent'
  detail?: Maybe<Scalars['String']['output']>
  journalEntryId?: Maybe<Scalars['ID']['output']>
  /** case, manual_flag, chariot, data_hub_entry, sage_entry or alert */
  kind: Scalars['String']['output']
  occurredAt: Scalars['ISO8601DateTime']['output']
  title: Scalars['String']['output']
}

export type AccountingHistory = {
  __typename?: 'AccountingHistory'
  dataHubLines: Array<AccountingLine>
  events: Array<AccountingEvent>
  sageEntries: Array<SageLedgerEntry>
}

export type AccountingLine = {
  __typename?: 'AccountingLine'
  amount: Money
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  glAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  journalEntryId: Scalars['ID']['output']
  journalEntrySageId?: Maybe<Scalars['String']['output']>
  journalEntryStatus: Scalars['String']['output']
  journalEntryType: Scalars['String']['output']
  postingDate: Scalars['ISO8601Date']['output']
  txnType: Scalars['String']['output']
}

/** Autogenerated input type of AcknowledgeTrainingPolicies */
export type AcknowledgeTrainingPoliciesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  policyIds: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of AcknowledgeTrainingPolicies. */
export type AcknowledgeTrainingPoliciesPayload = {
  __typename?: 'AcknowledgeTrainingPoliciesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policies: Array<StaffTrainingPolicy>
}

/** Autogenerated input type of AddAssetSecret */
export type AddAssetSecretInput = {
  assetId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  kind: AssetSecretKindEnum
  /** Named so Rails filters it from logs */
  secretValue: Scalars['String']['input']
}

/** Autogenerated return type of AddAssetSecret. */
export type AddAssetSecretPayload = {
  __typename?: 'AddAssetSecretPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of AddNewStarter */
export type AddNewStarterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Needed without employeeId */
  email?: InputMaybe<Scalars['String']['input']>
  /** Someone already here from Salesforce. Their name, email and title stay as they are */
  employeeId?: InputMaybe<Scalars['ID']['input']>
  /** Needed without employeeId */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Needed without employeeId */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Create or upgrade their FP Navigator login and email them the sign-in guide. Needs CREATE_USER */
  navigatorAccess?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  teamId?: InputMaybe<Scalars['ID']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  trainingRequired?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of AddNewStarter. */
export type AddNewStarterPayload = {
  __typename?: 'AddNewStarterPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  employee: Employee
}

/** Autogenerated input type of AddPlusOne */
export type AddPlusOneInput = {
  /** The guest whose party they join */
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** False holds the plus-one's email and calendar invite, for sendHeldUpdates to send later */
  notify?: InputMaybe<Scalars['Boolean']['input']>
  plusOne: AttendeeDetailsInput
}

/** Autogenerated return type of AddPlusOne. */
export type AddPlusOnePayload = {
  __typename?: 'AddPlusOnePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  plusOne?: Maybe<EventAttendeeAdmin>
}

export type AddressInput = {
  city: Scalars['String']['input']
  countryCode: Scalars['Country']['input']
  phoneCountryCode: Scalars['String']['input']
  phoneNumberWithoutCountryCode: Scalars['String']['input']
  postalCode: Scalars['String']['input']
  state?: InputMaybe<Scalars['String']['input']>
  street: Scalars['String']['input']
}

export type Adjustment = {
  __typename?: 'Adjustment'
  amount: Money
  createdDate: Scalars['ISO8601Date']['output']
  displayName: Scalars['String']['output']
  id: Scalars['String']['output']
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
}

export type AdminCharityBankAccount = {
  __typename?: 'AdminCharityBankAccount'
  abaRoutingNumber?: Maybe<Scalars['String']['output']>
  accountHolderName?: Maybe<Scalars['String']['output']>
  accountNumber?: Maybe<Scalars['String']['output']>
  accountNumberLast4?: Maybe<Scalars['String']['output']>
  bankCountry?: Maybe<Scalars['String']['output']>
  bankCurrency?: Maybe<Scalars['String']['output']>
  bankName?: Maybe<Scalars['String']['output']>
  canRetire: Scalars['Boolean']['output']
  charity: Charity
  charityBankAccountChecklistItems: Array<AdminCharityBankAccountChecklistItem>
  charityBankAccountProofs: Array<AdminCharityBankAccountProof>
  charityBankAccountVerificationCalls: Array<AdminCharityBankAccountVerificationCall>
  checklistHasFlaggedItems: Scalars['Boolean']['output']
  checklistIncomplete: Scalars['Boolean']['output']
  checklistReadyForVerificationCall: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByUser: User
  iban?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  rejectionReason?: Maybe<Scalars['String']['output']>
  sortCode?: Maybe<Scalars['String']['output']>
  status: CharityBankAccountStatusEnum
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  submittedByUser?: Maybe<User>
  swiftCode?: Maybe<Scalars['String']['output']>
  verificationNotes?: Maybe<Scalars['String']['output']>
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  verifiedByUser?: Maybe<User>
}

export type AdminCharityBankAccountChecklistItem = {
  __typename?: 'AdminCharityBankAccountChecklistItem'
  id: Scalars['ID']['output']
  itemKey: BankAccountChecklistItemKeyEnum
  notes?: Maybe<Scalars['String']['output']>
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  reviewedByUser?: Maybe<User>
  status: BankAccountChecklistItemStatusEnum
}

export type AdminCharityBankAccountProof = {
  __typename?: 'AdminCharityBankAccountProof'
  documentType: CharityBankAccountProofDocumentTypeEnum
  fileName?: Maybe<Scalars['String']['output']>
  fileUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type AdminCharityBankAccountVerificationCall = {
  __typename?: 'AdminCharityBankAccountVerificationCall'
  abaRoutingNumber?: Maybe<Scalars['String']['output']>
  accountCurrency?: Maybe<Scalars['String']['output']>
  accountHolderAddress?: Maybe<Scalars['String']['output']>
  accountHolderName?: Maybe<Scalars['String']['output']>
  accountNumber?: Maybe<Scalars['String']['output']>
  bankAddress?: Maybe<Scalars['String']['output']>
  bankName?: Maybe<Scalars['String']['output']>
  callDateTime: Scalars['ISO8601DateTime']['output']
  callOutcome: VerificationCallOutcomeEnum
  comments?: Maybe<Scalars['String']['output']>
  completedByUser?: Maybe<User>
  contactName?: Maybe<Scalars['String']['output']>
  contactRole?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  duringCallChecklist?: Maybe<Scalars['JSON']['output']>
  emailAddressUsed?: Maybe<Scalars['String']['output']>
  emailSource?: Maybe<Scalars['String']['output']>
  iban?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  identityConfirmationMethod?: Maybe<Scalars['String']['output']>
  intermediaryBankDetails?: Maybe<Scalars['String']['output']>
  intermediaryBankName?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  phoneNumberSource?: Maybe<Scalars['String']['output']>
  preCallChecklist?: Maybe<Scalars['JSON']['output']>
  redFlagsMitigationNotes?: Maybe<Scalars['String']['output']>
  redFlagsPresent: Scalars['Boolean']['output']
  sortCode?: Maybe<Scalars['String']['output']>
  swiftCode?: Maybe<Scalars['String']['output']>
  telephoneNumberCalled?: Maybe<Scalars['String']['output']>
}

export type AdminCharityContact = {
  __typename?: 'AdminCharityContact'
  charity: Charity
  email: Scalars['String']['output']
  emailVerification?: Maybe<AdminCharityContactEmailVerification>
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  jobRole?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  portalStatus?: Maybe<CharityContactPortalEnum>
  role?: Maybe<Scalars['String']['output']>
  surname: Scalars['String']['output']
  user?: Maybe<User>
}

export type AdminCharityContactEmailVerification = {
  __typename?: 'AdminCharityContactEmailVerification'
  domain?: Maybe<Scalars['String']['output']>
  fetchedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  notes?: Maybe<Scalars['String']['output']>
  riskLevel: CharityContactRiskLevelEnum
  riskLevelNotes?: Maybe<Scalars['String']['output']>
  score?: Maybe<Scalars['Int']['output']>
  shouldBlock?: Maybe<Scalars['Boolean']['output']>
  verificationStatus: CharityContactVerificationStatusEnum
}

export type AdminCharityContactInvitation = {
  __typename?: 'AdminCharityContactInvitation'
  addresseeType: CharityContactInvitationAddresseeTypeEnum
  charityContact?: Maybe<AdminCharityContact>
  email: Scalars['String']['output']
  emailVerification?: Maybe<AdminCharityContactEmailVerification>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  invitationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  invitedBy?: Maybe<User>
  lastName?: Maybe<Scalars['String']['output']>
  onboardingMessage?: Maybe<Scalars['String']['output']>
  portalRole: CharityContactEnum
  status: Scalars['String']['output']
}

export type AdminFee = {
  __typename?: 'AdminFee'
  endDate: Scalars['ISO8601Date']['output']
  fee: Scalars['Float']['output']
  feeWaived: Scalars['Boolean']['output']
  hifoDiscount: Scalars['Float']['output']
  monthlyFeeMoney: Money
  salesforceCaseId?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601Date']['output']
}

export type AdminFeeSageJournalEntry = {
  __typename?: 'AdminFeeSageJournalEntry'
  createdAt: Scalars['ISO8601DateTime']['output']
  description: Scalars['String']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  glJournalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  journalEntryType: AdminFeeSageJournalEntryGrouping
  lines: Array<AdminFeeSageJournalEntryLine>
  postingDate: Scalars['ISO8601Date']['output']
  referenceNumber?: Maybe<Scalars['String']['output']>
  sageHref?: Maybe<Scalars['String']['output']>
  sageId?: Maybe<Scalars['String']['output']>
  status: AdminFeeSageJournalEntryStatus
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** AdminFeeSageJournalEntryCollection type */
export type AdminFeeSageJournalEntryCollection = {
  __typename?: 'AdminFeeSageJournalEntryCollection'
  /** A collection of paginated AdminFeeSageJournalEntryCollection */
  collection: Array<AdminFeeSageJournalEntry>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum AdminFeeSageJournalEntryGrouping {
  /** Administrative fees journal entries */
  AdministrativeFees = 'AdministrativeFees',
  /** Chariot approved journal entries */
  ChariotApproved = 'ChariotApproved',
  /** Chariot settled journal entries */
  ChariotSettled = 'ChariotSettled',
  /** Contribution journal entries */
  ContributionJournalEntry = 'ContributionJournalEntry',
  /** Grant journal entries */
  GrantJournalEntry = 'GrantJournalEntry',
  /** Grant processing fees journal entries */
  GrantProcessingFees = 'GrantProcessingFees',
  /** Investment returns journal entries */
  InvestmentReturns = 'InvestmentReturns',
}

export type AdminFeeSageJournalEntryLine = {
  __typename?: 'AdminFeeSageJournalEntryLine'
  caseRecord?: Maybe<CaseRecord>
  caseRecordId?: Maybe<Scalars['String']['output']>
  caseStageSetToClosedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  caseStageSetToMoneyMovementAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  classId?: Maybe<Scalars['String']['output']>
  departmentId?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  documentId?: Maybe<Scalars['String']['output']>
  glAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  locationId?: Maybe<Scalars['String']['output']>
  projectId?: Maybe<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  txnAmount: Money
  txnType: Scalars['String']['output']
}

export enum AdminFeeSageJournalEntryStatus {
  /** Completed */
  Completed = 'Completed',
  /** Error */
  Error = 'Error',
  /** Marking case records as complete */
  MarkingCaseRecordsAsComplete = 'MarkingCaseRecordsAsComplete',
  /** Reviewing */
  Reviewing = 'Reviewing',
  /** Submitted */
  Submitted = 'Submitted',
  /** Submitting */
  Submitting = 'Submitting',
}

export type AdministrativeFee = {
  __typename?: 'AdministrativeFee'
  amount: Money
  createdDate: Scalars['ISO8601Date']['output']
  displayName: Scalars['String']['output']
  feeType: FeeTypeEnum
  id: Scalars['String']['output']
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  relatedGrantId?: Maybe<Scalars['String']['output']>
  status: AdministrativeFeeStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
}

export enum AdministrativeFeeStatus {
  /** Fee closed cancelled */
  FeeClosedCancelled = 'FEE_CLOSED_CANCELLED',
  /** Fee closed completed */
  FeeClosedCompleted = 'FEE_CLOSED_COMPLETED',
  /** Fee in progress */
  FeeInProgress = 'FEE_IN_PROGRESS',
  /** Fee new */
  FeeNew = 'FEE_NEW',
}

export type AdvisedDafAccountAdmin = {
  __typename?: 'AdvisedDafAccountAdmin'
  accessLevel: DafAccessLevelEnum
  /** The ID of the DAF Access Link in object SF */
  dafAccessLinkId: Scalars['String']['output']
  dafAccount: DafAccountAdmin
  hasAccessToMemberApp: Scalars['Boolean']['output']
  needsToResignTcs: Scalars['Boolean']['output']
}

export type Advisor = {
  __typename?: 'Advisor'
  accessLevel?: Maybe<DafAccessLevelEnum>
  contactId: Scalars['String']['output']
  dafAccessLinkId: Scalars['String']['output']
  email?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  invitationId?: Maybe<Scalars['String']['output']>
  needsConfirmation: Scalars['Boolean']['output']
  status: AdvisorStatus
  surname: Scalars['String']['output']
}

export type AdvisorInvitation = {
  __typename?: 'AdvisorInvitation'
  accessLevel: DafAccessLevelEnum
  createdBy: UserPrivate
  id: Scalars['ID']['output']
  legalEntity: LegalEntity
}

export enum AdvisorStatus {
  AwaitingSignUp = 'AwaitingSignUp',
  InvitationExpired = 'InvitationExpired',
  NeedsConfirmation = 'NeedsConfirmation',
  SignedUp = 'SignedUp',
}

export type AmendedPledgeAdmin = {
  __typename?: 'AmendedPledgeAdmin'
  companyName: Scalars['String']['output']
  countersignatureUrl?: Maybe<Scalars['String']['output']>
  countersigned: Scalars['Boolean']['output']
  createdDate: Scalars['ISO8601Date']['output']
  currentPercentage?: Maybe<Scalars['Float']['output']>
  dateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  fullHomeAddress?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  memberSignatureUrl?: Maybe<Scalars['String']['output']>
  originalDateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  originalPercentage?: Maybe<Scalars['Float']['output']>
  shareholdingPercentage?: Maybe<Scalars['Float']['output']>
  signed: Scalars['Boolean']['output']
  surname?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
  valuation?: Maybe<Scalars['BigInt']['output']>
}

/** AmendedPledgeAdminCollection type */
export type AmendedPledgeAdminCollection = {
  __typename?: 'AmendedPledgeAdminCollection'
  /** A collection of paginated AmendedPledgeAdminCollection */
  collection: Array<AmendedPledgeAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum ApprovalStatus {
  Approved = 'APPROVED',
  Endorsed = 'ENDORSED',
  Rejected = 'REJECTED',
}

/** Autogenerated input type of ArchiveTrainingCourse */
export type ArchiveTrainingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  courseId: Scalars['ID']['input']
}

/** Autogenerated return type of ArchiveTrainingCourse. */
export type ArchiveTrainingCoursePayload = {
  __typename?: 'ArchiveTrainingCoursePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: TrainingCourseAdmin
}

/** Autogenerated input type of ArchiveTrainingModule */
export type ArchiveTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of ArchiveTrainingModule. */
export type ArchiveTrainingModulePayload = {
  __typename?: 'ArchiveTrainingModulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

/** Autogenerated input type of ArchiveUser */
export type ArchiveUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  /** Defaults to today */
  leftOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Also record that they've left FP, which offboards them and opens their kit returns. Needs EDIT_EMPLOYEE */
  markEmployeeLeft?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of ArchiveUser. */
export type ArchiveUserPayload = {
  __typename?: 'ArchiveUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type Asset = {
  __typename?: 'Asset'
  /** Every hand-over, newest first */
  assignments: Array<AssetAssignment>
  category: AssetCategoryEnum
  /** Every check, newest first */
  checks: Array<AssetCheck>
  condition?: Maybe<AssetConditionEnum>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentAssignment?: Maybe<AssetAssignment>
  deviceName?: Maybe<Scalars['String']['output']>
  disposalMethod?: Maybe<Scalars['String']['output']>
  disposedOn?: Maybe<Scalars['ISO8601Date']['output']>
  /** Newest first */
  documents: Array<AssetDocument>
  entity?: Maybe<AssetEntityEnum>
  financeAssetRef?: Maybe<Scalars['String']['output']>
  fphNumber: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** The newest Apple Business Manager and RMM check */
  latestChecks: Array<AssetCheck>
  /** Where it is when it isn't with anyone */
  location?: Maybe<AssetLocationEnum>
  manufacturer?: Maybe<Scalars['String']['output']>
  mobileNumber?: Maybe<Scalars['String']['output']>
  modelNumber?: Maybe<Scalars['String']['output']>
  networkProvider?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  operatingSystem?: Maybe<Scalars['String']['output']>
  orderReference?: Maybe<Scalars['String']['output']>
  productName: Scalars['String']['output']
  productType?: Maybe<AssetProductTypeEnum>
  productUrl?: Maybe<Scalars['String']['output']>
  purchasePrice?: Maybe<Money>
  purchasedBy?: Maybe<Employee>
  purchasedOn?: Maybe<Scalars['ISO8601Date']['output']>
  ramGb?: Maybe<Scalars['Int']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  /** Recovery keys, without their values. Replaced ones only when asked */
  secrets: Array<AssetSecret>
  serialNumber?: Maybe<Scalars['String']['output']>
  status: AssetStatusEnum
  supplier?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  warrantyExpiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  warrantyType?: Maybe<Scalars['String']['output']>
}

export type AssetSecretsArgs = {
  includeReplaced?: InputMaybe<Scalars['Boolean']['input']>
}

export type AssetAssignment = {
  __typename?: 'AssetAssignment'
  assignedByName?: Maybe<Scalars['String']['output']>
  /** Blank for assignments imported from Salesforce */
  assignedOn?: Maybe<Scalars['ISO8601Date']['output']>
  employee?: Maybe<Employee>
  /** How it should come back from a leaver. Set with their leaving date */
  expectedReturnMethod?: Maybe<AssetReturnMethodEnum>
  holderName: Scalars['String']['output']
  id: Scalars['ID']['output']
  /** Set when the asset is assigned to an office rather than a person */
  location?: Maybe<AssetLocationEnum>
  notes?: Maybe<Scalars['String']['output']>
  returnCondition?: Maybe<AssetConditionEnum>
  /** Their leaving date, while it's still with them */
  returnDueOn?: Maybe<Scalars['ISO8601Date']['output']>
  returnMethod?: Maybe<AssetReturnMethodEnum>
  returnedByName?: Maybe<Scalars['String']['output']>
  returnedOn?: Maybe<Scalars['ISO8601Date']['output']>
}

export type AssetAttributesInput = {
  category?: InputMaybe<AssetCategoryEnum>
  condition?: InputMaybe<AssetConditionEnum>
  deviceName?: InputMaybe<Scalars['String']['input']>
  entity?: InputMaybe<AssetEntityEnum>
  financeAssetRef?: InputMaybe<Scalars['String']['input']>
  location?: InputMaybe<AssetLocationEnum>
  manufacturer?: InputMaybe<Scalars['String']['input']>
  mobileNumber?: InputMaybe<Scalars['String']['input']>
  modelNumber?: InputMaybe<Scalars['String']['input']>
  networkProvider?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  operatingSystem?: InputMaybe<Scalars['String']['input']>
  orderReference?: InputMaybe<Scalars['String']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
  productType?: InputMaybe<AssetProductTypeEnum>
  productUrl?: InputMaybe<Scalars['String']['input']>
  purchaseCurrency?: InputMaybe<Scalars['String']['input']>
  purchaseValue?: InputMaybe<Scalars['Float']['input']>
  purchasedById?: InputMaybe<Scalars['ID']['input']>
  purchasedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  ramGb?: InputMaybe<Scalars['Int']['input']>
  serialNumber?: InputMaybe<Scalars['String']['input']>
  supplier?: InputMaybe<Scalars['String']['input']>
  warrantyExpiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  warrantyType?: InputMaybe<Scalars['String']['input']>
}

export enum AssetCategoryEnum {
  Furniture = 'FURNITURE',
  ItAccessory = 'IT_ACCESSORY',
  ItEquipment = 'IT_EQUIPMENT',
}

export type AssetCheck = {
  __typename?: 'AssetCheck'
  checkedByName?: Maybe<Scalars['String']['output']>
  checkedOn: Scalars['ISO8601Date']['output']
  checkedVia: AssetCheckViaEnum
  /** The device's name or ID in the source system */
  externalRef?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  result: AssetCheckResultEnum
  source: AssetCheckSourceEnum
}

export enum AssetCheckResultEnum {
  Missing = 'MISSING',
  NotApplicable = 'NOT_APPLICABLE',
  Present = 'PRESENT',
}

export enum AssetCheckSourceEnum {
  AppleBusinessManager = 'APPLE_BUSINESS_MANAGER',
  LighthouseRmm = 'LIGHTHOUSE_RMM',
}

export enum AssetCheckViaEnum {
  Api = 'API',
  DeviceExport = 'DEVICE_EXPORT',
  Manual = 'MANUAL',
}

/** AssetCollection type */
export type AssetCollection = {
  __typename?: 'AssetCollection'
  /** A collection of paginated AssetCollection */
  collection: Array<Asset>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum AssetConditionEnum {
  Fair = 'FAIR',
  Good = 'GOOD',
  LikeNew = 'LIKE_NEW',
  NeedsRepair = 'NEEDS_REPAIR',
  New = 'NEW',
  Unusable = 'UNUSABLE',
}

export enum AssetDeviceCheckFilterEnum {
  /** Apple devices not confirmed in Apple Business Manager */
  AbmNotConfirmed = 'ABM_NOT_CONFIRMED',
  /** laptops in use with no RMM check in the last 90 days */
  CheckDue = 'CHECK_DUE',
  /** laptops in use whose latest LighthouseIT RMM check didn't find them, or that haven't been checked */
  RmmNotConfirmed = 'RMM_NOT_CONFIRMED',
}

export type AssetDeviceCheckSummary = {
  __typename?: 'AssetDeviceCheckSummary'
  /** Apple laptops, desktops, phones and tablets still on the register */
  appleDevices: Scalars['Int']['output']
  appleDevicesInAbm: Scalars['Int']['output']
  computersConfirmedInRmm: Scalars['Int']['output']
  /** no RMM check in the last 90 days */
  computersDueCheck: Scalars['Int']['output']
  computersInUse: Scalars['Int']['output']
}

export type AssetDocument = {
  __typename?: 'AssetDocument'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: AssetDocumentKindEnum
  originalFilename: Scalars['String']['output']
  uploadedByName?: Maybe<Scalars['String']['output']>
  /** Expires after 15 minutes */
  url: Scalars['String']['output']
}

export enum AssetDocumentKindEnum {
  DisposalCertificate = 'DISPOSAL_CERTIFICATE',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  Photo = 'PHOTO',
  Repair = 'REPAIR',
  Warranty = 'WARRANTY',
}

export enum AssetEntityEnum {
  FpInc = 'FP_INC',
  FpLtd = 'FP_LTD',
}

export type AssetLeaver = {
  __typename?: 'AssetLeaver'
  employee: Employee
  items: Array<AssetReturnItem>
  leftOn: Scalars['ISO8601Date']['output']
}

export enum AssetLocationEnum {
  LondonOffice = 'LONDON_OFFICE',
  NewYorkOffice = 'NEW_YORK_OFFICE',
  SanFranciscoOffice = 'SAN_FRANCISCO_OFFICE',
  Storage = 'STORAGE',
}

export type AssetOrderLineInput = {
  category: AssetCategoryEnum
  manufacturer?: InputMaybe<Scalars['String']['input']>
  productName: Scalars['String']['input']
  productType?: InputMaybe<AssetProductTypeEnum>
  quantity: Scalars['Int']['input']
  unitPrice?: InputMaybe<Scalars['Float']['input']>
}

export enum AssetProductTypeEnum {
  Adaptor = 'ADAPTOR',
  Cable = 'CABLE',
  Case = 'CASE',
  Chair = 'CHAIR',
  Charger = 'CHARGER',
  Desk = 'DESK',
  Desktop = 'DESKTOP',
  Footrest = 'FOOTREST',
  Headset = 'HEADSET',
  Keyboard = 'KEYBOARD',
  KeyboardAndMouse = 'KEYBOARD_AND_MOUSE',
  Lamp = 'LAMP',
  Laptop = 'LAPTOP',
  LaptopStand = 'LAPTOP_STAND',
  Monitor = 'MONITOR',
  Mouse = 'MOUSE',
  MousePad = 'MOUSE_PAD',
  Network = 'NETWORK',
  Other = 'OTHER',
  Pen = 'PEN',
  Phone = 'PHONE',
  PowerBank = 'POWER_BANK',
  StandingDeskConverter = 'STANDING_DESK_CONVERTER',
  Storage = 'STORAGE',
  Tablet = 'TABLET',
  UsbHub = 'USB_HUB',
  Webcam = 'WEBCAM',
  WristRest = 'WRIST_REST',
}

export type AssetReturnItem = {
  __typename?: 'AssetReturnItem'
  asset: Asset
  expectedReturnMethod: AssetReturnMethodEnum
  /** The assignment's id */
  id: Scalars['ID']['output']
  returnDueOn: Scalars['ISO8601Date']['output']
  returnMethod?: Maybe<AssetReturnMethodEnum>
  returnedOn?: Maybe<Scalars['ISO8601Date']['output']>
  stage: AssetReturnStageEnum
}

export enum AssetReturnMethodEnum {
  Courier = 'COURIER',
  InOffice = 'IN_OFFICE',
  Kept = 'KEPT',
}

export enum AssetReturnStageEnum {
  /** back and wiped, or moved on */
  Done = 'DONE',
  /** still with the leaver, to be written off on the leaving date */
  Keeping = 'KEEPING',
  /** still with the leaver, expected back */
  Outstanding = 'OUTSTANDING',
  /** back with us, waiting to be wiped */
  ToWipe = 'TO_WIPE',
  /** kept by the leaver */
  WrittenOff = 'WRITTEN_OFF',
}

export type AssetSecret = {
  __typename?: 'AssetSecret'
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  kind: AssetSecretKindEnum
  replacedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** Newest first */
  reveals: Array<AssetSecretReveal>
}

export enum AssetSecretKindEnum {
  BitlockerRecoveryKey = 'BITLOCKER_RECOVERY_KEY',
  FilevaultRecoveryKey = 'FILEVAULT_RECOVERY_KEY',
  FirmwarePassword = 'FIRMWARE_PASSWORD',
  Other = 'OTHER',
}

export type AssetSecretReveal = {
  __typename?: 'AssetSecretReveal'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  reason: Scalars['String']['output']
  revealedByName?: Maybe<Scalars['String']['output']>
}

export enum AssetStatusEnum {
  Assigned = 'ASSIGNED',
  AwaitingReturn = 'AWAITING_RETURN',
  Disposed = 'DISPOSED',
  InRepair = 'IN_REPAIR',
  InStock = 'IN_STOCK',
  Lost = 'LOST',
  OnOrder = 'ON_ORDER',
  Retired = 'RETIRED',
  ReturnedToSupplier = 'RETURNED_TO_SUPPLIER',
  ToWipe = 'TO_WIPE',
}

export enum AssetType {
  Cash = 'CASH',
  Cryptocurrency = 'CRYPTOCURRENCY',
  Other = 'OTHER',
  PrivateSecurities = 'PRIVATE_SECURITIES',
  PublicSecurities = 'PUBLIC_SECURITIES',
  /** @deprecated Use PRIVATE_SECURITIES or PUBLIC_SECURITIES instead. */
  Securities = 'SECURITIES',
}

/** Autogenerated input type of AssignAsset */
export type AssignAssetInput = {
  assetId: Scalars['ID']['input']
  assignedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeId?: InputMaybe<Scalars['ID']['input']>
  /** an office, for shared kit */
  location?: InputMaybe<AssetLocationEnum>
  notes?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of AssignAsset. */
export type AssignAssetPayload = {
  __typename?: 'AssignAssetPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of AssignTrainingModule */
export type AssignTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dueOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Omit to assign everyone the module is for */
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of AssignTrainingModule. */
export type AssignTrainingModulePayload = {
  __typename?: 'AssignTrainingModulePayload'
  assignedCount: Scalars['Int']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

export type AttendeeDetailsChangesInput = {
  accessibilityRequirements?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  consentToIncludeInGuestlist?: InputMaybe<Scalars['Boolean']['input']>
  /** Answers by question key; a blank answer clears it */
  customAnswers?: InputMaybe<Scalars['JSON']['input']>
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>
  dietaryRequirementsOther?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  sourceOfInvitation?: InputMaybe<Scalars['String']['input']>
  sourceOfInvitationOther?: InputMaybe<Scalars['String']['input']>
}

export type AttendeeDetailsInput = {
  accessibilityRequirements?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  consentToIncludeInGuestlist?: InputMaybe<Scalars['Boolean']['input']>
  customAnswers?: InputMaybe<Scalars['JSON']['input']>
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>
  dietaryRequirementsOther?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  jobTitle?: InputMaybe<Scalars['String']['input']>
  lastName: Scalars['String']['input']
  sourceOfInvitation?: InputMaybe<Scalars['String']['input']>
  sourceOfInvitationOther?: InputMaybe<Scalars['String']['input']>
}

export type BalanceReconciliationParameters = {
  __typename?: 'BalanceReconciliationParameters'
  dateFrom?: Maybe<Scalars['ISO8601Date']['output']>
  dateTo?: Maybe<Scalars['ISO8601Date']['output']>
  exceptionThresholdMinorUnits: Scalars['Int']['output']
  fundCategories: Array<FundCategory>
  legalEntity: ReconciliationLegalEntity
}

export type BalanceReconciliationResult = {
  __typename?: 'BalanceReconciliationResult'
  lines: Array<GiftAccountBalance>
  parameters: BalanceReconciliationParameters
  runAt: Scalars['ISO8601DateTime']['output']
  summary: Array<BalanceReconciliationSummary>
  unmapped: Array<UnmappedBalance>
}

export type BalanceReconciliationSummary = {
  __typename?: 'BalanceReconciliationSummary'
  currency: Scalars['String']['output']
  difference: Money
  exceptionCount: Scalars['Int']['output']
  lineCount: Scalars['Int']['output']
  sageTotal: Money
  salesforceTotal: Money
  unmappedCount: Scalars['Int']['output']
  withinToleranceCount: Scalars['Int']['output']
}

export type BalanceReconciliationTransactions = {
  __typename?: 'BalanceReconciliationTransactions'
  sageLines: Array<ReconciliationSageTransaction>
  salesforceLines: Array<ReconciliationSalesforceTransaction>
}

export enum BalanceTypeEnum {
  All = 'All',
  Fees = 'Fees',
  Illiquid = 'Illiquid',
  Incoming = 'Incoming',
  InvestmentActivity = 'InvestmentActivity',
  Liquid = 'Liquid',
  Outgoing = 'Outgoing',
  PendingFees = 'PendingFees',
  PendingOutgoingGrants = 'PendingOutgoingGrants',
}

export enum BankAccountChecklistItemKeyEnum {
  AccountHolderMismatch = 'ACCOUNT_HOLDER_MISMATCH',
  AccountNameMatchesLegal = 'ACCOUNT_NAME_MATCHES_LEGAL',
  BankingDocumentsOdd = 'BANKING_DOCUMENTS_ODD',
  BankDetailsMatchWire = 'BANK_DETAILS_MATCH_WIRE',
  BankDifferentCountry = 'BANK_DIFFERENT_COUNTRY',
  DisplayNameSpoofing = 'DISPLAY_NAME_SPOOFING',
  EmailDomainMismatch = 'EMAIL_DOMAIN_MISMATCH',
  InconsistentGranteeName = 'INCONSISTENT_GRANTEE_NAME',
  LastMinuteChanges = 'LAST_MINUTE_CHANGES',
  ProofTypeAcceptable = 'PROOF_TYPE_ACCEPTABLE',
  SpellingGrammarErrors = 'SPELLING_GRAMMAR_ERRORS',
  UnusualBankNames = 'UNUSUAL_BANK_NAMES',
  UrgencyLanguage = 'URGENCY_LANGUAGE',
}

export enum BankAccountChecklistItemStatusEnum {
  Completed = 'completed',
  Flagged = 'flagged',
  NotApplicable = 'not_applicable',
  Pending = 'pending',
}

export enum BooleanOperatorEnum {
  False = 'FALSE',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  True = 'TRUE',
}

/** Autogenerated input type of CalculateInvestmentReturns */
export type CalculateInvestmentReturnsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CalculateInvestmentReturns. */
export type CalculateInvestmentReturnsPayload = {
  __typename?: 'CalculateInvestmentReturnsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type CalculationData = {
  __typename?: 'CalculationData'
  dailyBalances: Array<DailyBalance>
  tieredFees: Array<TieredFee>
}

/** Autogenerated input type of CancelCharityContactInvite */
export type CancelCharityContactInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  invitationId: Scalars['ID']['input']
}

/** Autogenerated return type of CancelCharityContactInvite. */
export type CancelCharityContactInvitePayload = {
  __typename?: 'CancelCharityContactInvitePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CancelGrant */
export type CancelGrantInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  reason: Scalars['String']['input']
}

/** Autogenerated return type of CancelGrant. */
export type CancelGrantPayload = {
  __typename?: 'CancelGrantPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  grantCaseRecord: GrantCaseRecord
}

export type CaseProcessingRecord = {
  __typename?: 'CaseProcessingRecord'
  caseClosed?: Maybe<Scalars['ISO8601DateTime']['output']>
  caseId: Scalars['ID']['output']
  caseNumber: Scalars['String']['output']
  caseOpened: Scalars['ISO8601DateTime']['output']
  caseOwner: Scalars['String']['output']
  caseRecordType: Scalars['String']['output']
  grantComplexity?: Maybe<Scalars['String']['output']>
  legalEntity?: Maybe<Scalars['String']['output']>
  recipientName?: Maybe<Scalars['String']['output']>
  recipientType?: Maybe<Scalars['String']['output']>
  stages: Array<CaseProcessingStage>
  totalTimeTakenInMinutes: Scalars['Int']['output']
  totalTimeTakenInMinutesIncludingNonWorkingTime: Scalars['Int']['output']
  transactionAmount?: Maybe<Money>
}

export type CaseProcessingStage = {
  __typename?: 'CaseProcessingStage'
  editedBy: Scalars['String']['output']
  editedDate: Scalars['ISO8601DateTime']['output']
  newValue: Scalars['String']['output']
  oldValue: Scalars['String']['output']
  stageId: Scalars['ID']['output']
  timeTakenInMinutes: Scalars['Int']['output']
  timeTakenInMinutesIncludingNonWorkingTime: Scalars['Int']['output']
}

export type CaseRecord = {
  __typename?: 'CaseRecord'
  adjustmentType?: Maybe<Scalars['String']['output']>
  attachments: Array<CaseRecordAttachment>
  caseNotes: Array<Note>
  caseNumber: Scalars['String']['output']
  caseStage: CaseStage
  caseType: CaseType
  contact?: Maybe<Contact>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy?: Maybe<Employee>
  description: Scalars['String']['output']
  displayName: Scalars['String']['output']
  editHistory: Array<EditHistory>
  endUserCharity?: Maybe<Charity>
  fxAtTimeOfTransaction?: Maybe<Scalars['Float']['output']>
  grantCaseRecord?: Maybe<GrantCaseRecord>
  grantUseRestrictions?: Maybe<Scalars['String']['output']>
  hasSyncError: Scalars['Boolean']['output']
  highImpactAtTimeOfDeployment: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  investmentReturnsType?: Maybe<Scalars['String']['output']>
  lastModifiedBy?: Maybe<Employee>
  legallyDonatingEntity?: Maybe<Contact>
  notes?: Maybe<Scalars['String']['output']>
  owner?: Maybe<Employee>
  recipientAmount?: Maybe<Scalars['Float']['output']>
  recipientAmountForRollUps: Money
  recipientCharity?: Maybe<Charity>
  recipientCompany?: Maybe<CompanyAdmin>
  recipientCurrency?: Maybe<Scalars['String']['output']>
  recipientFundAccount?: Maybe<FundAccount>
  recipientName?: Maybe<Scalars['String']['output']>
  recipientType?: Maybe<SenderRecipientTypeEnum>
  sageJournalEntries?: Maybe<Array<SageJournalEntry>>
  salesforceId?: Maybe<Scalars['String']['output']>
  senderAmount: Money
  senderCharity?: Maybe<Charity>
  senderCompany?: Maybe<CompanyAdmin>
  senderContact?: Maybe<Contact>
  senderFundAccount?: Maybe<FundAccount>
  senderName?: Maybe<Scalars['String']['output']>
  senderType?: Maybe<SenderRecipientTypeEnum>
  shareEmailWithCharity?: Maybe<Scalars['Boolean']['output']>
  shareNameWithCharity?: Maybe<Scalars['Boolean']['output']>
  status: Scalars['String']['output']
  submittedBy?: Maybe<Contact>
  syncErrorMessage?: Maybe<Scalars['String']['output']>
  transactionDate?: Maybe<Scalars['ISO8601Date']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type CaseRecordAttachment = {
  __typename?: 'CaseRecordAttachment'
  createdAt: Scalars['ISO8601DateTime']['output']
  downloadUrl?: Maybe<Scalars['String']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

/** CaseRecordCollection type */
export type CaseRecordCollection = {
  __typename?: 'CaseRecordCollection'
  /** A collection of paginated CaseRecordCollection */
  collection: Array<CaseRecord>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type CaseRecordFilterConditionInput = {
  field: CaseRecordFilterFieldEnum
  operator: FilterOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export enum CaseRecordFilterFieldEnum {
  CaseNumber = 'CASE_NUMBER',
  CaseStage = 'CASE_STAGE',
  CaseType = 'CASE_TYPE',
  CommunityManager = 'COMMUNITY_MANAGER',
  Description = 'DESCRIPTION',
  Owner = 'OWNER',
  RecipientCharity = 'RECIPIENT_CHARITY',
  RecipientFundAccount = 'RECIPIENT_FUND_ACCOUNT',
  SenderFundAccount = 'SENDER_FUND_ACCOUNT',
  Status = 'STATUS',
  SyncErrorMessage = 'SYNC_ERROR_MESSAGE',
  TransactionDate = 'TRANSACTION_DATE',
}

export type CaseRecordFilterGroupInput = {
  AND?: InputMaybe<Array<CaseRecordFilterGroupInput>>
  OR?: InputMaybe<Array<CaseRecordFilterGroupInput>>
  conditions?: InputMaybe<Array<CaseRecordFilterConditionInput>>
}

export type CaseStage = {
  __typename?: 'CaseStage'
  caseRecords?: Maybe<Array<CaseRecord>>
  id: Scalars['ID']['output']
  includeInBalances: Scalars['Boolean']['output']
  includeInStatements: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
  transactionLockedIn: Scalars['Boolean']['output']
}

export enum CaseStatus {
  /** created */
  Created = 'created',
  /** error */
  Error = 'error',
  /** not_applicable */
  NotApplicable = 'not_applicable',
  /** queued */
  Queued = 'queued',
  /** reviewing */
  Reviewing = 'reviewing',
}

export type CaseType = {
  __typename?: 'CaseType'
  caseRecords?: Maybe<Array<CaseRecord>>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export enum CashPaymentTypeEnum {
  Plaid = 'PLAID',
  PlaidTransfer = 'PLAID_TRANSFER',
  WireTransfer = 'WIRE_TRANSFER',
}

/** Autogenerated input type of ChangeAssetStatus */
export type ChangeAssetStatusInput = {
  assetId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Required when disposing */
  disposalMethod?: InputMaybe<Scalars['String']['input']>
  /** Defaults to today when disposing */
  disposedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  location?: InputMaybe<AssetLocationEnum>
  status: AssetStatusEnum
}

/** Autogenerated return type of ChangeAssetStatus. */
export type ChangeAssetStatusPayload = {
  __typename?: 'ChangeAssetStatusPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ChangeDataUploadRowDecision */
export type ChangeDataUploadRowDecisionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  decision: DataUploadRowDecision
  id: Scalars['ID']['input']
}

/** Autogenerated return type of ChangeDataUploadRowDecision. */
export type ChangeDataUploadRowDecisionPayload = {
  __typename?: 'ChangeDataUploadRowDecisionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ChariotDisbursement = {
  __typename?: 'ChariotDisbursement'
  chariotId: Scalars['String']['output']
  id: Scalars['ID']['output']
  status: Scalars['String']['output']
}

export type Charity = {
  __typename?: 'Charity'
  candidProfileUrl?: Maybe<Scalars['String']['output']>
  chariotDisbursements: Array<ChariotDisbursement>
  charityBankAccounts: Array<AdminCharityBankAccount>
  charityCompanyNumber?: Maybe<Scalars['String']['output']>
  charityHqCountry?: Maybe<Scalars['String']['output']>
  charityStatus?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  fiscalYearEnd?: Maybe<Scalars['ISO8601Date']['output']>
  grantsFromFpDafs: Array<CaseRecord>
  grantsFromFpFunds: Array<CaseRecord>
  id: Scalars['ID']['output']
  legacyDueDiligences: Array<LegacyDueDiligence>
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  usDueDiligences: Array<UsDueDiligence>
  /** Verified bank accounts for this charity, most recently verified first (verifiedAt descending, then createdAt descending). */
  verifiedBankAccounts: Array<AdminCharityBankAccount>
  website?: Maybe<Scalars['String']['output']>
}

export type CharityCharityBankAccountsArgs = {
  status?: InputMaybe<Array<InputMaybe<CharityBankAccountStatusEnum>>>
}

export enum CharityBankAccountProofDocumentTypeEnum {
  ProofOfOwnership = 'proof_of_ownership',
  TransferDetails = 'transfer_details',
}

export enum CharityBankAccountStatusEnum {
  Draft = 'draft',
  NeedsReview = 'needs_review',
  ReadyForVerificationCall = 'ready_for_verification_call',
  Rejected = 'rejected',
  Superseded = 'superseded',
  Verified = 'verified',
}

export type CharityCategoryAdmin = {
  __typename?: 'CharityCategoryAdmin'
  backgroundColour: Scalars['String']['output']
  causeAreas: Array<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  exampleHifo?: Maybe<HifoAdmin>
  excludeFromHifoSelection: Scalars['Boolean']['output']
  icon: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** CharityCategoryAdminCollection type */
export type CharityCategoryAdminCollection = {
  __typename?: 'CharityCategoryAdminCollection'
  /** A collection of paginated CharityCategoryAdminCollection */
  collection: Array<CharityCategoryAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type CharityCategoryChangeInput = {
  backgroundColour: Scalars['String']['input']
  causeAreas: Array<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  exampleHifoId?: InputMaybe<Scalars['ID']['input']>
  excludeFromHifoSelection: Scalars['Boolean']['input']
  icon: Scalars['String']['input']
  name: Scalars['String']['input']
}

/** CharityCollection type */
export type CharityCollection = {
  __typename?: 'CharityCollection'
  /** A collection of paginated CharityCollection */
  collection: Array<Charity>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum CharityContactEnum {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export enum CharityContactInvitationAddresseeTypeEnum {
  GeneralInbox = 'GENERAL_INBOX',
  NamedContact = 'NAMED_CONTACT',
}

export enum CharityContactInvitationListStatusEnum {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
}

export enum CharityContactPortalEnum {
  Accepted = 'ACCEPTED',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
}

export enum CharityContactRiskLevelEnum {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export enum CharityContactVerificationStatusEnum {
  Completed = 'Completed',
  Error = 'Error',
  Pending = 'Pending',
}

export enum CharityFilterFieldEnum {
  CharityCompanyNumber = 'CHARITY_COMPANY_NUMBER',
  CharityHqCountry = 'CHARITY_HQ_COUNTRY',
  Name = 'NAME',
  Status = 'STATUS',
}

export type CharityStringFilterInput = {
  field: CharityFilterFieldEnum
  operator: StringOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of CheckInAttendee */
export type CheckInAttendeeInput = {
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CheckInAttendee. */
export type CheckInAttendeePayload = {
  __typename?: 'CheckInAttendeePayload'
  alreadyCheckedIn: Scalars['Boolean']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  guest: EventCheckInGuest
}

/** Autogenerated input type of CloseCheckIn */
export type CloseCheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of CloseCheckIn. */
export type CloseCheckInPayload = {
  __typename?: 'CloseCheckInPayload'
  checkInClosedAt: Scalars['ISO8601DateTime']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  markedNoShowCount: Scalars['Int']['output']
}

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata'
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output']
  /** The number of items per page */
  limitValue: Scalars['Int']['output']
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output']
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output']
}

export type CommunityManager = {
  __typename?: 'CommunityManager'
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  surname?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  welcomeCallLink?: Maybe<Scalars['String']['output']>
}

export type Company = {
  __typename?: 'Company'
  id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  number?: Maybe<Scalars['String']['output']>
}

export type CompanyAdmin = {
  __typename?: 'CompanyAdmin'
  companyType: CompanyRecord
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

/** CompanyAdminCollection type */
export type CompanyAdminCollection = {
  __typename?: 'CompanyAdminCollection'
  /** A collection of paginated CompanyAdminCollection */
  collection: Array<CompanyAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum CompanyFilterFieldEnum {
  CompanyType = 'COMPANY_TYPE',
  Name = 'NAME',
}

export type CompanyInput = {
  name: Scalars['String']['input']
  number?: InputMaybe<Scalars['String']['input']>
}

export type CompanyRecord = {
  __typename?: 'CompanyRecord'
  companies: Array<CompanyAdmin>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export type CompanyStringFilterInput = {
  field: CompanyFilterFieldEnum
  operator: StringOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of CompleteAdminFeeSageJournalEntry */
export type CompleteAdminFeeSageJournalEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of CompleteAdminFeeSageJournalEntry. */
export type CompleteAdminFeeSageJournalEntryPayload = {
  __typename?: 'CompleteAdminFeeSageJournalEntryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated input type of CompleteTrainingModule */
export type CompleteTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of CompleteTrainingModule. */
export type CompleteTrainingModulePayload = {
  __typename?: 'CompleteTrainingModulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: StaffTrainingModule
}

export type Contact = {
  __typename?: 'Contact'
  advisor?: Maybe<Employee>
  advisoryJourney: Array<Scalars['String']['output']>
  advisoryNotes?: Maybe<Scalars['String']['output']>
  aiSummary?: Maybe<Scalars['String']['output']>
  alternativeEmail?: Maybe<Scalars['String']['output']>
  beneficiaries: Array<Scalars['String']['output']>
  canReceiveEventInvites: Scalars['Boolean']['output']
  causeAreaGroups: Array<Scalars['String']['output']>
  causeAreas: Array<Scalars['String']['output']>
  communityManager?: Maybe<Employee>
  communityNextSteps?: Maybe<Scalars['String']['output']>
  connectedOnLinkedInWithDavid?: Maybe<Scalars['Boolean']['output']>
  contactType: ContactRecord
  createdAt: Scalars['ISO8601DateTime']['output']
  deploymentNotes?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  estimatedNetWorthUsd: Money
  eventInternalSpeakerNotes?: Maybe<Scalars['String']['output']>
  eventLocationsOfInterest: Array<Scalars['String']['output']>
  eventNotes?: Maybe<Scalars['String']['output']>
  eventSpeakerBiography?: Maybe<Scalars['String']['output']>
  eventSpeakerStatus?: Maybe<Scalars['String']['output']>
  familyNotes?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  firstPledgeDateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  futurePledgeValue: Money
  gender?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  influencedHifoGrants: Money
  initialCloser?: Maybe<Employee>
  involvement: Array<Scalars['String']['output']>
  involvementNotes?: Maybe<Scalars['String']['output']>
  isConfidential: Scalars['Boolean']['output']
  isCurrentDonor: Scalars['Boolean']['output']
  isMember?: Maybe<Scalars['Boolean']['output']>
  isMembersPartnerOrSpouse: Scalars['Boolean']['output']
  isPledgeVenturesLp: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  linkedInProfile?: Maybe<Scalars['String']['output']>
  liquidityToDate: Money
  mailingCity?: Maybe<Scalars['String']['output']>
  mailingCountry?: Maybe<Scalars['String']['output']>
  mailingPostalCode?: Maybe<Scalars['String']['output']>
  mailingState?: Maybe<Scalars['String']['output']>
  mailingStreet?: Maybe<Scalars['String']['output']>
  mainRole?: Maybe<Scalars['String']['output']>
  memberOffBoarded?: Maybe<Scalars['Boolean']['output']>
  memberValueScore?: Maybe<Scalars['Float']['output']>
  memberValueScoreTier?: Maybe<Scalars['String']['output']>
  membershipJoinDate?: Maybe<Scalars['ISO8601Date']['output']>
  membershipOverride?: Maybe<Scalars['String']['output']>
  moneyDueToCharitableSector: Money
  moneyGiftedToCharitableSector: Money
  motivation: Array<Scalars['String']['output']>
  motivationNotes?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Scalars['String']['output']>
  optedOutOfCommunityEvents: Scalars['Boolean']['output']
  optedOutOfSummerRetreats: Scalars['Boolean']['output']
  optedOutOfWinterRetreats: Scalars['Boolean']['output']
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  preferredMethodsOfCommunication: Array<Scalars['String']['output']>
  responsivenessDateLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>
  responsivenessDetails?: Maybe<Scalars['String']['output']>
  responsivenessNotes?: Maybe<Scalars['String']['output']>
  responsivenessStatus?: Maybe<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  singlePointOfContact?: Maybe<Employee>
  socialThinkingNotes?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  sourceType?: Maybe<Scalars['String']['output']>
  testRecord: Scalars['Boolean']['output']
  title?: Maybe<Scalars['String']['output']>
  totalGrants: Money
  totalPledgeValue: Money
  typeOfStewardship?: Maybe<Scalars['String']['output']>
  unrecordedLiquidity: Money
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** ContactCollection type */
export type ContactCollection = {
  __typename?: 'ContactCollection'
  /** A collection of paginated ContactCollection */
  collection: Array<Contact>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum ContactFilterFieldEnum {
  ContactType = 'CONTACT_TYPE',
  Email = 'EMAIL',
  Name = 'NAME',
}

export type ContactRecord = {
  __typename?: 'ContactRecord'
  contacts: Array<Contact>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export type ContactStringFilterInput = {
  field: ContactFilterFieldEnum
  operator: StringOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export type Contract = {
  __typename?: 'Contract'
  autoRenews: Scalars['Boolean']['output']
  billingFrequency?: Maybe<Scalars['String']['output']>
  /** Statements of work, order forms and the like made under this one */
  childContracts: Array<Contract>
  conflictsConfirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  conflictsConfirmedByName?: Maybe<Scalars['String']['output']>
  conflictsDetails?: Maybe<Scalars['String']['output']>
  conflictsStatus?: Maybe<ContractConflictsStatusEnum>
  contractType: ContractTypeEnum
  counterpartyEntityType?: Maybe<Scalars['String']['output']>
  counterpartyJurisdiction?: Maybe<Scalars['String']['output']>
  /** Only blank on a draft */
  counterpartyLegalName?: Maybe<Scalars['String']['output']>
  counterpartyRegistrationNumber?: Maybe<Scalars['String']['output']>
  counterpartySignatoryName?: Maybe<Scalars['String']['output']>
  counterpartySignatoryRole?: Maybe<Scalars['String']['output']>
  counterpartyWorkingName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByName?: Maybe<Scalars['String']['output']>
  /** The notice deadline, or the expiry date when there isn't one */
  deadlineOn?: Maybe<Scalars['ISO8601Date']['output']>
  disposalMethod?: Maybe<Scalars['String']['output']>
  disposedOn?: Maybe<Scalars['ISO8601Date']['output']>
  disputeResolution?: Maybe<Scalars['String']['output']>
  /** The main agreement first, then supporting documents, newest first */
  documents: Array<ContractDocument>
  effectiveOn?: Maybe<Scalars['ISO8601Date']['output']>
  executedOn?: Maybe<Scalars['ISO8601Date']['output']>
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  fpSignatoryName?: Maybe<Scalars['String']['output']>
  fpSignatoryRole?: Maybe<Scalars['String']['output']>
  governingLaw?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  ipOwnership?: Maybe<Scalars['String']['output']>
  /** When the current term started, if it renewed automatically */
  lastRenewedOn?: Maybe<Scalars['ISO8601Date']['output']>
  /** The FP entity that is party to it */
  legalEntity?: Maybe<LegalEntityAdmin>
  liabilityCap?: Maybe<Scalars['String']['output']>
  /** Key terms a person has marked as not applicable */
  notApplicableFields: Array<ContractAnswerableFieldEnum>
  notes?: Maybe<Scalars['String']['output']>
  noticeByOn?: Maybe<Scalars['ISO8601Date']['output']>
  /** Set by hand rather than worked out from the expiry date and notice period */
  noticeByOverridden: Scalars['Boolean']['output']
  noticeMethod?: Maybe<Scalars['String']['output']>
  noticePeriodAmount?: Maybe<Scalars['Int']['output']>
  noticePeriodUnit?: Maybe<ContractNoticePeriodUnitEnum>
  otherRequirements?: Maybe<Scalars['String']['output']>
  owner?: Maybe<Employee>
  /** The owner no longer works at FP */
  ownerLeft: Scalars['Boolean']['output']
  parentContract?: Maybe<Contract>
  paymentTerms?: Maybe<Scalars['String']['output']>
  personalDataDetails?: Maybe<Scalars['String']['output']>
  priceIncreases?: Maybe<Scalars['String']['output']>
  processesPersonalData?: Maybe<Scalars['Boolean']['output']>
  /** What it's for */
  purpose?: Maybe<ContractPurposeEnum>
  /** Reminders sent or tried, newest first */
  reminders: Array<ContractReminder>
  renewalDecision?: Maybe<ContractRenewalDecisionEnum>
  renewalDecisionByName?: Maybe<Scalars['String']['output']>
  renewalDecisionOn?: Maybe<Scalars['ISO8601Date']['output']>
  renewalTermMonths?: Maybe<Scalars['Int']['output']>
  retainUntilOn?: Maybe<Scalars['ISO8601Date']['output']>
  retentionRequirements?: Maybe<Scalars['String']['output']>
  status: ContractStatusEnum
  team?: Maybe<Team>
  terminatedOn?: Maybe<Scalars['ISO8601Date']['output']>
  terminationForConvenience?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** When the remaining reminders for the current deadline will go out */
  upcomingReminderDates: Array<Scalars['ISO8601Date']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  value?: Maybe<Money>
  valuePeriod?: Maybe<ContractValuePeriodEnum>
}

export enum ContractAnswerableFieldEnum {
  BillingFrequency = 'BILLING_FREQUENCY',
  CounterpartyEntityType = 'COUNTERPARTY_ENTITY_TYPE',
  CounterpartyJurisdiction = 'COUNTERPARTY_JURISDICTION',
  CounterpartyRegistrationNumber = 'COUNTERPARTY_REGISTRATION_NUMBER',
  CounterpartySignatoryName = 'COUNTERPARTY_SIGNATORY_NAME',
  CounterpartySignatoryRole = 'COUNTERPARTY_SIGNATORY_ROLE',
  DisputeResolution = 'DISPUTE_RESOLUTION',
  EffectiveOn = 'EFFECTIVE_ON',
  ExecutedOn = 'EXECUTED_ON',
  ExpiresOn = 'EXPIRES_ON',
  FpSignatoryName = 'FP_SIGNATORY_NAME',
  FpSignatoryRole = 'FP_SIGNATORY_ROLE',
  GoverningLaw = 'GOVERNING_LAW',
  IpOwnership = 'IP_OWNERSHIP',
  LiabilityCap = 'LIABILITY_CAP',
  NoticeMethod = 'NOTICE_METHOD',
  NoticePeriodAmount = 'NOTICE_PERIOD_AMOUNT',
  OtherRequirements = 'OTHER_REQUIREMENTS',
  PaymentTerms = 'PAYMENT_TERMS',
  PersonalDataDetails = 'PERSONAL_DATA_DETAILS',
  PriceIncreases = 'PRICE_INCREASES',
  ProcessesPersonalData = 'PROCESSES_PERSONAL_DATA',
  Purpose = 'PURPOSE',
  RetentionRequirements = 'RETENTION_REQUIREMENTS',
  TerminationForConvenience = 'TERMINATION_FOR_CONVENIENCE',
  Value = 'VALUE',
}

export enum ContractAttentionEnum {
  /** Notice deadline, or expiry when there's no notice deadline, in the next 30 days with nothing decided */
  DeadlineWithin_30Days = 'DEADLINE_WITHIN_30_DAYS',
  /** As above, in the next 90 days */
  DeadlineWithin_90Days = 'DEADLINE_WITHIN_90_DAYS',
  /** Saved as a draft and waiting for review */
  Draft = 'DRAFT',
  /** The owner no longer works at FP */
  OwnerLeft = 'OWNER_LEFT',
}

export type ContractAttributesInput = {
  autoRenews?: InputMaybe<Scalars['Boolean']['input']>
  billingFrequency?: InputMaybe<Scalars['String']['input']>
  conflictsDetails?: InputMaybe<Scalars['String']['input']>
  conflictsStatus?: InputMaybe<ContractConflictsStatusEnum>
  contractType?: InputMaybe<ContractTypeEnum>
  counterpartyEntityType?: InputMaybe<Scalars['String']['input']>
  counterpartyJurisdiction?: InputMaybe<Scalars['String']['input']>
  counterpartyLegalName?: InputMaybe<Scalars['String']['input']>
  counterpartyRegistrationNumber?: InputMaybe<Scalars['String']['input']>
  counterpartySignatoryName?: InputMaybe<Scalars['String']['input']>
  counterpartySignatoryRole?: InputMaybe<Scalars['String']['input']>
  counterpartyWorkingName?: InputMaybe<Scalars['String']['input']>
  disposalMethod?: InputMaybe<Scalars['String']['input']>
  disposedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  disputeResolution?: InputMaybe<Scalars['String']['input']>
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  executedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  expiresOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  fpSignatoryName?: InputMaybe<Scalars['String']['input']>
  fpSignatoryRole?: InputMaybe<Scalars['String']['input']>
  governingLaw?: InputMaybe<Scalars['String']['input']>
  ipOwnership?: InputMaybe<Scalars['String']['input']>
  /** The FP entity that is party to it */
  legalEntityId?: InputMaybe<Scalars['ID']['input']>
  liabilityCap?: InputMaybe<Scalars['String']['input']>
  notApplicableFields?: InputMaybe<Array<ContractAnswerableFieldEnum>>
  notes?: InputMaybe<Scalars['String']['input']>
  /** Only kept when noticeByOverridden is true */
  noticeByOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  noticeByOverridden?: InputMaybe<Scalars['Boolean']['input']>
  noticeMethod?: InputMaybe<Scalars['String']['input']>
  noticePeriodAmount?: InputMaybe<Scalars['Int']['input']>
  noticePeriodUnit?: InputMaybe<ContractNoticePeriodUnitEnum>
  otherRequirements?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  parentContractId?: InputMaybe<Scalars['ID']['input']>
  paymentTerms?: InputMaybe<Scalars['String']['input']>
  personalDataDetails?: InputMaybe<Scalars['String']['input']>
  priceIncreases?: InputMaybe<Scalars['String']['input']>
  processesPersonalData?: InputMaybe<Scalars['Boolean']['input']>
  purpose?: InputMaybe<ContractPurposeEnum>
  renewalTermMonths?: InputMaybe<Scalars['Int']['input']>
  retainUntilOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  retentionRequirements?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['ID']['input']>
  terminationForConvenience?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Float']['input']>
  valueCurrency?: InputMaybe<Scalars['String']['input']>
  valuePeriod?: InputMaybe<ContractValuePeriodEnum>
}

/** ContractCollection type */
export type ContractCollection = {
  __typename?: 'ContractCollection'
  /** A collection of paginated ContractCollection */
  collection: Array<Contract>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum ContractConflictsStatusEnum {
  Declared = 'DECLARED',
  NoneKnown = 'NONE_KNOWN',
}

export type ContractDocument = {
  __typename?: 'ContractDocument'
  createdAt: Scalars['ISO8601DateTime']['output']
  datedOn?: Maybe<Scalars['ISO8601Date']['output']>
  extractedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  extractionError?: Maybe<Scalars['String']['output']>
  /** Blank when reading key terms isn't set up */
  extractionStatus?: Maybe<ContractExtractionStatusEnum>
  id: Scalars['ID']['output']
  kind: ContractDocumentKindEnum
  originalFilename: Scalars['String']['output']
  pageCount?: Maybe<Scalars['Int']['output']>
  /** Other documents it relies on but doesn't contain, to upload too */
  referencedDocuments: Array<ContractReferencedDocument>
  signed: Scalars['Boolean']['output']
  /** Key terms read from the document */
  suggestions: Array<ContractKeyTermSuggestion>
  title?: Maybe<Scalars['String']['output']>
  uploadedByName?: Maybe<Scalars['String']['output']>
  /** Expires after 15 minutes */
  url: Scalars['String']['output']
}

export enum ContractDocumentKindEnum {
  Agreement = 'AGREEMENT',
  Amendment = 'AMENDMENT',
  Dpa = 'DPA',
  Exhibit = 'EXHIBIT',
  Notice = 'NOTICE',
  OrderForm = 'ORDER_FORM',
  Other = 'OTHER',
  Schedule = 'SCHEDULE',
  SideLetter = 'SIDE_LETTER',
  StatementOfWork = 'STATEMENT_OF_WORK',
}

export type ContractEntityCount = {
  __typename?: 'ContractEntityCount'
  count: Scalars['Int']['output']
  /** Blank for contracts with no entity yet */
  legalEntity?: Maybe<LegalEntityAdmin>
}

export enum ContractExtractionStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Running = 'RUNNING',
  Unreadable = 'UNREADABLE',
}

export type ContractKeyTermSuggestion = {
  __typename?: 'ContractKeyTermSuggestion'
  /** The clause, section or schedule the quote is in, as numbered in the document */
  clause?: Maybe<Scalars['String']['output']>
  /** Worked out from another term, such as an expiry date from the term length */
  derived: Scalars['Boolean']['output']
  /** The ContractAttributesInput field it's for, such as expiresOn */
  field: Scalars['String']['output']
  page?: Maybe<Scalars['Int']['output']>
  /** The passage it was read from */
  quote?: Maybe<Scalars['String']['output']>
  /** Dates as YYYY-MM-DD, numbers as digits, booleans as true or false, enums as their GraphQL value, the FP entity as its id */
  value: Scalars['String']['output']
  /** The quote was found in the document's text */
  verified: Scalars['Boolean']['output']
}

export enum ContractNoticePeriodUnitEnum {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
}

export enum ContractPurposeEnum {
  Events = 'EVENTS',
  Facilities = 'FACILITIES',
  FinancialServices = 'FINANCIAL_SERVICES',
  HrServices = 'HR_SERVICES',
  Marketing = 'MARKETING',
  Other = 'OTHER',
  Technology = 'TECHNOLOGY',
}

export type ContractReferencedDocument = {
  __typename?: 'ContractReferencedDocument'
  page?: Maybe<Scalars['Int']['output']>
  quote?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** The quote was found in the document's text */
  verified: Scalars['Boolean']['output']
}

export type ContractReminder = {
  __typename?: 'ContractReminder'
  createdAt: Scalars['ISO8601DateTime']['output']
  daysBefore: Scalars['Int']['output']
  id: Scalars['ID']['output']
  kind: ContractReminderKindEnum
  /** The owner, or the contracts channel */
  recipientName: Scalars['String']['output']
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  skipReason?: Maybe<Scalars['String']['output']>
  status: ContractReminderStatusEnum
  /** The deadline it was counting down to */
  targetOn: Scalars['ISO8601Date']['output']
}

export enum ContractReminderKindEnum {
  Expiry = 'EXPIRY',
  NoticeDeadline = 'NOTICE_DEADLINE',
}

export enum ContractReminderStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
}

export enum ContractRenewalDecisionEnum {
  NoticeGiven = 'NOTICE_GIVEN',
  Renewing = 'RENEWING',
}

export enum ContractStatusEnum {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Ended = 'ENDED',
  Terminated = 'TERMINATED',
}

export type ContractSummary = {
  __typename?: 'ContractSummary'
  deadlinesWithin30Days: Scalars['Int']['output']
  deadlinesWithin31To90Days: Scalars['Int']['output']
  drafts: Scalars['Int']['output']
  /** Draft and active contracts per FP entity, including ones with no entity yet */
  liveByEntity: Array<ContractEntityCount>
  ownerLeft: Scalars['Int']['output']
}

export enum ContractTypeEnum {
  DataProcessing = 'DATA_PROCESSING',
  Nda = 'NDA',
  Other = 'OTHER',
  ProfessionalEngagement = 'PROFESSIONAL_ENGAGEMENT',
  Property = 'PROPERTY',
  Software = 'SOFTWARE',
  SpeakerEvent = 'SPEAKER_EVENT',
  StatementOfWork = 'STATEMENT_OF_WORK',
  SupplierServices = 'SUPPLIER_SERVICES',
  VenueHire = 'VENUE_HIRE',
}

export enum ContractValuePeriodEnum {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  OneOff = 'ONE_OFF',
  UsageBased = 'USAGE_BASED',
}

export type Contribution = {
  __typename?: 'Contribution'
  amount: Money
  assetType: AssetType
  contributionMethod?: Maybe<ContributionMethodEnum>
  createdDate: Scalars['ISO8601Date']['output']
  cryptoAmount?: Maybe<Scalars['String']['output']>
  cryptoCurrency?: Maybe<Scalars['String']['output']>
  cryptoPayment?: Maybe<CryptoPayment>
  displayName: Scalars['String']['output']
  donorCountryOfTaxResidence?: Maybe<Scalars['Country']['output']>
  donorHasUsPassport: Scalars['Boolean']['output']
  donorNationality?: Maybe<Scalars['Country']['output']>
  donorUkDomiciled: Scalars['Boolean']['output']
  giftAccountId: Scalars['String']['output']
  giftAidEligible: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  legalEntity: LegalEntity
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  paymentType?: Maybe<CashPaymentTypeEnum>
  plaidPayment?: Maybe<PlaidPayment>
  plaidTransfer?: Maybe<PlaidTransfer>
  privateSecurityItem?: Maybe<PrivateSecurityItem>
  publicSecurityItem?: Maybe<PublicSecurityItem>
  status: ContributionStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
  transferDetails: TransferDetails
}

export enum ContributionMethodEnum {
  BankTransfer = 'BANK_TRANSFER',
  Crypto = 'CRYPTO',
  ExternalDaf = 'EXTERNAL_DAF',
  PrivateSecuritiesTransfer = 'PRIVATE_SECURITIES_TRANSFER',
  PublicSecuritiesTransfer = 'PUBLIC_SECURITIES_TRANSFER',
}

export enum ContributionStatus {
  /** Contribution requested */
  ContributionRequested = 'CONTRIBUTION_REQUESTED',
  /** Receipt sent */
  ReceiptSent = 'RECEIPT_SENT',
  /** Transfer initiated */
  TransferMade = 'TRANSFER_MADE',
  /** Transfer received */
  TransferReceived = 'TRANSFER_RECEIVED',
}

/** Autogenerated input type of CreateAllDataUploadRowRecords */
export type CreateAllDataUploadRowRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of CreateAllDataUploadRowRecords. */
export type CreateAllDataUploadRowRecordsPayload = {
  __typename?: 'CreateAllDataUploadRowRecordsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CreateAsset */
export type CreateAssetInput = {
  assignToEmployeeId?: InputMaybe<Scalars['ID']['input']>
  assignToLocation?: InputMaybe<AssetLocationEnum>
  assignedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  attributes: AssetAttributesInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** ON_ORDER or IN_STOCK; ignored when assigning */
  status?: InputMaybe<AssetStatusEnum>
}

/** Autogenerated return type of CreateAsset. */
export type CreateAssetPayload = {
  __typename?: 'CreateAssetPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of CreateAssetsFromOrder */
export type CreateAssetsFromOrderInput = {
  /** Add the items even though the order reference already has assets */
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>
  assignToEmployeeId?: InputMaybe<Scalars['ID']['input']>
  assignToLocation?: InputMaybe<AssetLocationEnum>
  assignedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  entity?: InputMaybe<AssetEntityEnum>
  lines: Array<AssetOrderLineInput>
  orderReference?: InputMaybe<Scalars['String']['input']>
  purchaseCurrency?: InputMaybe<Scalars['String']['input']>
  purchasedById?: InputMaybe<Scalars['ID']['input']>
  purchasedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** ON_ORDER or IN_STOCK; ignored when assigning */
  status?: InputMaybe<AssetStatusEnum>
  supplier?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateAssetsFromOrder. */
export type CreateAssetsFromOrderPayload = {
  __typename?: 'CreateAssetsFromOrderPayload'
  assets: Array<Asset>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of CreateCaseNote */
export type CreateCaseNoteInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
}

/** Autogenerated return type of CreateCaseNote. */
export type CreateCaseNotePayload = {
  __typename?: 'CreateCaseNotePayload'
  caseNote: Note
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of CreateCharityBankAccountVerificationCall */
export type CreateCharityBankAccountVerificationCallInput = {
  abaRoutingNumber?: InputMaybe<Scalars['String']['input']>
  accountCurrency?: InputMaybe<Scalars['String']['input']>
  accountHolderAddress?: InputMaybe<Scalars['String']['input']>
  accountHolderName?: InputMaybe<Scalars['String']['input']>
  accountNumber?: InputMaybe<Scalars['String']['input']>
  bankAddress?: InputMaybe<Scalars['String']['input']>
  bankName?: InputMaybe<Scalars['String']['input']>
  callDateTime: Scalars['ISO8601DateTime']['input']
  callOutcome: VerificationCallOutcomeEnum
  charityBankAccountId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  contactRole?: InputMaybe<Scalars['String']['input']>
  duringCallChecklist?: InputMaybe<Scalars['JSON']['input']>
  emailAddressUsed?: InputMaybe<Scalars['String']['input']>
  emailSource?: InputMaybe<Scalars['String']['input']>
  iban?: InputMaybe<Scalars['String']['input']>
  identityConfirmationMethod?: InputMaybe<Scalars['String']['input']>
  intermediaryBankDetails?: InputMaybe<Scalars['String']['input']>
  intermediaryBankName?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  phoneNumberSource?: InputMaybe<Scalars['String']['input']>
  preCallChecklist?: InputMaybe<Scalars['JSON']['input']>
  redFlagsMitigationNotes?: InputMaybe<Scalars['String']['input']>
  redFlagsPresent?: InputMaybe<Scalars['Boolean']['input']>
  sortCode?: InputMaybe<Scalars['String']['input']>
  swiftCode?: InputMaybe<Scalars['String']['input']>
  telephoneNumberCalled?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateCharityBankAccountVerificationCall. */
export type CreateCharityBankAccountVerificationCallPayload = {
  __typename?: 'CreateCharityBankAccountVerificationCallPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  verificationCall: AdminCharityBankAccountVerificationCall
}

/** Autogenerated input type of CreateCharityCategory */
export type CreateCharityCategoryInput = {
  charityCategoryInput: CharityCategoryChangeInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateCharityCategory. */
export type CreateCharityCategoryPayload = {
  __typename?: 'CreateCharityCategoryPayload'
  charityCategory?: Maybe<CharityCategoryAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of CreateContract */
export type CreateContractInput = {
  attributes: ContractAttributesInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** DRAFT or ACTIVE (the default) */
  status?: InputMaybe<ContractStatusEnum>
}

/** Autogenerated return type of CreateContract. */
export type CreateContractPayload = {
  __typename?: 'CreateContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of CreateDataUploadRowRecord */
export type CreateDataUploadRowRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of CreateDataUploadRowRecord. */
export type CreateDataUploadRowRecordPayload = {
  __typename?: 'CreateDataUploadRowRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CreateEventCampaign */
export type CreateEventCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of CreateEventCampaign. */
export type CreateEventCampaignPayload = {
  __typename?: 'CreateEventCampaignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  event?: Maybe<EventAdmin>
}

/** Autogenerated input type of CreateEvent */
export type CreateEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventChanges: EventChangeInput
}

/** Autogenerated return type of CreateEvent. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  event?: Maybe<EventAdmin>
}

/** Autogenerated input type of CreateHifoCascade */
export type CreateHifoCascadeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadeInput: HifoCascadeChangeInput
}

/** Autogenerated return type of CreateHifoCascade. */
export type CreateHifoCascadePayload = {
  __typename?: 'CreateHifoCascadePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  hifoCascade?: Maybe<HifoCascade>
}

/** Autogenerated input type of CreateHifoCascadePitch */
export type CreateHifoCascadePitchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadeId: Scalars['ID']['input']
  hifoCascadePitchInput: HifoCascadePitchChangeInput
}

/** Autogenerated input type of CreateHifoCascadePitchMaterial */
export type CreateHifoCascadePitchMaterialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadePitchId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateHifoCascadePitchMaterial. */
export type CreateHifoCascadePitchMaterialPayload = {
  __typename?: 'CreateHifoCascadePitchMaterialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  pitchMaterial: HifoCascadePitchMaterial
}

/** Autogenerated input type of CreateHifoCascadePitchNote */
export type CreateHifoCascadePitchNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  hifoCascadePitchId: Scalars['ID']['input']
}

/** Autogenerated return type of CreateHifoCascadePitchNote. */
export type CreateHifoCascadePitchNotePayload = {
  __typename?: 'CreateHifoCascadePitchNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  pitchNote: Note
}

/** Autogenerated return type of CreateHifoCascadePitch. */
export type CreateHifoCascadePitchPayload = {
  __typename?: 'CreateHifoCascadePitchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  hifoCascadePitch?: Maybe<HifoCascadePitch>
}

/** Autogenerated input type of CreateHifo */
export type CreateHifoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoInput: HifoChangeInput
}

/** Autogenerated return type of CreateHifo. */
export type CreateHifoPayload = {
  __typename?: 'CreateHifoPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors: Array<Scalars['String']['output']>
  hifo?: Maybe<HifoAdmin>
}

/** Autogenerated input type of CreateImpactMeasurementCategory */
export type CreateImpactMeasurementCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactMeasurementCategoryInput: ImpactMeasurementCategoryInput
}

/** Autogenerated return type of CreateImpactMeasurementCategory. */
export type CreateImpactMeasurementCategoryPayload = {
  __typename?: 'CreateImpactMeasurementCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactMeasurementCategory?: Maybe<ImpactMeasurementCategory>
}

/** Autogenerated input type of CreateImpactMeasurementItem */
export type CreateImpactMeasurementItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactMeasurementItemInput: ImpactMeasurementItemInput
}

/** Autogenerated return type of CreateImpactMeasurementItem. */
export type CreateImpactMeasurementItemPayload = {
  __typename?: 'CreateImpactMeasurementItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactMeasurementItem?: Maybe<ImpactMeasurementItem>
}

/** Autogenerated input type of CreateImpactRecord */
export type CreateImpactRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactRecordInput: ImpactRecordInput
}

/** Autogenerated return type of CreateImpactRecord. */
export type CreateImpactRecordPayload = {
  __typename?: 'CreateImpactRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactRecord?: Maybe<ImpactData>
}

/** Autogenerated input type of CreateInvestmentPool */
export type CreateInvestmentPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  investmentPoolInput: InvestmentPoolInput
}

/** Autogenerated return type of CreateInvestmentPool. */
export type CreateInvestmentPoolPayload = {
  __typename?: 'CreateInvestmentPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  investmentPool?: Maybe<InvestmentPool>
}

/** Autogenerated input type of CreateMatchCampaignCategory */
export type CreateMatchCampaignCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  matchCampaignCategoryInput: MatchCampaignCategoryInput
}

/** Autogenerated return type of CreateMatchCampaignCategory. */
export type CreateMatchCampaignCategoryPayload = {
  __typename?: 'CreateMatchCampaignCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  matchCampaignCategory?: Maybe<MatchCampaignCategory>
}

/** Autogenerated input type of CreateMatchCampaign */
export type CreateMatchCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  matchCampaignInput: MatchCampaignInput
}

/** Autogenerated return type of CreateMatchCampaign. */
export type CreateMatchCampaignPayload = {
  __typename?: 'CreateMatchCampaignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  matchCampaign?: Maybe<MatchCampaignAdmin>
}

/** Autogenerated input type of CreateNewsItem */
export type CreateNewsItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  newsItemChanges: NewsItemChangeInput
}

/** Autogenerated return type of CreateNewsItem. */
export type CreateNewsItemPayload = {
  __typename?: 'CreateNewsItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  newsItem?: Maybe<NewsItemAdmin>
}

/** Autogenerated input type of CreatePledge */
export type CreatePledgeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  pledge: PledgeInput
  surname: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

/** Autogenerated return type of CreatePledge. */
export type CreatePledgePayload = {
  __typename?: 'CreatePledgePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  pledge?: Maybe<PledgeAdmin>
}

/** Autogenerated input type of CreatePolicy */
export type CreatePolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  policyInput: PolicyInput
}

/** Autogenerated return type of CreatePolicy. */
export type CreatePolicyPayload = {
  __typename?: 'CreatePolicyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policy: PolicyAdmin
}

/** Autogenerated input type of CreateRole */
export type CreateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  roleInput: RoleInput
}

/** Autogenerated return type of CreateRole. */
export type CreateRolePayload = {
  __typename?: 'CreateRolePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  role?: Maybe<Role>
}

/** Autogenerated input type of CreateSecondFactor */
export type CreateSecondFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateSecondFactor. */
export type CreateSecondFactorPayload = {
  __typename?: 'CreateSecondFactorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  twoFactorCode: Scalars['String']['output']
  twoFactorUrl: Scalars['String']['output']
}

/** Autogenerated input type of CreateTargetAudience */
export type CreateTargetAudienceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  targetAudienceInput: TargetAudienceInput
}

/** Autogenerated return type of CreateTargetAudience. */
export type CreateTargetAudiencePayload = {
  __typename?: 'CreateTargetAudiencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  targetAudience?: Maybe<TargetAudience>
}

/** Autogenerated input type of CreateTeam */
export type CreateTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

/** Autogenerated return type of CreateTeam. */
export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  team: Team
}

/** Autogenerated input type of CreateTrainingCategory */
export type CreateTrainingCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

/** Autogenerated return type of CreateTrainingCategory. */
export type CreateTrainingCategoryPayload = {
  __typename?: 'CreateTrainingCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCategory: TrainingCategory
}

/** Autogenerated input type of CreateTrainingCourse */
export type CreateTrainingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  courseInput: TrainingCourseInput
  singleModule?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of CreateTrainingCourse. */
export type CreateTrainingCoursePayload = {
  __typename?: 'CreateTrainingCoursePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: TrainingCourseAdmin
  /** The module, for a single-module course */
  trainingModule?: Maybe<TrainingModuleAdmin>
}

/** Autogenerated input type of CreateTrainingModule */
export type CreateTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Adds it to the end of this course */
  courseId?: InputMaybe<Scalars['ID']['input']>
  moduleInput: TrainingModuleInput
}

/** Autogenerated return type of CreateTrainingModule. */
export type CreateTrainingModulePayload = {
  __typename?: 'CreateTrainingModulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

/** Autogenerated input type of CreateUsDisbursement */
export type CreateUsDisbursementInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CreateUsDisbursement. */
export type CreateUsDisbursementPayload = {
  __typename?: 'CreateUsDisbursementPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of CreateUsDueDiligenceNote */
export type CreateUsDueDiligenceNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  usDueDiligenceId: Scalars['ID']['input']
}

/** Autogenerated return type of CreateUsDueDiligenceNote. */
export type CreateUsDueDiligenceNotePayload = {
  __typename?: 'CreateUsDueDiligenceNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  usDueDiligenceNote: Note
}

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  isPledger: Scalars['Boolean']['input']
  pledge?: InputMaybe<PledgeInput>
  preventConfirmationEmail: Scalars['Boolean']['input']
  salesforceId?: InputMaybe<Scalars['String']['input']>
  surname: Scalars['String']['input']
  websiteProfile: WebsiteProfileInput
  welcomeEmailSource: Scalars['String']['input']
}

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
}

export type CryptoPayment = {
  __typename?: 'CryptoPayment'
  depositAddress?: Maybe<Scalars['String']['output']>
  depositTag?: Maybe<Scalars['String']['output']>
  donationId?: Maybe<Scalars['String']['output']>
  qrCode?: Maybe<Scalars['String']['output']>
}

export enum DafAccessLevelEnum {
  Full = 'Full',
  Partial = 'Partial',
  View = 'View',
}

export type DafAccountAdmin = {
  __typename?: 'DafAccountAdmin'
  adjustments: Array<Adjustment>
  adminFees: Array<AdminFee>
  administrativeFees: Array<AdministrativeFee>
  advisors: Array<Advisor>
  balances: Array<Money>
  contributions: Array<Contribution>
  /** returns draft private security items for the current user on this DAF account */
  draftPrivateSecurities: Array<PrivateSecurityItem>
  /** returns draft public security items for the current user on this DAF account */
  draftPublicSecurities: Array<PublicSecurityItem>
  giftAccountId: Scalars['String']['output']
  giftAids: Array<GiftAid>
  grants: Array<GrantAdmin>
  illiquidBalances: Array<Money>
  incomingFundToFundTransfers: Array<FundToFundTransfer>
  investmentAllocation?: Maybe<InvestmentAllocation>
  investmentReturns: Array<InvestmentReturn>
  legalEntity: LegalEntity
  liquidBalances: Array<Money>
  name: Scalars['String']['output']
  pendingInvestmentAllocationChange?: Maybe<InvestmentAllocationChange>
  pendingPlanChange?: Maybe<PlanChange>
  plan?: Maybe<PlanEnum>
  predictedAdminFees?: Maybe<Array<Money>>
  processingFeeExemption: Scalars['Boolean']['output']
  recurringGrants: Array<RecurringGrant>
  statements?: Maybe<Array<Statement>>
}

export type DafAdminFee = {
  __typename?: 'DafAdminFee'
  applicableDafPlan: Scalars['String']['output']
  averageDailyBalanceGross: Money
  calculationData?: Maybe<CalculationData>
  caseStatus: FeeCaseStatus
  endDate: Scalars['ISO8601Date']['output']
  fee: Money
  feeStartDate?: Maybe<Scalars['ISO8601Date']['output']>
  feeWaived: Scalars['Boolean']['output']
  feeWaivedReason?: Maybe<Scalars['String']['output']>
  fund: Fund
  fundAccount: FundAccount
  hifoDiscount: Money
  id: Scalars['ID']['output']
  monthlyFee: Money
  period: DafAdminFeePeriod
  salesforceCaseId?: Maybe<Scalars['String']['output']>
  startDate: Scalars['ISO8601Date']['output']
}

export type DafAdminFeePeriod = {
  __typename?: 'DafAdminFeePeriod'
  endDate: Scalars['ISO8601Date']['output']
  fundAdminFees?: Maybe<Array<FundAdminFee>>
  id: Scalars['ID']['output']
  lockedDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  name: Scalars['String']['output']
  startDate: Scalars['ISO8601Date']['output']
}

/** DafAdminFeePeriodCollection type */
export type DafAdminFeePeriodCollection = {
  __typename?: 'DafAdminFeePeriodCollection'
  /** A collection of paginated DafAdminFeePeriodCollection */
  collection: Array<DafAdminFeePeriod>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type DafAdvisor = {
  __typename?: 'DafAdvisor'
  accessLevel?: Maybe<DafAccessLevelEnum>
  contact: Contact
  fund: Fund
  id: Scalars['ID']['output']
  needsConfirmation: Scalars['Boolean']['output']
  removed?: Maybe<Scalars['ISO8601Date']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  signedTermsAndConditions?: Maybe<Scalars['ISO8601Date']['output']>
}

export type DafAdvisorExternalOpexDonation = {
  __typename?: 'DafAdvisorExternalOpexDonation'
  caseRecords: Array<CaseRecord>
  contact: Contact
  funds: Array<Fund>
  numberOfDafs: Scalars['Int']['output']
  opexDonationsByMonth: Array<DafAdvisorExternalOpexMonthlyTotal>
}

export type DafAdvisorExternalOpexMonthlyTotal = {
  __typename?: 'DafAdvisorExternalOpexMonthlyTotal'
  month: Scalars['ISO8601Date']['output']
  total: Money
}

export type DafInvestmentAllocationChange = {
  __typename?: 'DafInvestmentAllocationChange'
  dateApplied?: Maybe<Scalars['ISO8601Date']['output']>
  dateCreated: Scalars['ISO8601DateTime']['output']
  dateUpdated: Scalars['ISO8601DateTime']['output']
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>
  fund: Fund
  id: Scalars['ID']['output']
  newInvestmentAllocation?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
}

/** DafInvestmentAllocationChangeCollection type */
export type DafInvestmentAllocationChangeCollection = {
  __typename?: 'DafInvestmentAllocationChangeCollection'
  /** A collection of paginated DafInvestmentAllocationChangeCollection */
  collection: Array<DafInvestmentAllocationChange>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type DafPlanChange = {
  __typename?: 'DafPlanChange'
  dateApplied?: Maybe<Scalars['ISO8601Date']['output']>
  dateCreated: Scalars['ISO8601DateTime']['output']
  dateUpdated: Scalars['ISO8601DateTime']['output']
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>
  fund: Fund
  id: Scalars['ID']['output']
  newPlan: Scalars['String']['output']
  status: Scalars['String']['output']
}

/** DafPlanChangeCollection type */
export type DafPlanChangeCollection = {
  __typename?: 'DafPlanChangeCollection'
  /** A collection of paginated DafPlanChangeCollection */
  collection: Array<DafPlanChange>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type DafStatement = {
  __typename?: 'DafStatement'
  createdAt: Scalars['ISO8601DateTime']['output']
  currency: Scalars['String']['output']
  endDate: Scalars['ISO8601Date']['output']
  generationStatus: GenerationStatus
  giftAccountId: Scalars['ID']['output']
  giftAccountName: Scalars['String']['output']
  id: Scalars['ID']['output']
  legalEntity: LegalEntity
  regeneratedOn?: Maybe<Scalars['ISO8601DateTime']['output']>
  startDate: Scalars['ISO8601Date']['output']
}

export type DafStatementInput = {
  endDate: Scalars['ISO8601Date']['input']
  startDate: Scalars['ISO8601Date']['input']
}

export type DafStatementPeriod = {
  __typename?: 'DafStatementPeriod'
  endDate: Scalars['ISO8601Date']['output']
  period: Scalars['String']['output']
  startDate: Scalars['ISO8601Date']['output']
  statuses: Array<DafStatementPeriodStatus>
}

export type DafStatementPeriodStatus = {
  __typename?: 'DafStatementPeriodStatus'
  count: Scalars['Int']['output']
  generationStatus: GenerationStatus
}

export type DailyBalance = {
  __typename?: 'DailyBalance'
  balance: Money
  date: Scalars['ISO8601Date']['output']
  hifoTotal: Money
  opexTotal: Money
}

export type DailyRegistrationCount = {
  __typename?: 'DailyRegistrationCount'
  count: Scalars['Int']['output']
  date: Scalars['ISO8601Date']['output']
}

export type DataUpload = {
  __typename?: 'DataUpload'
  createdAt: Scalars['ISO8601DateTime']['output']
  errorMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  rows: Array<DataUploadRow>
  status: DataUploadStatus
  totals: DataUploadTotals
  updatedAt: Scalars['ISO8601DateTime']['output']
  uploadType: DataUploadFile
  user: User
}

/** DataUploadCollection type */
export type DataUploadCollection = {
  __typename?: 'DataUploadCollection'
  /** A collection of paginated DataUploadCollection */
  collection: Array<DataUpload>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum DataUploadFile {
  /** Charities */
  Charities = 'Charities',
  /** DirectDonations */
  DirectDonations = 'DirectDonations',
}

export type DataUploadRow = {
  __typename?: 'DataUploadRow'
  createdAt: Scalars['ISO8601DateTime']['output']
  decision: DataUploadRowDecision
  dupSuggestions: Array<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  importErrors: Array<Scalars['JSON']['output']>
  newRecordId?: Maybe<Scalars['ID']['output']>
  newRecordType?: Maybe<Scalars['String']['output']>
  parsed: Scalars['JSON']['output']
  raw: Scalars['JSON']['output']
  rowIndex: Scalars['Int']['output']
  status: DataUploadRowStatus
  updatedAt: Scalars['ISO8601DateTime']['output']
  validationErrors: Array<Scalars['JSON']['output']>
}

export enum DataUploadRowDecision {
  /** Create */
  Create = 'Create',
  /** Skip */
  Skip = 'Skip',
}

export enum DataUploadRowStatus {
  /** Created */
  Created = 'Created',
  /** Creating */
  Creating = 'Creating',
  /** Failed */
  Failed = 'Failed',
  /** Pending */
  Pending = 'Pending',
  /** Skipped */
  Skipped = 'Skipped',
}

export enum DataUploadStatus {
  /** Analyzed */
  Analyzed = 'Analyzed',
  /** Analyzing */
  Analyzing = 'Analyzing',
  /** Complete */
  Complete = 'Complete',
  /** Failed */
  Failed = 'Failed',
  /** Importing */
  Importing = 'Importing',
}

export type DataUploadTotals = {
  __typename?: 'DataUploadTotals'
  created: Scalars['Int']['output']
  errors: Scalars['Int']['output']
  potentialDuplicates: Scalars['Int']['output']
  ready: Scalars['Int']['output']
  totalRows: Scalars['Int']['output']
}

export type DateFilterInput = {
  field: FundFilterFieldEnum
  operator: DateOperatorEnum
  value?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export enum DateOperatorEnum {
  After = 'AFTER',
  Before = 'BEFORE',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  On = 'ON',
}

/** Autogenerated input type of DeactivateCharityContact */
export type DeactivateCharityContactInput = {
  charityContactId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of DeactivateCharityContact. */
export type DeactivateCharityContactPayload = {
  __typename?: 'DeactivateCharityContactPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteAssetDocument */
export type DeleteAssetDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteAssetDocument. */
export type DeleteAssetDocumentPayload = {
  __typename?: 'DeleteAssetDocumentPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of DeleteCaseNote */
export type DeleteCaseNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteCaseNote. */
export type DeleteCaseNotePayload = {
  __typename?: 'DeleteCaseNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteCharityCategory */
export type DeleteCharityCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteCharityCategory. */
export type DeleteCharityCategoryPayload = {
  __typename?: 'DeleteCharityCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteContractDocument */
export type DeleteContractDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteContractDocument. */
export type DeleteContractDocumentPayload = {
  __typename?: 'DeleteContractDocumentPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of DeleteContract */
export type DeleteContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteContract. */
export type DeleteContractPayload = {
  __typename?: 'DeleteContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedId: Scalars['ID']['output']
}

/** Autogenerated input type of DeleteEventQuestionTemplate */
export type DeleteEventQuestionTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteEventQuestionTemplate. */
export type DeleteEventQuestionTemplatePayload = {
  __typename?: 'DeleteEventQuestionTemplatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteHifoCascade */
export type DeleteHifoCascadeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteHifoCascade. */
export type DeleteHifoCascadePayload = {
  __typename?: 'DeleteHifoCascadePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteHifoCascadePitch */
export type DeleteHifoCascadePitchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated input type of DeleteHifoCascadePitchMaterial */
export type DeleteHifoCascadePitchMaterialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteHifoCascadePitchMaterial. */
export type DeleteHifoCascadePitchMaterialPayload = {
  __typename?: 'DeleteHifoCascadePitchMaterialPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteHifoCascadePitchNote */
export type DeleteHifoCascadePitchNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteHifoCascadePitchNote. */
export type DeleteHifoCascadePitchNotePayload = {
  __typename?: 'DeleteHifoCascadePitchNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated return type of DeleteHifoCascadePitch. */
export type DeleteHifoCascadePitchPayload = {
  __typename?: 'DeleteHifoCascadePitchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteHifo */
export type DeleteHifoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteHifo. */
export type DeleteHifoPayload = {
  __typename?: 'DeleteHifoPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteImpactMeasurementCategory */
export type DeleteImpactMeasurementCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteImpactMeasurementCategory. */
export type DeleteImpactMeasurementCategoryPayload = {
  __typename?: 'DeleteImpactMeasurementCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteImpactMeasurementItem */
export type DeleteImpactMeasurementItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteImpactMeasurementItem. */
export type DeleteImpactMeasurementItemPayload = {
  __typename?: 'DeleteImpactMeasurementItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteInvestmentPool */
export type DeleteInvestmentPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteInvestmentPool. */
export type DeleteInvestmentPoolPayload = {
  __typename?: 'DeleteInvestmentPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteMatchCampaignCategory */
export type DeleteMatchCampaignCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteMatchCampaignCategory. */
export type DeleteMatchCampaignCategoryPayload = {
  __typename?: 'DeleteMatchCampaignCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteMatchCampaign */
export type DeleteMatchCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteMatchCampaign. */
export type DeleteMatchCampaignPayload = {
  __typename?: 'DeleteMatchCampaignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteNewsItem */
export type DeleteNewsItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteNewsItem. */
export type DeleteNewsItemPayload = {
  __typename?: 'DeleteNewsItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteProvisionalPledge */
export type DeleteProvisionalPledgeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  pledgeId: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteProvisionalPledge. */
export type DeleteProvisionalPledgePayload = {
  __typename?: 'DeleteProvisionalPledgePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteTargetAudience */
export type DeleteTargetAudienceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteTargetAudience. */
export type DeleteTargetAudiencePayload = {
  __typename?: 'DeleteTargetAudiencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteUsDueDiligenceNote */
export type DeleteUsDueDiligenceNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteUsDueDiligenceNote. */
export type DeleteUsDueDiligenceNotePayload = {
  __typename?: 'DeleteUsDueDiligenceNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DisableSecondFactor */
export type DisableSecondFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  code: Scalars['String']['input']
}

/** Autogenerated return type of DisableSecondFactor. */
export type DisableSecondFactorPayload = {
  __typename?: 'DisableSecondFactorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of DiscardHeldUpdates */
export type DiscardHeldUpdatesInput = {
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of DiscardHeldUpdates. */
export type DiscardHeldUpdatesPayload = {
  __typename?: 'DiscardHeldUpdatesPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of DismissPolicySummarySuggestion */
export type DismissPolicySummarySuggestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  documentId: Scalars['ID']['input']
}

/** Autogenerated return type of DismissPolicySummarySuggestion. */
export type DismissPolicySummarySuggestionPayload = {
  __typename?: 'DismissPolicySummarySuggestionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policy: PolicyAdmin
}

export type EditHistory = {
  __typename?: 'EditHistory'
  changedBy?: Maybe<User>
  changedFrom?: Maybe<Scalars['String']['output']>
  changedTo?: Maybe<Scalars['String']['output']>
  comment?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['ISO8601DateTime']['output']>
  field?: Maybe<Scalars['String']['output']>
}

export type Employee = {
  __typename?: 'Employee'
  /** When they were added, by the Salesforce sync or in the admin */
  createdAt: Scalars['ISO8601DateTime']['output']
  /** Blank for Salesforce integration users, which have no email */
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  leftOn?: Maybe<Scalars['ISO8601Date']['output']>
  name: Scalars['String']['output']
  /** When their leaving date offboarded them. Only then does moving or cancelling it bring them back */
  offboardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  profileName?: Maybe<Scalars['String']['output']>
  roles?: Maybe<Array<Role>>
  salesforceId?: Maybe<Scalars['String']['output']>
  /** Their Salesforce user is active. Set by the Salesforce sync */
  salesforceLicenceActive: Scalars['Boolean']['output']
  signInStatus: EmployeeSignInStatusEnum
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  team?: Maybe<Team>
  title?: Maybe<Scalars['String']['output']>
  trainingRequired: Scalars['Boolean']['output']
  user?: Maybe<User>
  welcomeCallLink?: Maybe<Scalars['String']['output']>
  /** They're current staff. Set in the admin */
  worksAtFp: Scalars['Boolean']['output']
}

export type EmployeeBooleanFilterInput = {
  field: EmployeeFilterFieldEnum
  operator: BooleanOperatorEnum
}

export type EmployeeChangeInput = {
  id: Scalars['ID']['input']
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** null clears it. EDIT_EMPLOYEE or MANAGE_TRAINING */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** null clears it */
  teamId?: InputMaybe<Scalars['ID']['input']>
  /** Turning it on needs EDIT_EMPLOYEE or MANAGE_TRAINING, turning it off MANAGE_TRAINING */
  trainingRequired?: InputMaybe<Scalars['Boolean']['input']>
}

/** EmployeeCollection type */
export type EmployeeCollection = {
  __typename?: 'EmployeeCollection'
  /** A collection of paginated EmployeeCollection */
  collection: Array<Employee>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum EmployeeFilterFieldEnum {
  Email = 'EMAIL',
  Name = 'NAME',
  ProfileName = 'PROFILE_NAME',
  SalesforceLicenceActive = 'SALESFORCE_LICENCE_ACTIVE',
  Title = 'TITLE',
  WorksAtFp = 'WORKS_AT_FP',
}

/** Whether an employee can sign in to FP Navigator */
export enum EmployeeSignInStatusEnum {
  Archived = 'ARCHIVED',
  NotAdmin = 'NOT_ADMIN',
  No_2Fa = 'NO_2FA',
  NoLogin = 'NO_LOGIN',
  Ok = 'OK',
}

export type EmployeeStringFilterInput = {
  field: EmployeeFilterFieldEnum
  operator: StringOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated input type of EnableSecondFactor */
export type EnableSecondFactorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  code: Scalars['String']['input']
  id: Scalars['Int']['input']
}

/** Autogenerated return type of EnableSecondFactor. */
export type EnableSecondFactorPayload = {
  __typename?: 'EnableSecondFactorPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type EventAdmin = {
  __typename?: 'EventAdmin'
  attendees: Array<EventAttendeeAdmin>
  calendarDescription?: Maybe<Scalars['String']['output']>
  calendarResponsesCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  campaign?: Maybe<EventCampaign>
  cancelledCount: Scalars['Int']['output']
  capacity: Scalars['Int']['output']
  capacityHeldCount: Scalars['Int']['output']
  changesLockAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  checkInClosedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** Who can be checked in: confirmed guests and no-shows. Light enough to poll. */
  checkInGuests: Array<EventCheckInGuest>
  checkedInCount: Scalars['Int']['output']
  collectPlusOneDetails: Scalars['Boolean']['output']
  confirmedCount: Scalars['Int']['output']
  contactPhone?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  dayReminderMode: EventReminderModeEnum
  emailOverrides: Scalars['JSON']['output']
  endsAt: Scalars['ISO8601DateTime']['output']
  eventType: EventTypeEnum
  followUps: Array<EventFollowUp>
  formConfig: Scalars['JSON']['output']
  googleCalendarEventId?: Maybe<Scalars['String']['output']>
  googleCalendarUrl?: Maybe<Scalars['String']['output']>
  hostedRegistrationUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** The save the date form's questions: the retreat's own, or the defaults */
  interestQuestions: Scalars['JSON']['output']
  /** Registered interest through the save the date and not yet registered */
  interestedCount: Scalars['Int']['output']
  invitedCount: Scalars['Int']['output']
  locationAddress?: Maybe<Scalars['String']['output']>
  locationCity?: Maybe<Scalars['String']['output']>
  locationMapUrl?: Maybe<Scalars['String']['output']>
  locationName?: Maybe<Scalars['String']['output']>
  manager?: Maybe<Employee>
  maxPlusOnes: Scalars['Int']['output']
  maxPromotionSkips: Scalars['Int']['output']
  noShowCount: Scalars['Int']['output']
  offerExpiryHours: Scalars['Int']['output']
  offeredCount: Scalars['Int']['output']
  outboxHealth: EventOutboxHealth
  overCapacity: Scalars['Boolean']['output']
  plusOnesEnabled: Scalars['Boolean']['output']
  registrationHostedInApp: Scalars['Boolean']['output']
  registrationMode: EventRegistrationModeEnum
  registrationsPerDay: Array<DailyRegistrationCount>
  remainingCapacity: Scalars['Int']['output']
  reminders: Array<EventReminder>
  slackChannel?: Maybe<Scalars['String']['output']>
  startsAt: Scalars['ISO8601DateTime']['output']
  status: EventStatusEnum
  strapiSlug: Scalars['String']['output']
  termsUrl?: Maybe<Scalars['String']['output']>
  termsVersion?: Maybe<Scalars['String']['output']>
  timezone: Scalars['String']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  waitlist: Array<EventRegistrationAdmin>
  waitlistAutoPromote: Scalars['Boolean']['output']
  waitlistClosesAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  waitlistEnabled: Scalars['Boolean']['output']
  waitlistedPartiesCount: Scalars['Int']['output']
  waitlistedPeopleCount: Scalars['Int']['output']
  weekReminderMode: EventReminderModeEnum
}

/** EventAdminCollection type */
export type EventAdminCollection = {
  __typename?: 'EventAdminCollection'
  /** A collection of paginated EventAdminCollection */
  collection: Array<EventAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type EventAttendeeAdmin = {
  __typename?: 'EventAttendeeAdmin'
  accessibilityRequirements?: Maybe<Scalars['String']['output']>
  /** The photo of the member app user linked to the guest's contact */
  avatarUrl?: Maybe<Scalars['String']['output']>
  /** Their reply to the Google Calendar invite, as of the last hourly check */
  calendarResponse?: Maybe<EventCalendarResponseEnum>
  cancellationReason?: Maybe<Scalars['String']['output']>
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  cancelledFromStatus?: Maybe<EventAttendeeStatusEnum>
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  checkedInByName?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  consentToIncludeInGuestlist: Scalars['Boolean']['output']
  /** Where the guest's name, company or job title differ from their contact's */
  contactDifferences: Array<EventContactDifference>
  /** The matched contact's Salesforce ID, for linking to their record */
  contactSalesforceId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  customAnswers: Scalars['JSON']['output']
  dietaryRequirements?: Maybe<Scalars['String']['output']>
  dietaryRequirementsOther?: Maybe<Scalars['String']['output']>
  /** When the team ticked this interested guest for early access */
  earlyAccessAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  eventsAttended?: Maybe<Scalars['Int']['output']>
  firstName: Scalars['String']['output']
  focusMember?: Maybe<Scalars['Boolean']['output']>
  /** Emails and calendar updates the team held back and hasn't yet sent or discarded */
  heldUpdateCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  offerExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** Emails, calendar updates and Slack posts about this guest, oldest first. Load for one guest at a time. */
  outboxEntries: Array<EventOutboxEntryAdmin>
  parentAttendeeId?: Maybe<Scalars['ID']['output']>
  pledgeDate?: Maybe<Scalars['ISO8601Date']['output']>
  plusOne: Scalars['Boolean']['output']
  preferredName?: Maybe<Scalars['String']['output']>
  /** website or admin */
  registrationSource: Scalars['String']['output']
  sourceOfInvitation?: Maybe<Scalars['String']['output']>
  sourceOfInvitationOther?: Maybe<Scalars['String']['output']>
  spoc?: Maybe<Scalars['String']['output']>
  status: EventAttendeeStatusEnum
  syncStatus?: Maybe<Scalars['String']['output']>
  uuid: Scalars['String']['output']
}

export enum EventAttendeeStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Interested = 'INTERESTED',
  Invited = 'INVITED',
  NoShow = 'NO_SHOW',
  Offered = 'OFFERED',
  PendingReview = 'PENDING_REVIEW',
  Waitlisted = 'WAITLISTED',
}

export enum EventCalendarResponseEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NoReply = 'NO_REPLY',
  /** Replied maybe */
  Tentative = 'TENTATIVE',
}

export type EventCampaign = {
  __typename?: 'EventCampaign'
  active: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  linkedEventId?: Maybe<Scalars['ID']['output']>
  linkedEventTitle?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  recordTypeName: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type EventChangeInput = {
  /** Shown in the Google Calendar invite */
  calendarDescription?: InputMaybe<Scalars['String']['input']>
  campaignId?: InputMaybe<Scalars['ID']['input']>
  capacity?: InputMaybe<Scalars['Int']['input']>
  changesLockAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  collectPlusOneDetails?: InputMaybe<Scalars['Boolean']['input']>
  /** Guests are told to text this number on the day */
  contactPhone?: InputMaybe<Scalars['String']['input']>
  dayReminderMode?: InputMaybe<EventReminderModeEnum>
  emailOverrides?: InputMaybe<Scalars['JSON']['input']>
  endsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  eventType?: InputMaybe<EventTypeEnum>
  formConfig?: InputMaybe<Scalars['JSON']['input']>
  locationAddress?: InputMaybe<Scalars['String']['input']>
  locationCity?: InputMaybe<Scalars['String']['input']>
  /** A Google Maps link to the venue */
  locationMapUrl?: InputMaybe<Scalars['String']['input']>
  locationName?: InputMaybe<Scalars['String']['input']>
  /** The employee looking after the event: on the calendar invite and told when guests change their needs */
  managerId?: InputMaybe<Scalars['ID']['input']>
  maxPlusOnes?: InputMaybe<Scalars['Int']['input']>
  maxPromotionSkips?: InputMaybe<Scalars['Int']['input']>
  offerExpiryHours?: InputMaybe<Scalars['Int']['input']>
  plusOnesEnabled?: InputMaybe<Scalars['Boolean']['input']>
  registrationHostedInApp?: InputMaybe<Scalars['Boolean']['input']>
  registrationMode?: InputMaybe<EventRegistrationModeEnum>
  slackChannel?: InputMaybe<Scalars['String']['input']>
  startsAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  status?: InputMaybe<EventStatusEnum>
  strapiSlug?: InputMaybe<Scalars['String']['input']>
  termsUrl?: InputMaybe<Scalars['String']['input']>
  termsVersion?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  waitlistAutoPromote?: InputMaybe<Scalars['Boolean']['input']>
  waitlistClosesAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  waitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>
  weekReminderMode?: InputMaybe<EventReminderModeEnum>
}

export type EventCheckInGuest = {
  __typename?: 'EventCheckInGuest'
  /** The photo of the member app user linked to the guest's contact */
  avatarUrl?: Maybe<Scalars['String']['output']>
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  checkedInByName?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  /** The lead guest's name, for plus-ones */
  guestOf?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  jobTitle?: Maybe<Scalars['String']['output']>
  lastName: Scalars['String']['output']
  plusOne: Scalars['Boolean']['output']
  status: EventAttendeeStatusEnum
}

export type EventContactDifference = {
  __typename?: 'EventContactDifference'
  field: EventContactFieldEnum
  guestValue: Scalars['String']['output']
  /** False for company, which is an Account link changed in Salesforce */
  salesforceUpdatable: Scalars['Boolean']['output']
  /** Null when Salesforce has nothing for this field */
  salesforceValue?: Maybe<Scalars['String']['output']>
}

export enum EventContactFieldEnum {
  Company = 'COMPANY',
  FirstName = 'FIRST_NAME',
  JobTitle = 'JOB_TITLE',
  LastName = 'LAST_NAME',
}

export type EventFollowUp = {
  __typename?: 'EventFollowUp'
  /** Guests this follow-up has already been sent to */
  queuedCount: Scalars['Int']['output']
  /** Guests in the group with an email address */
  recipientCount: Scalars['Int']['output']
  segment: EventFollowUpSegmentEnum
  /** Why it can't be sent yet, if it can't */
  unavailableReason?: Maybe<Scalars['String']['output']>
}

export enum EventFollowUpSegmentEnum {
  Attended = 'ATTENDED',
  DropOut = 'DROP_OUT',
  /** Interested guests the team ticked for early access */
  EarlyAccess = 'EARLY_ACCESS',
  /** Still on the waitlist or awaiting approval */
  NoPlace = 'NO_PLACE',
  NoShow = 'NO_SHOW',
  /** Everyone still interested, once the retreat is live */
  RegistrationOpen = 'REGISTRATION_OPEN',
}

export type EventInviteResult = {
  __typename?: 'EventInviteResult'
  /** Emails already on the guest list, in any status but cancelled */
  alreadyOnList: Array<Scalars['String']['output']>
  /** Emails that match more than one contact */
  ambiguous: Array<Scalars['String']['output']>
  /** Text that looked like an email but isn't one */
  invalid: Array<Scalars['String']['output']>
  invited: Array<EventAttendeeAdmin>
  /** Emails that match no contact, locally or in Salesforce */
  notFound: Array<Scalars['String']['output']>
}

export type EventOutboxEntryAdmin = {
  __typename?: 'EventOutboxEntryAdmin'
  attempts: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  kind: Scalars['String']['output']
  lastError?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  subjectId: Scalars['ID']['output']
  subjectType: Scalars['String']['output']
  transitionKey: Scalars['String']['output']
}

export type EventOutboxHealth = {
  __typename?: 'EventOutboxHealth'
  failedCount: Scalars['Int']['output']
  failedEntries: Array<EventOutboxEntryAdmin>
  pendingCount: Scalars['Int']['output']
}

export enum EventPeriodEnum {
  Past = 'PAST',
  Upcoming = 'UPCOMING',
}

export type EventQuestionTemplate = {
  __typename?: 'EventQuestionTemplate'
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  options: Scalars['JSON']['output']
  questionType: Scalars['String']['output']
  sfField?: Maybe<Scalars['String']['output']>
}

export type EventRegistrationAdmin = {
  __typename?: 'EventRegistrationAdmin'
  createdAt: Scalars['ISO8601DateTime']['output']
  eventAttendees: Array<EventAttendeeAdmin>
  id: Scalars['ID']['output']
  partySize: Scalars['Int']['output']
  promotionSkipCount: Scalars['Int']['output']
  source: Scalars['String']['output']
  termsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  termsVersionAccepted?: Maybe<Scalars['String']['output']>
  uuid: Scalars['String']['output']
  waitlistPosition?: Maybe<Scalars['Int']['output']>
}

export enum EventRegistrationModeEnum {
  Curated = 'CURATED',
  Open = 'OPEN',
}

export type EventReminder = {
  __typename?: 'EventReminder'
  autoSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  kind: EventReminderKindEnum
  mode: EventReminderModeEnum
  /** Guests this reminder has already been sent to */
  queuedCount: Scalars['Int']['output']
  /** Confirmed guests with an email address */
  recipientCount: Scalars['Int']['output']
  /** When it goes out if automatic */
  sendsAt: Scalars['ISO8601DateTime']['output']
  /** Why it can't be sent, if it can't */
  unavailableReason?: Maybe<Scalars['String']['output']>
}

export enum EventReminderKindEnum {
  Day = 'DAY',
  Week = 'WEEK',
}

export enum EventReminderModeEnum {
  /** Sent at 9am event time, a week or a day before */
  Automatic = 'AUTOMATIC',
  /** Only sent when someone presses Send */
  Manual = 'MANUAL',
}

export type EventSettings = {
  __typename?: 'EventSettings'
  /** Default T&Cs link for new events */
  termsUrl?: Maybe<Scalars['String']['output']>
  /** Default T&Cs version for new events */
  termsVersion?: Maybe<Scalars['String']['output']>
  /** Upcoming events whose T&Cs match the current default */
  upcomingEventsUsingDefaultCount: Scalars['Int']['output']
}

export enum EventStatusEnum {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  /** Retreats only: collecting interest before registration opens */
  SaveTheDate = 'SAVE_THE_DATE',
}

export enum EventTypeEnum {
  Dinner = 'DINNER',
  Gathering = 'GATHERING',
  Retreat = 'RETREAT',
  Webinar = 'WEBINAR',
}

export enum EventWebsitePageStatusEnum {
  /** The page exists in Strapi but isn't published yet */
  Draft = 'DRAFT',
  NotFound = 'NOT_FOUND',
  Published = 'PUBLISHED',
  /** Strapi couldn't be checked */
  Unknown = 'UNKNOWN',
}

export type EventsSummary = {
  __typename?: 'EventsSummary'
  pastCount: Scalars['Int']['output']
  upcomingCount: Scalars['Int']['output']
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  baseCurrency: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  currency: Scalars['String']['output']
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  rate: Scalars['Float']['output']
  source: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  validFrom: Scalars['ISO8601Date']['output']
  validTo: Scalars['ISO8601Date']['output']
}

/** ExchangeRateCollection type */
export type ExchangeRateCollection = {
  __typename?: 'ExchangeRateCollection'
  /** A collection of paginated ExchangeRateCollection */
  collection: Array<ExchangeRate>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type FeatureFlagChangeInput = {
  enabled: Scalars['Boolean']['input']
  featureFlag: FeatureFlagEnum
}

export enum FeatureFlagEnum {
  EstimatedImpact = 'EstimatedImpact',
  GivingGame = 'GivingGame',
  GrantFlowGrantToHifo = 'GrantFlowGrantToHifo',
  HideDafAccess = 'HideDAFAccess',
  HifoWrapped = 'HifoWrapped',
  ImpactReport = 'ImpactReport',
  InvestedFpiDaf = 'InvestedFpiDaf',
  LogExternalGrant = 'LogExternalGrant',
  NewHomePage = 'NewHomePage',
  NewPledgeFlow = 'NewPledgeFlow',
  OnboardingFlow = 'OnboardingFlow',
  SeeManageDafAdvisorsSection = 'SeeManageDafAdvisorsSection',
  SeeNptMigration = 'SeeNPTMigration',
}

export enum FeeCaseStatus {
  /** created */
  Created = 'created',
  /** error */
  Error = 'error',
  /** not_applicable */
  NotApplicable = 'not_applicable',
  /** queued */
  Queued = 'queued',
  /** reviewing */
  Reviewing = 'reviewing',
}

export enum FeeTypeEnum {
  AdminFee = 'ADMIN_FEE',
  BankTransactionFee = 'BANK_TRANSACTION_FEE',
  InternationalFee = 'INTERNATIONAL_FEE',
  PrivateShareOnboardingFee = 'PRIVATE_SHARE_ONBOARDING_FEE',
  RestrictedSecuritiesContributionFee = 'RESTRICTED_SECURITIES_CONTRIBUTION_FEE',
}

export enum FilterOperatorEnum {
  /** ILIKE %%value%% match */
  Contains = 'CONTAINS',
  /** ILIKE %%value match */
  EndsWith = 'ENDS_WITH',
  /** Equal to */
  Eq = 'EQ',
  /** Check for boolean value of false */
  False = 'FALSE',
  /** Greater than */
  Gt = 'GT',
  /** Greater than or equal to */
  Gte = 'GTE',
  /** Check for not null */
  IsNotNull = 'IS_NOT_NULL',
  /** Check for null */
  IsNull = 'IS_NULL',
  /** Less than */
  Lt = 'LT',
  /** Less than or equal to */
  Lte = 'LTE',
  /** Not equal to */
  Neq = 'NEQ',
  /** ILIKE value%% match */
  StartsWith = 'STARTS_WITH',
  /** Check for boolean value of true */
  True = 'TRUE',
}

export type Fund = {
  __typename?: 'Fund'
  adminFeeExemption: Scalars['Boolean']['output']
  closedDate?: Maybe<Scalars['ISO8601Date']['output']>
  dafAdvisors: Array<DafAdvisor>
  dafPlan?: Maybe<PlanEnum>
  feeStartDate?: Maybe<Scalars['ISO8601Date']['output']>
  fundAccounts: Array<FundAccount>
  fundGroup?: Maybe<FundGroup>
  fundManagers: Array<FundManager>
  fundRating?: Maybe<Scalars['Int']['output']>
  fundRecordType: FundRecord
  fundStatus: FundStatusEnum
  fundTheme?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  impactReportingContact?: Maybe<Contact>
  investmentAllocation?: Maybe<InvestmentAllocation>
  legacyPlan: LegacyPlanEnum
  legacyPlanNotes?: Maybe<Scalars['String']['output']>
  legalEntity: LegalEntityAdmin
  name: Scalars['String']['output']
  notes?: Maybe<Scalars['String']['output']>
  openDate?: Maybe<Scalars['ISO8601Date']['output']>
  preferredName?: Maybe<Scalars['String']['output']>
  processingFeeExemption: Scalars['Boolean']['output']
  registeredInvestmentAdvisor?: Maybe<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  worldview?: Maybe<Scalars['String']['output']>
}

export type FundAccount = {
  __typename?: 'FundAccount'
  availableForGrantMaking: Money
  currency: Scalars['String']['output']
  fees: Money
  fund: Fund
  id: Scalars['ID']['output']
  incoming: Money
  investmentActivity: Money
  outgoing: Money
  pendingFees: Money
  pendingOutgoingGrants: Money
  sageCode?: Maybe<Scalars['String']['output']>
  totalClearedBalance: Money
  totalClearedIncoming: Money
  totalClearedOutgoing: Money
  totalIlliquidBalance: Money
  totalLiquidBalance: Money
  totalWorkingBalance: Money
  totalWorkingIncoming: Money
  totalWorkingOutgoing: Money
}

export type FundAccountAverageMonthlyBalance = {
  __typename?: 'FundAccountAverageMonthlyBalance'
  averageDailyBalance: Money
  averageDailyLiquidBalance: Money
  dafPlan?: Maybe<PlanEnum>
  dailyBalances: Array<DailyBalance>
  endDate: Scalars['ISO8601Date']['output']
  fund: Fund
  fundAccount: FundAccount
  hifoTotal: Money
  id: Scalars['ID']['output']
  investmentAllocation?: Maybe<InvestmentAllocation>
  monthEndBalance: Money
  opexTotal: Money
  startDate: Scalars['ISO8601Date']['output']
}

/** FundAccountAverageMonthlyBalanceCollection type */
export type FundAccountAverageMonthlyBalanceCollection = {
  __typename?: 'FundAccountAverageMonthlyBalanceCollection'
  /** A collection of paginated FundAccountAverageMonthlyBalanceCollection */
  collection: Array<FundAccountAverageMonthlyBalance>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

/** FundAccountCollection type */
export type FundAccountCollection = {
  __typename?: 'FundAccountCollection'
  /** A collection of paginated FundAccountCollection */
  collection: Array<FundAccount>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type FundAdminFee = {
  __typename?: 'FundAdminFee'
  applicableDafPlan: Scalars['String']['output']
  averageDailyBalanceGross: Money
  averageDailyBalanceNet: Money
  baseCurrency: Scalars['String']['output']
  calculationData?: Maybe<CalculationData>
  caseStatus: FeeCaseStatus
  endDate: Scalars['ISO8601Date']['output']
  equivalentYearlyFee: Money
  feeStartDate?: Maybe<Scalars['ISO8601Date']['output']>
  feeWaived: Scalars['Boolean']['output']
  feeWaivedReasons?: Maybe<Array<Scalars['String']['output']>>
  fund: Fund
  fundAccountAdminFees: Array<DafAdminFee>
  hifoDiscount: Money
  hifoTotal: Money
  id: Scalars['ID']['output']
  monthlyFee: Money
  opexTotal: Money
  period: DafAdminFeePeriod
  startDate: Scalars['ISO8601Date']['output']
}

export enum FundCategory {
  Funds = 'FUNDS',
  Unrestricted = 'UNRESTRICTED',
}

/** FundCollection type */
export type FundCollection = {
  __typename?: 'FundCollection'
  /** A collection of paginated FundCollection */
  collection: Array<Fund>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum FundFilterFieldEnum {
  ClosedDate = 'CLOSED_DATE',
  DafPlan = 'DAF_PLAN',
  FundStatus = 'FUND_STATUS',
  ImpactReportingContact = 'IMPACT_REPORTING_CONTACT',
  LegacyPlan = 'LEGACY_PLAN',
  Name = 'NAME',
  OpenDate = 'OPEN_DATE',
}

export type FundGroup = {
  __typename?: 'FundGroup'
  funds: Array<Fund>
  groupType?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

/** FundGroupCollection type */
export type FundGroupCollection = {
  __typename?: 'FundGroupCollection'
  /** A collection of paginated FundGroupCollection */
  collection: Array<FundGroup>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type FundManager = {
  __typename?: 'FundManager'
  employee: Employee
  fund: Fund
  id: Scalars['ID']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export type FundRecord = {
  __typename?: 'FundRecord'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export enum FundStatusEnum {
  Active = 'active',
  Closed = 'closed',
  Inactive = 'inactive',
}

export type FundToFundTransfer = {
  __typename?: 'FundToFundTransfer'
  amount: Money
  createdDate: Scalars['ISO8601Date']['output']
  displayName: Scalars['String']['output']
  id: Scalars['String']['output']
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  recipientFundId: Scalars['String']['output']
  senderFundId: Scalars['String']['output']
  status: GrantStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
  transferType: FundToFundTransferEnum
}

export enum FundToFundTransferEnum {
  DafToDaf = 'DafToDaf',
  ImpactMultiplierTransfer = 'ImpactMultiplierTransfer',
  Unknown = 'Unknown',
}

/** Autogenerated input type of GenerateAllDafStatements */
export type GenerateAllDafStatementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dafStatementInput: DafStatementInput
}

/** Autogenerated return type of GenerateAllDafStatements. */
export type GenerateAllDafStatementsPayload = {
  __typename?: 'GenerateAllDafStatementsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of GenerateSalesforceCasesForAccountPerformance */
export type GenerateSalesforceCasesForAccountPerformanceInput = {
  accountPerformanceId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of GenerateSalesforceCasesForAccountPerformance. */
export type GenerateSalesforceCasesForAccountPerformancePayload = {
  __typename?: 'GenerateSalesforceCasesForAccountPerformancePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated input type of GenerateSalesforceCasesForPeriod */
export type GenerateSalesforceCasesForPeriodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  periodId: Scalars['ID']['input']
}

/** Autogenerated return type of GenerateSalesforceCasesForPeriod. */
export type GenerateSalesforceCasesForPeriodPayload = {
  __typename?: 'GenerateSalesforceCasesForPeriodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

export enum GenerationStatus {
  /** error */
  Error = 'error',
  /** generating */
  Generating = 'generating',
  /** published */
  Published = 'published',
  /** publishing */
  Publishing = 'publishing',
  /** queued */
  Queued = 'queued',
  /** reviewing */
  Reviewing = 'reviewing',
}

export type GiftAccountBalance = {
  __typename?: 'GiftAccountBalance'
  currency: Scalars['String']['output']
  fundAccountBalance: Money
  fundAccountId?: Maybe<Scalars['String']['output']>
  fundAccountName?: Maybe<Scalars['String']['output']>
  fundCategory?: Maybe<FundCategory>
  fundId?: Maybe<Scalars['String']['output']>
  fundOpenedDate?: Maybe<Scalars['ISO8601Date']['output']>
  fundRecordType?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isException?: Maybe<Scalars['Boolean']['output']>
  legalEntity?: Maybe<Scalars['String']['output']>
  sageBalance: Money
  sageGiftAccountId?: Maybe<Scalars['String']['output']>
  sageId?: Maybe<Scalars['String']['output']>
  sageName?: Maybe<Scalars['String']['output']>
  totalDiscrepancy: Money
}

export type GiftAid = {
  __typename?: 'GiftAid'
  amount: Money
  contribution: Contribution
  createdDate: Scalars['ISO8601Date']['output']
  displayName: Scalars['String']['output']
  giftAccountId: Scalars['String']['output']
  id: Scalars['String']['output']
  legalEntity: LegalEntity
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  status: GiftAidStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
}

export enum GiftAidStatus {
  /** Gift Aid declaration signed */
  DeclarationSigned = 'DECLARATION_SIGNED',
  /** Declaration submitted to HMRC */
  DeclarationSubmitted = 'DECLARATION_SUBMITTED',
  /** Funds received */
  FundsReceived = 'FUNDS_RECEIVED',
  /** Gift Aid notified */
  GiftAidNotified = 'GIFT_AID_NOTIFIED',
}

export type GivingPreferences = {
  __typename?: 'GivingPreferences'
  annualGivingBudget?: Maybe<Scalars['String']['output']>
  causeAreaFlexibility?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use cause_areas instead */
  causeAreaGroups?: Maybe<Array<Scalars['String']['output']>>
  causeAreas: Array<Scalars['String']['output']>
  givingPriorities: Array<Scalars['String']['output']>
  grantFrequency?: Maybe<Scalars['String']['output']>
  riskAversion?: Maybe<Scalars['Int']['output']>
  timeHorizon?: Maybe<Scalars['Int']['output']>
}

export type GivingPreferencesInput = {
  annualGivingBudget?: InputMaybe<Scalars['String']['input']>
  causeAreaFlexibility?: InputMaybe<Scalars['Int']['input']>
  causeAreas?: InputMaybe<Array<Scalars['String']['input']>>
  givingPriorities?: InputMaybe<Array<Scalars['String']['input']>>
  grantFrequency?: InputMaybe<Scalars['String']['input']>
  riskAversion?: InputMaybe<Scalars['Int']['input']>
  timeHorizon?: InputMaybe<Scalars['Int']['input']>
}

export enum GivingRecommendationType {
  Fund = 'FUND',
  Hifo = 'HIFO',
  Opex = 'OPEX',
}

export type GlobalSearchHit = {
  __typename?: 'GlobalSearchHit'
  extraData?: Maybe<Array<Scalars['String']['output']>>
  label: Scalars['String']['output']
  recordId: Scalars['ID']['output']
  recordType: GlobalSearchRecordTypeEnum
}

export enum GlobalSearchRecordTypeEnum {
  AmendedPledge = 'AMENDED_PLEDGE',
  CaseRecord = 'CASE_RECORD',
  Charity = 'CHARITY',
  CharityBankAccount = 'CHARITY_BANK_ACCOUNT',
  CharityCategory = 'CHARITY_CATEGORY',
  Company = 'COMPANY',
  Contact = 'CONTACT',
  Contribution = 'CONTRIBUTION',
  Employee = 'EMPLOYEE',
  Event = 'EVENT',
  Fees = 'FEES',
  Fund = 'FUND',
  Grant = 'GRANT',
  Hifo = 'HIFO',
  HifoCascade = 'HIFO_CASCADE',
  MatchCampaign = 'MATCH_CAMPAIGN',
  MatchCampaignCategory = 'MATCH_CAMPAIGN_CATEGORY',
  NewsItem = 'NEWS_ITEM',
  Policy = 'POLICY',
  ProvisionalPledge = 'PROVISIONAL_PLEDGE',
  Role = 'ROLE',
  TargetAudience = 'TARGET_AUDIENCE',
  TrainingModule = 'TRAINING_MODULE',
  User = 'USER',
}

export type GrantAdmin = {
  __typename?: 'GrantAdmin'
  amount: Money
  charityHqCountry?: Maybe<Scalars['Country']['output']>
  charityName: Scalars['String']['output']
  createdDate: Scalars['ISO8601DateTime']['output']
  displayName: Scalars['String']['output']
  giftAccountId?: Maybe<Scalars['String']['output']>
  givingRecommendationType?: Maybe<GivingRecommendationType>
  hifo?: Maybe<HifoAdmin>
  highImpactAtTimeOfDeployment: Scalars['Boolean']['output']
  id: Scalars['String']['output']
  impact?: Maybe<ImpactData>
  legalEntity?: Maybe<LegalEntity>
  matchCampaigns: Array<MatchCampaign>
  origin: Scalars['String']['output']
  primaryCauseArea?: Maybe<Scalars['String']['output']>
  primaryCauseAreaGroup?: Maybe<Scalars['String']['output']>
  status: GrantStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
  usdAmount: Money
}

/** Autogenerated input type of GrantAdminPortalAccess */
export type GrantAdminPortalAccessInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeId?: InputMaybe<Scalars['ID']['input']>
  userId?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of GrantAdminPortalAccess. */
export type GrantAdminPortalAccessPayload = {
  __typename?: 'GrantAdminPortalAccessPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  employeeId?: Maybe<Scalars['ID']['output']>
  userId: Scalars['ID']['output']
}

export type GrantBasketItemAdmin = {
  __typename?: 'GrantBasketItemAdmin'
  amount: Money
  anythingElse?: Maybe<Scalars['String']['output']>
  charityCampaignSalesforceId?: Maybe<Scalars['String']['output']>
  charityCountry?: Maybe<Scalars['String']['output']>
  charityName: Scalars['String']['output']
  charityWebsite?: Maybe<Scalars['String']['output']>
  createdDate: Scalars['ISO8601Date']['output']
  /** Member-facing label for this grant basket item (e.g. 'Grant to Charity Name' or 'Top up Match Split pot') */
  displayName: Scalars['String']['output']
  giftAccountId: Scalars['String']['output']
  /** The method used to create the grant. If null, the grant was created before this field was added. */
  grantCreationMethod?: Maybe<GrantCreationMethod>
  grantFormSource?: Maybe<GrantFormSource>
  grantRestrictions?: Maybe<Scalars['String']['output']>
  hifo?: Maybe<HifoAdmin>
  id: Scalars['String']['output']
  lastErrorMessage?: Maybe<Scalars['String']['output']>
  legalEntity: LegalEntity
  matchCampaigns: Array<MatchCampaign>
  onBehalfOfEmail?: Maybe<Scalars['String']['output']>
  onBehalfOfName?: Maybe<Scalars['String']['output']>
  otherGrantAcknowledgementLetterRecipients: Array<Scalars['String']['output']>
  reasonForHifoGrant?: Maybe<Array<GrantReasonForHifo>>
  reasonForHifoGrantAdditional?: Maybe<Scalars['String']['output']>
  recurringGrantFrequency?: Maybe<RecurringGrantFrequency>
  reference?: Maybe<Scalars['String']['output']>
  shareEmail: Scalars['Boolean']['output']
  shareName: Scalars['Boolean']['output']
  sharedEmail?: Maybe<Scalars['String']['output']>
  status: GrantBasketItemStatus
  userFirstName?: Maybe<Scalars['String']['output']>
  userId: Scalars['String']['output']
  userSurname?: Maybe<Scalars['String']['output']>
  /** If true, the grant was processed immediately and wasn't stored in user's grant basket. If false, the grant was stored in user's grant basket before processing. If null, the grant was processed before this field was added. */
  wasProcessedImmediately?: Maybe<Scalars['Boolean']['output']>
}

/** GrantBasketItemAdminCollection type */
export type GrantBasketItemAdminCollection = {
  __typename?: 'GrantBasketItemAdminCollection'
  /** A collection of paginated GrantBasketItemAdminCollection */
  collection: Array<GrantBasketItemAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum GrantBasketItemStatus {
  Basket = 'BASKET',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
}

export enum GrantBasketItemsSearchEnum {
  All = 'All',
  Basket = 'BASKET',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
}

export type GrantCaseRecord = {
  __typename?: 'GrantCaseRecord'
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  cancelledReason?: Maybe<Scalars['String']['output']>
  complianceChecks: Array<GrantComplianceCheck>
  disbursement?: Maybe<ChariotDisbursement>
  grantRiskLevel?: Maybe<GrantRiskLevel>
  id: Scalars['ID']['output']
  readyForRelease: Scalars['Boolean']['output']
  snoozedUntil?: Maybe<Scalars['ISO8601Date']['output']>
  status: GrantCaseRecordStatusEnum
  usDueDiligence?: Maybe<UsDueDiligence>
}

export enum GrantCaseRecordStatusEnum {
  AttentionNeeded = 'ATTENTION_NEEDED',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Disbursing = 'DISBURSING',
  ReadyForRelease = 'READY_FOR_RELEASE',
  Snoozed = 'SNOOZED',
}

export type GrantComplianceCheck = {
  __typename?: 'GrantComplianceCheck'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  name: GrantComplianceCheckNameEnum
  status: GrantComplianceCheckStatusEnum
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum GrantComplianceCheckNameEnum {
  AmountAboveThreshold = 'AMOUNT_ABOVE_THRESHOLD',
  DueDiligencePending = 'DUE_DILIGENCE_PENDING',
  ManuallyCreated = 'MANUALLY_CREATED',
  NonStandardGrantRestrictions = 'NON_STANDARD_GRANT_RESTRICTIONS',
  NotEnoughBalance = 'NOT_ENOUGH_BALANCE',
}

export enum GrantComplianceCheckStatusEnum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum GrantCreationMethod {
  MemberAppGrantFormGrantToFund = 'MemberAppGrantFormGrantToFund',
  MemberAppGrantFormGrantToHifo = 'MemberAppGrantFormGrantToHifo',
  MemberAppGrantFormGrantToNewCharity = 'MemberAppGrantFormGrantToNewCharity',
  MemberAppGrantFormGrantToOpex = 'MemberAppGrantFormGrantToOpex',
  MemberAppGrantFormGrantToPastGrantee = 'MemberAppGrantFormGrantToPastGrantee',
}

export type GrantFilterConditionInput = {
  field: GrantFilterFieldEnum
  operator: FilterOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export enum GrantFilterFieldEnum {
  CaseNumber = 'CASE_NUMBER',
  CaseStage = 'CASE_STAGE',
  CaseType = 'CASE_TYPE',
  CommunityManager = 'COMMUNITY_MANAGER',
  ComplianceCheck = 'COMPLIANCE_CHECK',
  CreatedAt = 'CREATED_AT',
  Description = 'DESCRIPTION',
  GrantRiskLevel = 'GRANT_RISK_LEVEL',
  Owner = 'OWNER',
  RecipientCharity = 'RECIPIENT_CHARITY',
  RecipientFundAccount = 'RECIPIENT_FUND_ACCOUNT',
  SenderAmount = 'SENDER_AMOUNT',
  SenderFundAccount = 'SENDER_FUND_ACCOUNT',
  Status = 'STATUS',
  SyncErrorMessage = 'SYNC_ERROR_MESSAGE',
  TransactionDate = 'TRANSACTION_DATE',
}

export type GrantFilterGroupInput = {
  AND?: InputMaybe<Array<GrantFilterGroupInput>>
  OR?: InputMaybe<Array<GrantFilterGroupInput>>
  conditions?: InputMaybe<Array<GrantFilterConditionInput>>
}

export enum GrantFormSource {
  MemberAppFromFeaturedCta = 'MemberAppFromFeaturedCTA',
  MemberAppFromGermanSpendDownWarningCard = 'MemberAppFromGermanSpendDownWarningCard',
  MemberAppFromImpactEmptyStateCta = 'MemberAppFromImpactEmptyStateCTA',
  MemberAppFromImpactReportCta = 'MemberAppFromImpactReportCTA',
  MemberAppFromMyGivingCta = 'MemberAppFromMyGivingCTA',
  MemberAppFromOurRecommendations = 'MemberAppFromOurRecommendations',
}

export enum GrantReasonForHifo {
  FpEvent = 'FP_EVENT',
  FpNewsletter = 'FP_NEWSLETTER',
  FpResearchReport = 'FP_RESEARCH_REPORT',
  Independently = 'INDEPENDENTLY',
  MyFpAdvisor = 'MY_FP_ADVISOR',
  MyFpCommunityManager = 'MY_FP_COMMUNITY_MANAGER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  WebApp = 'WEB_APP',
}

export type GrantRiskLevel = {
  __typename?: 'GrantRiskLevel'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  reasons?: Maybe<Array<Scalars['String']['output']>>
  tier?: Maybe<GrantRiskLevelTierEnum>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum GrantRiskLevelTierEnum {
  TierFour = 'TIER_FOUR',
  TierOne = 'TIER_ONE',
  TierThree = 'TIER_THREE',
  TierTwo = 'TIER_TWO',
  TierZero = 'TIER_ZERO',
}

export enum GrantStatus {
  /** Grant approved */
  GrantApproved = 'GRANT_APPROVED',
  /** Grant complete */
  GrantComplete = 'GRANT_COMPLETE',
  /** Grant recommendation submitted */
  GrantRequested = 'GRANT_REQUESTED',
  /** Payment sent */
  PaymentSent = 'PAYMENT_SENT',
}

export type Hifo = {
  __typename?: 'Hifo'
  adjustedRoomForFunding?: Maybe<Money>
  charityCategoryIds: Array<Scalars['ID']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  deployedSoFar?: Maybe<Money>
  description?: Maybe<Scalars['String']['output']>
  grantRestrictions?: Maybe<Scalars['String']['output']>
  hifoType?: Maybe<HifoTypeEnum>
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  impactData?: Maybe<ImpactData>
  includeInEstimatedImpactList: Scalars['Boolean']['output']
  includeInGrantRecommendationsList: Scalars['Boolean']['output']
  lastEvaluated?: Maybe<Scalars['ISO8601Date']['output']>
  matchCampaigns: Array<MatchCampaign>
  minDonationAmount?: Maybe<Money>
  name?: Maybe<Scalars['String']['output']>
  operatingAreas?: Maybe<Array<Scalars['String']['output']>>
  primaryCauseArea?: Maybe<Scalars['String']['output']>
  recentGrantors?: Maybe<Array<UserPrivate>>
  recommendationType?: Maybe<GivingRecommendationType>
  roomForFunding?: Maybe<Money>
  totalNumberOfMembersGranted?: Maybe<Scalars['Int']['output']>
  website?: Maybe<Scalars['String']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
  worldview?: Maybe<Scalars['String']['output']>
}

export type HifoAdmin = {
  __typename?: 'HifoAdmin'
  adjustedRoomForFunding?: Maybe<Money>
  approvalStatus?: Maybe<Scalars['String']['output']>
  approver?: Maybe<Employee>
  audience?: Maybe<Scalars['String']['output']>
  charity?: Maybe<Charity>
  charityCategories: Array<HifoCharityCategory>
  charityCategoryIds: Array<Scalars['ID']['output']>
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>
  createdBy?: Maybe<User>
  dateStoppedBeingHifo?: Maybe<Scalars['ISO8601Date']['output']>
  deployedSoFar?: Maybe<Money>
  description?: Maybe<Scalars['String']['output']>
  editHistory: Array<EditHistory>
  evaluationTemplateLink?: Maybe<Scalars['String']['output']>
  evaluator?: Maybe<Employee>
  expiryDate?: Maybe<Scalars['ISO8601Date']['output']>
  firstFullReviewDate?: Maybe<Scalars['ISO8601Date']['output']>
  funds: Array<Fund>
  grantRestrictions?: Maybe<Scalars['String']['output']>
  hifoType?: Maybe<HifoTypeEnum>
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  imageUrl?: Maybe<Scalars['String']['output']>
  impactData?: Maybe<ImpactData>
  includeInEstimatedImpactList: Scalars['Boolean']['output']
  includeInGrantRecommendationsList: Scalars['Boolean']['output']
  includedInEstimatedImpact: Scalars['Boolean']['output']
  includedInGrantRecommendations: Scalars['Boolean']['output']
  isResearchInternal?: Maybe<Scalars['Boolean']['output']>
  lastEvaluated?: Maybe<Scalars['ISO8601Date']['output']>
  matchCampaigns: Array<MatchCampaign>
  minDonationAmount?: Maybe<Money>
  name?: Maybe<Scalars['String']['output']>
  operatingAreas?: Maybe<Array<Scalars['String']['output']>>
  parentCharity?: Maybe<Charity>
  primaryCauseArea?: Maybe<Scalars['String']['output']>
  primaryContact?: Maybe<Scalars['String']['output']>
  primaryContactEmails: Array<Scalars['String']['output']>
  rating?: Maybe<Scalars['Float']['output']>
  recentGrantors?: Maybe<Array<UserPrivate>>
  recommendationType?: Maybe<GivingRecommendationType>
  rejectedReason?: Maybe<Scalars['String']['output']>
  researcherRelationship?: Maybe<Employee>
  reviewer?: Maybe<Employee>
  roomForFunding?: Maybe<Money>
  status?: Maybe<HifoStatus>
  totalNumberOfMembersGranted?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>
  updatedBy?: Maybe<User>
  website?: Maybe<Scalars['String']['output']>
  websiteUrl?: Maybe<Scalars['String']['output']>
  worldview?: Maybe<Scalars['String']['output']>
}

/** HifoAdminCollection type */
export type HifoAdminCollection = {
  __typename?: 'HifoAdminCollection'
  /** A collection of paginated HifoAdminCollection */
  collection: Array<HifoAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type HifoCascade = {
  __typename?: 'HifoCascade'
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdBy?: Maybe<User>
  currentTrancheNumber?: Maybe<Scalars['Int']['output']>
  deadline?: Maybe<Scalars['ISO8601Date']['output']>
  hifo: HifoAdmin
  id: Scalars['ID']['output']
  minimumGrantAmount?: Maybe<Money>
  notes?: Maybe<Scalars['String']['output']>
  owner?: Maybe<Employee>
  pitches: Array<HifoCascadePitch>
  roomForFunding?: Maybe<Money>
  status?: Maybe<HifoCascadeStatusEnum>
  statusChangeNotes?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  updatedBy?: Maybe<User>
}

export type HifoCascadeChangeInput = {
  currentTrancheNumber?: InputMaybe<Scalars['Int']['input']>
  deadline?: InputMaybe<Scalars['ISO8601Date']['input']>
  hifoId?: InputMaybe<Scalars['ID']['input']>
  minimumGrantAmount?: InputMaybe<Scalars['Float']['input']>
  minimumGrantAmountCurrency?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  roomForFunding?: InputMaybe<Scalars['Float']['input']>
  roomForFundingCurrency?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<HifoCascadeStatusEnum>
  statusChangeNotes?: InputMaybe<Scalars['String']['input']>
}

/** HifoCascadeCollection type */
export type HifoCascadeCollection = {
  __typename?: 'HifoCascadeCollection'
  /** A collection of paginated HifoCascadeCollection */
  collection: Array<HifoCascade>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type HifoCascadePitch = {
  __typename?: 'HifoCascadePitch'
  committedAmount?: Maybe<Money>
  contact: Contact
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  createdBy?: Maybe<User>
  deadline?: Maybe<Scalars['ISO8601Date']['output']>
  grantedAmount?: Maybe<Money>
  hifoCascadeId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  owner?: Maybe<Employee>
  pitchMaterials: Array<HifoCascadePitchMaterial>
  pitchNotes: Array<Note>
  pitchedAmount?: Maybe<Money>
  position: Scalars['Int']['output']
  reasonForRejection?: Maybe<Scalars['String']['output']>
  status: HifoCascadePitchStatusEnum
  trancheNumber: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  updatedBy?: Maybe<User>
}

export type HifoCascadePitchChangeInput = {
  committedAmount?: InputMaybe<Scalars['Float']['input']>
  committedAmountCurrency?: InputMaybe<Scalars['String']['input']>
  contactId?: InputMaybe<Scalars['ID']['input']>
  deadline?: InputMaybe<Scalars['ISO8601Date']['input']>
  grantedAmount?: InputMaybe<Scalars['Float']['input']>
  grantedAmountCurrency?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  pitchMaterials?: InputMaybe<Array<HifoCascadePitchMaterialInput>>
  pitchedAmount?: InputMaybe<Scalars['Float']['input']>
  pitchedAmountCurrency?: InputMaybe<Scalars['String']['input']>
  reasonForRejection?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<HifoCascadePitchStatusEnum>
  trancheNumber?: InputMaybe<Scalars['Int']['input']>
}

export type HifoCascadePitchMaterial = {
  __typename?: 'HifoCascadePitchMaterial'
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export type HifoCascadePitchMaterialInput = {
  name?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export enum HifoCascadePitchStatusEnum {
  Current = 'CURRENT',
  Rejected = 'REJECTED',
  Successful = 'SUCCESSFUL',
}

export enum HifoCascadeStatusEnum {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
}

export type HifoChangeInput = {
  approvalStatus?: InputMaybe<ApprovalStatus>
  approverId?: InputMaybe<Scalars['ID']['input']>
  audience?: InputMaybe<Scalars['String']['input']>
  charityCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>
  charityId?: InputMaybe<Scalars['ID']['input']>
  dateStoppedBeingHifo?: InputMaybe<Scalars['ISO8601Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  evaluationTemplateLink?: InputMaybe<Scalars['String']['input']>
  evaluatorId?: InputMaybe<Scalars['ID']['input']>
  expiryDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  firstFullReviewDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>
  grantRestrictions?: InputMaybe<Scalars['String']['input']>
  hifoType?: InputMaybe<HifoTypeEnum>
  includedInEstimatedImpact?: InputMaybe<Scalars['Boolean']['input']>
  includedInGrantRecommendations?: InputMaybe<Scalars['Boolean']['input']>
  isResearchInternal?: InputMaybe<Scalars['Boolean']['input']>
  lastEvaluated?: InputMaybe<Scalars['ISO8601Date']['input']>
  minDonationAmount?: InputMaybe<Scalars['Float']['input']>
  minDonationCurrency?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  operatingAreas?: InputMaybe<Array<Scalars['String']['input']>>
  parentCharityId?: InputMaybe<Scalars['ID']['input']>
  primaryCauseArea?: InputMaybe<PrimaryCauseAreaEnum>
  primaryContact?: InputMaybe<Scalars['String']['input']>
  primaryContactEmails?: InputMaybe<Array<Scalars['String']['input']>>
  rating?: InputMaybe<Scalars['Float']['input']>
  rejectedReason?: InputMaybe<Scalars['String']['input']>
  researcherRelationshipId?: InputMaybe<Scalars['ID']['input']>
  reviewerId?: InputMaybe<Scalars['ID']['input']>
  roomForFunding?: InputMaybe<Scalars['Float']['input']>
  roomForFundingCurrency?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<HifoStatus>
  website?: InputMaybe<Scalars['String']['input']>
  worldview?: InputMaybe<WorldviewEnum>
}

export type HifoCharityCategory = {
  __typename?: 'HifoCharityCategory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export enum HifoStatus {
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Historical = 'HISTORICAL',
  Incomplete = 'INCOMPLETE',
  ReadyForApproval = 'READY_FOR_APPROVAL',
  ReadyForPreVetting = 'READY_FOR_PRE_VETTING',
  Rejected = 'REJECTED',
}

export enum HifoTypeEnum {
  Dynamic = 'DYNAMIC',
  Evergreen = 'EVERGREEN',
  FpFund = 'FP_FUND',
  Opex = 'OPEX',
}

/** Autogenerated input type of IgnoreSageGiftAccountDifferences */
export type IgnoreSageGiftAccountDifferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
  note?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of IgnoreSageGiftAccountDifferences. */
export type IgnoreSageGiftAccountDifferencesPayload = {
  __typename?: 'IgnoreSageGiftAccountDifferencesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  results: Array<SageGiftAccountDifferenceActionResult>
}

export type ImpactData = {
  __typename?: 'ImpactData'
  achievements?: Maybe<Array<ImpactDataRecordAchievements>>
  areQuantitativeFiguresAvailable: Scalars['Boolean']['output']
  causeAreaInsights?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['String']['output']>
  hifo?: Maybe<Hifo>
  id: Scalars['ID']['output']
  intervention?: Maybe<Scalars['String']['output']>
  majorAchievements?: Maybe<Scalars['String']['output']>
  records?: Maybe<Array<ImpactDataRecord>>
  stories?: Maybe<Scalars['String']['output']>
  whyWeRecommend?: Maybe<Scalars['String']['output']>
}

export type ImpactDataRecord = {
  __typename?: 'ImpactDataRecord'
  /** Description for the value. i.e 6 Lives Saved. */
  description?: Maybe<Scalars['String']['output']>
  /** The icon to use for this impact record. */
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** Used to calculate an lower bound (mainly for climate impact). i.e. 6 lives save, which a lower bound of 2 lives. */
  lowerBounds?: Maybe<Scalars['Float']['output']>
  /** The type of impact */
  recordType: ImpactDataRecordTypeEnum
  /** The order in which to display the records. */
  sortOrder: Scalars['Int']['output']
  /** Static means that we use the value without multiplying it by the grant amount. */
  static: Scalars['Boolean']['output']
  /** The updates reflect the changes to the value over time as more research is completed. I.e. 8 lives saved after 2021/01/01 as opposed to 6 before. */
  updates?: Maybe<Array<ImpactDataRecordItemUpdate>>
  /** Used to calculate an upper bound (mainly for climate impact). i.e. 6 lives save, which a upper bound of 10 lives. */
  upperBounds?: Maybe<Scalars['Float']['output']>
  /** The impact delta i.e. this number is multiplied by the Grant value to calculated estimated impact. */
  value?: Maybe<Scalars['Float']['output']>
  /** The type of value, i.e. number, percentage, currency */
  valueType: ImpactDataRecordItemValueTypeEnum
}

export type ImpactDataRecordAchievements = {
  __typename?: 'ImpactDataRecordAchievements'
  description: Scalars['String']['output']
  icon: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type ImpactDataRecordItemUpdate = {
  __typename?: 'ImpactDataRecordItemUpdate'
  fromDate: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  lowerBounds?: Maybe<Scalars['Float']['output']>
  upperBounds?: Maybe<Scalars['Float']['output']>
  value: Scalars['Float']['output']
}

export enum ImpactDataRecordItemValueTypeEnum {
  Currency = 'Currency',
  Number = 'Number',
  Percentage = 'Percentage',
}

export enum ImpactDataRecordTypeEnum {
  Baseline = 'Baseline',
  Impact = 'Impact',
  Outcome = 'Outcome',
  Output = 'Output',
}

export type ImpactMeasurementCategory = {
  __typename?: 'ImpactMeasurementCategory'
  headingColour: Scalars['String']['output']
  id: Scalars['ID']['output']
  items: Array<ImpactMeasurementItem>
  title: Scalars['String']['output']
}

export type ImpactMeasurementCategoryInput = {
  headingColour: Scalars['String']['input']
  title: Scalars['String']['input']
}

export type ImpactMeasurementItem = {
  __typename?: 'ImpactMeasurementItem'
  description: Scalars['String']['output']
  example?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  impactMeasurementCategoryId?: Maybe<Scalars['String']['output']>
  readMore?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ImpactMeasurementItemInput = {
  description: Scalars['String']['input']
  example?: InputMaybe<Scalars['String']['input']>
  impactMeasurementCategoryId: Scalars['String']['input']
  readMore?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
}

export type ImpactRecordAchievementInput = {
  description: Scalars['String']['input']
  icon: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
}

export type ImpactRecordInput = {
  achievements?: InputMaybe<Array<ImpactRecordAchievementInput>>
  areQuantitativeFiguresAvailable: Scalars['Boolean']['input']
  causeAreaInsights?: InputMaybe<Scalars['String']['input']>
  goal?: InputMaybe<Scalars['String']['input']>
  hifoId: Scalars['ID']['input']
  intervention?: InputMaybe<Scalars['String']['input']>
  items?: InputMaybe<Array<ImpactRecordItemInput>>
  majorAchievements?: InputMaybe<Scalars['String']['input']>
  stories?: InputMaybe<Scalars['String']['input']>
  whyWeRecommend?: InputMaybe<Scalars['String']['input']>
}

export type ImpactRecordItemInput = {
  description?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lowerBounds?: InputMaybe<Scalars['Float']['input']>
  recordType: ImpactDataRecordTypeEnum
  sortOrder: Scalars['Int']['input']
  static: Scalars['Boolean']['input']
  updates?: InputMaybe<Array<ImpactRecordItemUpdateInput>>
  upperBounds?: InputMaybe<Scalars['Float']['input']>
  value: Scalars['Float']['input']
  valueType: ImpactDataRecordItemValueTypeEnum
}

export type ImpactRecordItemUpdateInput = {
  fromDate: Scalars['ISO8601Date']['input']
  id?: InputMaybe<Scalars['String']['input']>
  lowerBounds?: InputMaybe<Scalars['Float']['input']>
  upperBounds?: InputMaybe<Scalars['Float']['input']>
  value: Scalars['Float']['input']
}

export type InvestmentAccountPerformance = {
  __typename?: 'InvestmentAccountPerformance'
  accumulativeReturnsForPeriod: Scalars['Float']['output']
  caseStatus: CaseStatus
  changeInMarketValue: Scalars['Float']['output']
  closingBalance: Scalars['Float']['output']
  closingPrinciple: Scalars['Float']['output']
  description: Scalars['String']['output']
  dividendAndInterest: Scalars['Float']['output']
  fees: Scalars['Float']['output']
  fundAccount?: Maybe<FundAccount>
  id: Scalars['ID']['output']
  netReturnsForPeriod: Scalars['Float']['output']
  openingBalance: Scalars['Float']['output']
  openingPrinciple: Scalars['Float']['output']
  openingUnrealisedGainsLossesCumulative: Scalars['Float']['output']
  poolPerformance: InvestmentPoolPerformance
  realisedGainsLosses: Scalars['Float']['output']
  salesforceCaseId?: Maybe<Scalars['String']['output']>
  totalContributionsForPeriod: Scalars['Float']['output']
  totalGrantsForPeriod: Scalars['Float']['output']
  totalWeightedContributionsForPeriod: Scalars['Float']['output']
  totalWeightedGrantsForPeriod: Scalars['Float']['output']
}

export enum InvestmentAllocation {
  Balanced = 'BALANCED',
  Conservative = 'CONSERVATIVE',
  DafMain = 'DAF_MAIN',
  Dynamic = 'DYNAMIC',
  ExternallyManagedFund = 'EXTERNALLY_MANAGED_FUND',
  LiquidityFund = 'LIQUIDITY_FUND',
  Moderate = 'MODERATE',
  ModerateAggressive = 'MODERATE_AGGRESSIVE',
  MoneyMarket = 'MONEY_MARKET',
  OpexMmf = 'OPEX_MMF',
  OpexShortDuration = 'OPEX_SHORT_DURATION',
  ShortDurationFund = 'SHORT_DURATION_FUND',
  TreasuryMoneyMarket = 'TREASURY_MONEY_MARKET',
}

export type InvestmentAllocationChange = {
  __typename?: 'InvestmentAllocationChange'
  newInvestmentAllocation: InvestmentAllocation
  submittedBy: UserPrivate
}

export type InvestmentDailyBalance = {
  __typename?: 'InvestmentDailyBalance'
  balance: Money
  date: Scalars['ISO8601Date']['output']
  fundAccountId: Scalars['ID']['output']
  fundId: Scalars['ID']['output']
  fundName: Scalars['String']['output']
  fundSalesforceId: Scalars['String']['output']
  legalEntityName: Scalars['String']['output']
  month: Scalars['String']['output']
}

export type InvestmentPeriod = {
  __typename?: 'InvestmentPeriod'
  closingDate: Scalars['ISO8601Date']['output']
  id: Scalars['ID']['output']
  lockedDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  name: Scalars['String']['output']
  openingDate: Scalars['ISO8601Date']['output']
}

export type InvestmentPool = {
  __typename?: 'InvestmentPool'
  accountNumber: Scalars['String']['output']
  currency: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  legalEntity: LegalEntityAdmin
  name: Scalars['String']['output']
  opexFloatFundAccount?: Maybe<FundAccount>
  salesforceId: InvestmentAllocation
}

export type InvestmentPoolInput = {
  accountNumber: Scalars['String']['input']
  currency: Scalars['String']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  legalEntityId: Scalars['ID']['input']
  name: Scalars['String']['input']
  opexFloatFundAccountId: Scalars['ID']['input']
  salesforceId: InvestmentAllocation
}

export type InvestmentPoolPerformance = {
  __typename?: 'InvestmentPoolPerformance'
  changeInMarketValue: Scalars['Float']['output']
  closingBalance: Scalars['Float']['output']
  closingBalanceOfAccountPerformances: Scalars['Float']['output']
  dividendAndInterest: Scalars['Float']['output']
  fees: Scalars['Float']['output']
  floatDelta: Scalars['Float']['output']
  id: Scalars['ID']['output']
  openingBalance: Scalars['Float']['output']
  period: InvestmentPeriod
  pool: InvestmentPool
  returnForPeriod: Scalars['Float']['output']
  totalReturnForPeriod: Scalars['Float']['output']
  weightedContributionsTotal: Scalars['Float']['output']
  weightedGrantsTotal: Scalars['Float']['output']
  weightedTotal: Scalars['Float']['output']
}

export type InvestmentPoolPerformanceInput = {
  changeInMarketValue: Scalars['Float']['input']
  closingBalance: Scalars['Float']['input']
  dividendAndInterest: Scalars['Float']['input']
  fees: Scalars['Float']['input']
  floatDelta: Scalars['Float']['input']
  id?: InputMaybe<Scalars['ID']['input']>
  openingBalance: Scalars['Float']['input']
}

export type InvestmentReturn = {
  __typename?: 'InvestmentReturn'
  amount: Money
  createdDate: Scalars['ISO8601Date']['output']
  displayName: Scalars['String']['output']
  id: Scalars['String']['output']
  matchCampaigns: Array<MatchCampaign>
  name: Scalars['String']['output']
  status: InvestmentReturnStatus
  submittedBy?: Maybe<Scalars['String']['output']>
  transferDate?: Maybe<Scalars['ISO8601Date']['output']>
}

export enum InvestmentReturnStatus {
  /** Returns posted */
  ReturnsPosted = 'RETURNS_POSTED',
}

/** Autogenerated input type of InviteCharityContact */
export type InviteCharityContactInput = {
  addresseeType?: InputMaybe<CharityContactInvitationAddresseeTypeEnum>
  charityId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<CharityContactEnum>
  surname?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of InviteCharityContact. */
export type InviteCharityContactPayload = {
  __typename?: 'InviteCharityContactPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of InviteGuests */
export type InviteGuestsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Pasted text containing the email addresses */
  emails: Scalars['String']['input']
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of InviteGuests. */
export type InviteGuestsPayload = {
  __typename?: 'InviteGuestsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  result: EventInviteResult
}

export type LegacyDueDiligence = {
  __typename?: 'LegacyDueDiligence'
  createdAt: Scalars['ISO8601DateTime']['output']
  salesforceId?: Maybe<Scalars['String']['output']>
}

export enum LegacyPlanEnum {
  Allocated = 'Allocated',
  NotAllocated = 'NotAllocated',
}

export enum LegalEntity {
  Fpi = 'FPI',
  Fpuk = 'FPUK',
  Germany = 'GERMANY',
  NonFpRelated = 'NON_FP_RELATED',
  Npt = 'NPT',
}

export type LegalEntityAdmin = {
  __typename?: 'LegalEntityAdmin'
  currencies?: Maybe<Array<Scalars['String']['output']>>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  sageId?: Maybe<Scalars['String']['output']>
  salesforceName?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of LinkSageTransactionRecord */
export type LinkSageTransactionRecordInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  sageJournalEntryId: Scalars['ID']['input']
}

/** Autogenerated return type of LinkSageTransactionRecord. */
export type LinkSageTransactionRecordPayload = {
  __typename?: 'LinkSageTransactionRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated input type of LockDafAdminFeePeriod */
export type LockDafAdminFeePeriodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of LockDafAdminFeePeriod. */
export type LockDafAdminFeePeriodPayload = {
  __typename?: 'LockDafAdminFeePeriodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  dafAdminFeePeriod?: Maybe<DafAdminFeePeriod>
}

/** Autogenerated input type of LockInvestmentPeriod */
export type LockInvestmentPeriodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of LockInvestmentPeriod. */
export type LockInvestmentPeriodPayload = {
  __typename?: 'LockInvestmentPeriodPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  investmentPeriod?: Maybe<InvestmentPeriod>
}

export type MatchCampaign = {
  __typename?: 'MatchCampaign'
  campaignIcon?: Maybe<Scalars['String']['output']>
  campaignTagText?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  matchCampaignCategory: MatchCampaignCategory
  salesforceId: Scalars['String']['output']
  /** null means that all legal entities are supported */
  supportedLegalEntities?: Maybe<Array<LegalEntity>>
  totalMatchPoolBalance: Money
}

export type MatchCampaignAdmin = {
  __typename?: 'MatchCampaignAdmin'
  active: Scalars['Boolean']['output']
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>
  hifos: Array<HifoAdmin>
  id: Scalars['ID']['output']
  matchCampaignCategory: MatchCampaignCategory
  name: Scalars['String']['output']
  salesforceFundIds: Array<Scalars['String']['output']>
  salesforceId: Scalars['String']['output']
  startDate: Scalars['ISO8601DateTime']['output']
  targetAudience: TargetAudience
}

export type MatchCampaignCategory = {
  __typename?: 'MatchCampaignCategory'
  categoryType: MatchCampaignCategoryTypeEnum
  colour: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  showAgainstTransactions: Scalars['Boolean']['output']
  tagText?: Maybe<Scalars['String']['output']>
}

export type MatchCampaignCategoryInput = {
  categoryType?: InputMaybe<MatchCampaignCategoryTypeEnum>
  colour: Scalars['String']['input']
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  showAgainstTransactions: Scalars['Boolean']['input']
  tagText?: InputMaybe<Scalars['String']['input']>
}

export enum MatchCampaignCategoryTypeEnum {
  ExternalMatch = 'ExternalMatch',
  ImpactMultiplier = 'ImpactMultiplier',
  OpexMatch = 'OpexMatch',
}

export type MatchCampaignInput = {
  active: Scalars['Boolean']['input']
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  hifoIds?: InputMaybe<Array<Scalars['String']['input']>>
  id?: InputMaybe<Scalars['String']['input']>
  matchCampaignCategoryId: Scalars['String']['input']
  name: Scalars['String']['input']
  salesforceFundIds?: InputMaybe<Array<Scalars['String']['input']>>
  salesforceId: Scalars['String']['input']
  startDate: Scalars['ISO8601DateTime']['input']
  targetAudienceId: Scalars['String']['input']
}

export type MemberAppSettings = {
  __typename?: 'MemberAppSettings'
  completedCustomizationCardsInFpJourneySection: Scalars['Boolean']['output']
  ctaPanelStatus: Scalars['String']['output']
  germanDafSpendDownCardStatus: Scalars['String']['output']
  hasDismissedCompleteOnboardingCta: Scalars['Boolean']['output']
  hasDismissedGivingSeasonDeadlinesBanner2024: Scalars['Boolean']['output']
  hasSeenCauseAreaGroupsAlert: Scalars['Boolean']['output']
  howManyTimesDismissedSignTcsModal: Scalars['Int']['output']
  howManyTimesSeenAddAdvisorBanner: Scalars['Int']['output']
  onboardingCompletedCauseAreasStep: Scalars['Boolean']['output']
  onboardingCompletedProfileStep: Scalars['Boolean']['output']
  onboardingCompletedSlideshowStep: Scalars['Boolean']['output']
  onboardingCompletedWelcomeCallStep: Scalars['Boolean']['output']
  ourRecommendationsDismissedFundsCta: Scalars['Boolean']['output']
  ourRecommendationsDismissedOrganizationsCta: Scalars['Boolean']['output']
  seenAppFeedbackModal: Scalars['Boolean']['output']
  seenEventsPage: Scalars['Boolean']['output']
  seenFfgRenameModal: Scalars['Boolean']['output']
  seenLogExternalGrantsFeature: Scalars['Boolean']['output']
  seenManageDafAdvisorsFeature: Scalars['Boolean']['output']
  seenOurRecommendationsPage: Scalars['Boolean']['output']
  showImpactAnalyticsFields: Scalars['Boolean']['output']
}

export type Money = {
  __typename?: 'Money'
  currency: Scalars['String']['output']
  minorUnit: Scalars['BigInt']['output']
}

export type MoneyInput = {
  currency: Scalars['String']['input']
  minorUnit: Scalars['BigInt']['input']
}

export type MutationAdmin = {
  __typename?: 'MutationAdmin'
  acceptSageGiftAccountDifferences: AcceptSageGiftAccountDifferencesPayload
  acknowledgeTrainingPolicies: AcknowledgeTrainingPoliciesPayload
  addAssetSecret: AddAssetSecretPayload
  /** Sets up someone joining FP: their employee record, team, start date, training and FP Navigator login */
  addNewStarter: AddNewStarterPayload
  addPlusOne: AddPlusOnePayload
  archiveTrainingCourse: ArchiveTrainingCoursePayload
  archiveTrainingModule: ArchiveTrainingModulePayload
  archiveUser: ArchiveUserPayload
  assignAsset: AssignAssetPayload
  assignTrainingModule: AssignTrainingModulePayload
  calculateInvestmentReturns: CalculateInvestmentReturnsPayload
  cancelCharityContactInvite: CancelCharityContactInvitePayload
  cancelGrant: CancelGrantPayload
  changeAssetStatus: ChangeAssetStatusPayload
  changeDataUploadRowDecision: ChangeDataUploadRowDecisionPayload
  checkInAttendee: CheckInAttendeePayload
  closeCheckIn: CloseCheckInPayload
  completeAdminFeeSageJournalEntry: CompleteAdminFeeSageJournalEntryPayload
  completeTrainingModule: CompleteTrainingModulePayload
  createAllDataUploadRowRecords: CreateAllDataUploadRowRecordsPayload
  createAsset: CreateAssetPayload
  createAssetsFromOrder: CreateAssetsFromOrderPayload
  createCaseNote: CreateCaseNotePayload
  createCharityBankAccountVerificationCall: CreateCharityBankAccountVerificationCallPayload
  createCharityCategory: CreateCharityCategoryPayload
  createContract: CreateContractPayload
  createDataUploadRowRecord: CreateDataUploadRowRecordPayload
  createEvent: CreateEventPayload
  createEventCampaign: CreateEventCampaignPayload
  createHifo: CreateHifoPayload
  createHifoCascade: CreateHifoCascadePayload
  createHifoCascadePitch: CreateHifoCascadePitchPayload
  createHifoCascadePitchMaterial: CreateHifoCascadePitchMaterialPayload
  createHifoCascadePitchNote: CreateHifoCascadePitchNotePayload
  createImpactMeasurementCategory: CreateImpactMeasurementCategoryPayload
  createImpactMeasurementItem: CreateImpactMeasurementItemPayload
  createImpactRecord: CreateImpactRecordPayload
  createInvestmentPool: CreateInvestmentPoolPayload
  createMatchCampaign: CreateMatchCampaignPayload
  createMatchCampaignCategory: CreateMatchCampaignCategoryPayload
  createNewsItem: CreateNewsItemPayload
  createPledge: CreatePledgePayload
  createPolicy: CreatePolicyPayload
  createRole: CreateRolePayload
  createSecondFactor: CreateSecondFactorPayload
  createTargetAudience: CreateTargetAudiencePayload
  createTeam: CreateTeamPayload
  createTrainingCategory: CreateTrainingCategoryPayload
  createTrainingCourse: CreateTrainingCoursePayload
  createTrainingModule: CreateTrainingModulePayload
  createUsDisbursement: CreateUsDisbursementPayload
  createUsDueDiligenceNote: CreateUsDueDiligenceNotePayload
  createUser: CreateUserPayload
  deactivateCharityContact: DeactivateCharityContactPayload
  deleteAssetDocument: DeleteAssetDocumentPayload
  deleteCaseNote: DeleteCaseNotePayload
  deleteCharityCategory: DeleteCharityCategoryPayload
  deleteContract: DeleteContractPayload
  deleteContractDocument: DeleteContractDocumentPayload
  deleteEventQuestionTemplate: DeleteEventQuestionTemplatePayload
  deleteHifo: DeleteHifoPayload
  deleteHifoCascade: DeleteHifoCascadePayload
  deleteHifoCascadePitch: DeleteHifoCascadePitchPayload
  deleteHifoCascadePitchMaterial: DeleteHifoCascadePitchMaterialPayload
  deleteHifoCascadePitchNote: DeleteHifoCascadePitchNotePayload
  deleteImpactMeasurementCategory: DeleteImpactMeasurementCategoryPayload
  deleteImpactMeasurementItem: DeleteImpactMeasurementItemPayload
  deleteInvestmentPool: DeleteInvestmentPoolPayload
  deleteMatchCampaign: DeleteMatchCampaignPayload
  deleteMatchCampaignCategory: DeleteMatchCampaignCategoryPayload
  deleteNewsItem: DeleteNewsItemPayload
  deleteProvisionalPledge: DeleteProvisionalPledgePayload
  deleteTargetAudience: DeleteTargetAudiencePayload
  deleteUsDueDiligenceNote: DeleteUsDueDiligenceNotePayload
  deleteUser: DeleteUserPayload
  disableSecondFactor: DisableSecondFactorPayload
  discardHeldUpdates: DiscardHeldUpdatesPayload
  dismissPolicySummarySuggestion: DismissPolicySummarySuggestionPayload
  enableSecondFactor: EnableSecondFactorPayload
  generateAllDafStatements: GenerateAllDafStatementsPayload
  generateSalesforceCasesForAccountPerformance: GenerateSalesforceCasesForAccountPerformancePayload
  generateSalesforceCasesForPeriod: GenerateSalesforceCasesForPeriodPayload
  grantAdminPortalAccess: GrantAdminPortalAccessPayload
  ignoreSageGiftAccountDifferences: IgnoreSageGiftAccountDifferencesPayload
  inviteCharityContact: InviteCharityContactPayload
  inviteGuests: InviteGuestsPayload
  linkSageTransactionRecord: LinkSageTransactionRecordPayload
  lockDafAdminFeePeriod: LockDafAdminFeePeriodPayload
  lockInvestmentPeriod: LockInvestmentPeriodPayload
  processCaseRecordGrantCompliance: ProcessCaseRecordGrantCompliancePayload
  promoteFromWaitlist: PromoteFromWaitlistPayload
  publishDafStatements: PublishDafStatementsPayload
  publishTrainingCourse: PublishTrainingCoursePayload
  publishTrainingModule: PublishTrainingModulePayload
  readContractDocumentAgain: ReadContractDocumentAgainPayload
  readPolicyDocumentAgain: ReadPolicyDocumentAgainPayload
  recalculateDafAdminFees: RecalculateDafAdminFeesPayload
  recordAssetCheck: RecordAssetCheckPayload
  recordContractRenewalDecision: RecordContractRenewalDecisionPayload
  recordPolicyAcknowledgement: RecordPolicyAcknowledgementPayload
  recordPolicyReview: RecordPolicyReviewPayload
  recordTrainingVideoProgress: RecordTrainingVideoProgressPayload
  regenerateDafStatements: RegenerateDafStatementsPayload
  registerAttendees: RegisterAttendeesPayload
  removeSecondFactors: RemoveSecondFactorsPayload
  reopenSageGiftAccountDifferences: ReopenSageGiftAccountDifferencesPayload
  reorderHifoCascade: ReorderHifoCascadePayload
  reorderTrainingCourseModules: ReorderTrainingCourseModulesPayload
  reorderTrainingCourses: ReorderTrainingCoursesPayload
  reorderTrainingModules: ReorderTrainingModulesPayload
  requireTrainingRetake: RequireTrainingRetakePayload
  resendCharityContactInvite: ResendCharityContactInvitePayload
  resendConfirmation: ResendConfirmationPayload
  resolveContactDifferences: ResolveContactDifferencesPayload
  retireCharityBankAccount: RetireCharityBankAccountPayload
  returnAsset: ReturnAssetPayload
  revealAssetSecret: RevealAssetSecretPayload
  runDuplicateChecker: RunDuplicateCheckerPayload
  sendEventFollowUps: SendEventFollowUpsPayload
  sendEventReminder: SendEventReminderPayload
  sendHeldUpdates: SendHeldUpdatesPayload
  sendTestEventEmail: SendTestEmailPayload
  sendTrainingNudges: SendTrainingNudgesPayload
  setAssetExpectedReturn: SetAssetExpectedReturnPayload
  setEarlyAccess: SetEarlyAccessPayload
  setEmployeeLeaving: SetEmployeeLeavingPayload
  setTrainingQuestionActive: SetTrainingQuestionActivePayload
  snoozeGrant: SnoozeGrantPayload
  startTrainingCourse: StartTrainingCoursePayload
  startTrainingQuizAttempt: StartTrainingQuizAttemptPayload
  submitTrainingQuizAttempt: SubmitTrainingQuizAttemptPayload
  syncSageRecords: SyncSageRecordsPayload
  terminateContract: TerminateContractPayload
  testMutation: TestMutationPayload
  undoCheckIn: UndoCheckInPayload
  unsnoozeGrant: UnsnoozeGrantPayload
  updateAmendedPledge: UpdateAmendedPledgePayload
  updateAsset: UpdateAssetPayload
  updateAttendeeDetails: UpdateAttendeeDetailsPayload
  updateAttendeeStatus: UpdateAttendeeStatusPayload
  updateCaseNote: UpdateCaseNotePayload
  updateCaseRecord: UpdateCaseRecordPayload
  updateCharityBankAccountStatus: UpdateCharityBankAccountStatusPayload
  updateCharityCategory: UpdateCharityCategoryPayload
  updateCharityContact: UpdateCharityContactPayload
  updateContract: UpdateContractPayload
  updateEmployee: UpdateEmployeePayload
  updateEmployeeTrainingFields: UpdateEmployeeTrainingFieldsPayload
  updateEvent: UpdateEventPayload
  updateEventSettings: UpdateEventSettingsPayload
  updateFundsDafInvestmentAllocation: UpdateFundsDafInvestmentAllocationPayload
  updateFundsDafPlan: UpdateFundsDafPlanPayload
  updateGrantCaseRecord: UpdateGrantCaseRecordPayload
  updateGrantComplianceCheck: UpdateGrantComplianceCheckPayload
  updateHifo: UpdateHifoPayload
  updateHifoCascade: UpdateHifoCascadePayload
  updateHifoCascadePitch: UpdateHifoCascadePitchPayload
  updateImpactMeasurementCategory: UpdateImpactMeasurementCategoryPayload
  updateImpactMeasurementItem: UpdateImpactMeasurementItemPayload
  updateImpactRecord: UpdateImpactRecordPayload
  updateInvestmentPool: UpdateInvestmentPoolPayload
  updateInvestmentPoolPerformance: UpdateInvestmentPoolPerformancePayload
  updateMatchCampaign: UpdateMatchCampaignPayload
  updateMatchCampaignCategory: UpdateMatchCampaignCategoryPayload
  updateNewsItem: UpdateNewsItemPayload
  updatePledge: UpdatePledgePayload
  updatePolicy: UpdatePolicyPayload
  updateRole: UpdateRolePayload
  updateSageGiftAccountRecord: UpdateSageGiftAccountRecordPayload
  updateTargetAudience: UpdateTargetAudiencePayload
  updateTeam: UpdateTeamPayload
  updateTrainingAssignment: UpdateTrainingAssignmentPayload
  updateTrainingCategory: UpdateTrainingCategoryPayload
  updateTrainingCourse: UpdateTrainingCoursePayload
  updateTrainingModule: UpdateTrainingModulePayload
  updateUsDueDiligence: UpdateUsDueDiligencePayload
  updateUsDueDiligenceNote: UpdateUsDueDiligenceNotePayload
  updateUser: UpdateUserPayload
  updateZeroHarmReview: UpdateZeroHarmReviewPayload
  upsertCharityBankAccountChecklistItem: UpsertCharityBankAccountChecklistItemPayload
  upsertEventQuestionTemplate: UpsertEventQuestionTemplatePayload
  upsertTrainingQuestion: UpsertTrainingQuestionPayload
}

export type MutationAdminAcceptSageGiftAccountDifferencesArgs = {
  input: AcceptSageGiftAccountDifferencesInput
}

export type MutationAdminAcknowledgeTrainingPoliciesArgs = {
  input: AcknowledgeTrainingPoliciesInput
}

export type MutationAdminAddAssetSecretArgs = {
  input: AddAssetSecretInput
}

export type MutationAdminAddNewStarterArgs = {
  input: AddNewStarterInput
}

export type MutationAdminAddPlusOneArgs = {
  input: AddPlusOneInput
}

export type MutationAdminArchiveTrainingCourseArgs = {
  input: ArchiveTrainingCourseInput
}

export type MutationAdminArchiveTrainingModuleArgs = {
  input: ArchiveTrainingModuleInput
}

export type MutationAdminArchiveUserArgs = {
  input: ArchiveUserInput
}

export type MutationAdminAssignAssetArgs = {
  input: AssignAssetInput
}

export type MutationAdminAssignTrainingModuleArgs = {
  input: AssignTrainingModuleInput
}

export type MutationAdminCalculateInvestmentReturnsArgs = {
  input: CalculateInvestmentReturnsInput
}

export type MutationAdminCancelCharityContactInviteArgs = {
  input: CancelCharityContactInviteInput
}

export type MutationAdminCancelGrantArgs = {
  input: CancelGrantInput
}

export type MutationAdminChangeAssetStatusArgs = {
  input: ChangeAssetStatusInput
}

export type MutationAdminChangeDataUploadRowDecisionArgs = {
  input: ChangeDataUploadRowDecisionInput
}

export type MutationAdminCheckInAttendeeArgs = {
  input: CheckInAttendeeInput
}

export type MutationAdminCloseCheckInArgs = {
  input: CloseCheckInInput
}

export type MutationAdminCompleteAdminFeeSageJournalEntryArgs = {
  input: CompleteAdminFeeSageJournalEntryInput
}

export type MutationAdminCompleteTrainingModuleArgs = {
  input: CompleteTrainingModuleInput
}

export type MutationAdminCreateAllDataUploadRowRecordsArgs = {
  input: CreateAllDataUploadRowRecordsInput
}

export type MutationAdminCreateAssetArgs = {
  input: CreateAssetInput
}

export type MutationAdminCreateAssetsFromOrderArgs = {
  input: CreateAssetsFromOrderInput
}

export type MutationAdminCreateCaseNoteArgs = {
  input: CreateCaseNoteInput
}

export type MutationAdminCreateCharityBankAccountVerificationCallArgs = {
  input: CreateCharityBankAccountVerificationCallInput
}

export type MutationAdminCreateCharityCategoryArgs = {
  input: CreateCharityCategoryInput
}

export type MutationAdminCreateContractArgs = {
  input: CreateContractInput
}

export type MutationAdminCreateDataUploadRowRecordArgs = {
  input: CreateDataUploadRowRecordInput
}

export type MutationAdminCreateEventArgs = {
  input: CreateEventInput
}

export type MutationAdminCreateEventCampaignArgs = {
  input: CreateEventCampaignInput
}

export type MutationAdminCreateHifoArgs = {
  input: CreateHifoInput
}

export type MutationAdminCreateHifoCascadeArgs = {
  input: CreateHifoCascadeInput
}

export type MutationAdminCreateHifoCascadePitchArgs = {
  input: CreateHifoCascadePitchInput
}

export type MutationAdminCreateHifoCascadePitchMaterialArgs = {
  input: CreateHifoCascadePitchMaterialInput
}

export type MutationAdminCreateHifoCascadePitchNoteArgs = {
  input: CreateHifoCascadePitchNoteInput
}

export type MutationAdminCreateImpactMeasurementCategoryArgs = {
  input: CreateImpactMeasurementCategoryInput
}

export type MutationAdminCreateImpactMeasurementItemArgs = {
  input: CreateImpactMeasurementItemInput
}

export type MutationAdminCreateImpactRecordArgs = {
  input: CreateImpactRecordInput
}

export type MutationAdminCreateInvestmentPoolArgs = {
  input: CreateInvestmentPoolInput
}

export type MutationAdminCreateMatchCampaignArgs = {
  input: CreateMatchCampaignInput
}

export type MutationAdminCreateMatchCampaignCategoryArgs = {
  input: CreateMatchCampaignCategoryInput
}

export type MutationAdminCreateNewsItemArgs = {
  input: CreateNewsItemInput
}

export type MutationAdminCreatePledgeArgs = {
  input: CreatePledgeInput
}

export type MutationAdminCreatePolicyArgs = {
  input: CreatePolicyInput
}

export type MutationAdminCreateRoleArgs = {
  input: CreateRoleInput
}

export type MutationAdminCreateSecondFactorArgs = {
  input: CreateSecondFactorInput
}

export type MutationAdminCreateTargetAudienceArgs = {
  input: CreateTargetAudienceInput
}

export type MutationAdminCreateTeamArgs = {
  input: CreateTeamInput
}

export type MutationAdminCreateTrainingCategoryArgs = {
  input: CreateTrainingCategoryInput
}

export type MutationAdminCreateTrainingCourseArgs = {
  input: CreateTrainingCourseInput
}

export type MutationAdminCreateTrainingModuleArgs = {
  input: CreateTrainingModuleInput
}

export type MutationAdminCreateUsDisbursementArgs = {
  input: CreateUsDisbursementInput
}

export type MutationAdminCreateUsDueDiligenceNoteArgs = {
  input: CreateUsDueDiligenceNoteInput
}

export type MutationAdminCreateUserArgs = {
  input: CreateUserInput
}

export type MutationAdminDeactivateCharityContactArgs = {
  input: DeactivateCharityContactInput
}

export type MutationAdminDeleteAssetDocumentArgs = {
  input: DeleteAssetDocumentInput
}

export type MutationAdminDeleteCaseNoteArgs = {
  input: DeleteCaseNoteInput
}

export type MutationAdminDeleteCharityCategoryArgs = {
  input: DeleteCharityCategoryInput
}

export type MutationAdminDeleteContractArgs = {
  input: DeleteContractInput
}

export type MutationAdminDeleteContractDocumentArgs = {
  input: DeleteContractDocumentInput
}

export type MutationAdminDeleteEventQuestionTemplateArgs = {
  input: DeleteEventQuestionTemplateInput
}

export type MutationAdminDeleteHifoArgs = {
  input: DeleteHifoInput
}

export type MutationAdminDeleteHifoCascadeArgs = {
  input: DeleteHifoCascadeInput
}

export type MutationAdminDeleteHifoCascadePitchArgs = {
  input: DeleteHifoCascadePitchInput
}

export type MutationAdminDeleteHifoCascadePitchMaterialArgs = {
  input: DeleteHifoCascadePitchMaterialInput
}

export type MutationAdminDeleteHifoCascadePitchNoteArgs = {
  input: DeleteHifoCascadePitchNoteInput
}

export type MutationAdminDeleteImpactMeasurementCategoryArgs = {
  input: DeleteImpactMeasurementCategoryInput
}

export type MutationAdminDeleteImpactMeasurementItemArgs = {
  input: DeleteImpactMeasurementItemInput
}

export type MutationAdminDeleteInvestmentPoolArgs = {
  input: DeleteInvestmentPoolInput
}

export type MutationAdminDeleteMatchCampaignArgs = {
  input: DeleteMatchCampaignInput
}

export type MutationAdminDeleteMatchCampaignCategoryArgs = {
  input: DeleteMatchCampaignCategoryInput
}

export type MutationAdminDeleteNewsItemArgs = {
  input: DeleteNewsItemInput
}

export type MutationAdminDeleteProvisionalPledgeArgs = {
  input: DeleteProvisionalPledgeInput
}

export type MutationAdminDeleteTargetAudienceArgs = {
  input: DeleteTargetAudienceInput
}

export type MutationAdminDeleteUsDueDiligenceNoteArgs = {
  input: DeleteUsDueDiligenceNoteInput
}

export type MutationAdminDeleteUserArgs = {
  input: DeleteUserInput
}

export type MutationAdminDisableSecondFactorArgs = {
  input: DisableSecondFactorInput
}

export type MutationAdminDiscardHeldUpdatesArgs = {
  input: DiscardHeldUpdatesInput
}

export type MutationAdminDismissPolicySummarySuggestionArgs = {
  input: DismissPolicySummarySuggestionInput
}

export type MutationAdminEnableSecondFactorArgs = {
  input: EnableSecondFactorInput
}

export type MutationAdminGenerateAllDafStatementsArgs = {
  input: GenerateAllDafStatementsInput
}

export type MutationAdminGenerateSalesforceCasesForAccountPerformanceArgs = {
  input: GenerateSalesforceCasesForAccountPerformanceInput
}

export type MutationAdminGenerateSalesforceCasesForPeriodArgs = {
  input: GenerateSalesforceCasesForPeriodInput
}

export type MutationAdminGrantAdminPortalAccessArgs = {
  input: GrantAdminPortalAccessInput
}

export type MutationAdminIgnoreSageGiftAccountDifferencesArgs = {
  input: IgnoreSageGiftAccountDifferencesInput
}

export type MutationAdminInviteCharityContactArgs = {
  input: InviteCharityContactInput
}

export type MutationAdminInviteGuestsArgs = {
  input: InviteGuestsInput
}

export type MutationAdminLinkSageTransactionRecordArgs = {
  input: LinkSageTransactionRecordInput
}

export type MutationAdminLockDafAdminFeePeriodArgs = {
  input: LockDafAdminFeePeriodInput
}

export type MutationAdminLockInvestmentPeriodArgs = {
  input: LockInvestmentPeriodInput
}

export type MutationAdminProcessCaseRecordGrantComplianceArgs = {
  input: ProcessCaseRecordGrantComplianceInput
}

export type MutationAdminPromoteFromWaitlistArgs = {
  input: PromoteFromWaitlistInput
}

export type MutationAdminPublishDafStatementsArgs = {
  input: PublishDafStatementsInput
}

export type MutationAdminPublishTrainingCourseArgs = {
  input: PublishTrainingCourseInput
}

export type MutationAdminPublishTrainingModuleArgs = {
  input: PublishTrainingModuleInput
}

export type MutationAdminReadContractDocumentAgainArgs = {
  input: ReadContractDocumentAgainInput
}

export type MutationAdminReadPolicyDocumentAgainArgs = {
  input: ReadPolicyDocumentAgainInput
}

export type MutationAdminRecalculateDafAdminFeesArgs = {
  input: RecalculateDafAdminFeesInput
}

export type MutationAdminRecordAssetCheckArgs = {
  input: RecordAssetCheckInput
}

export type MutationAdminRecordContractRenewalDecisionArgs = {
  input: RecordContractRenewalDecisionInput
}

export type MutationAdminRecordPolicyAcknowledgementArgs = {
  input: RecordPolicyAcknowledgementInput
}

export type MutationAdminRecordPolicyReviewArgs = {
  input: RecordPolicyReviewInput
}

export type MutationAdminRecordTrainingVideoProgressArgs = {
  input: RecordTrainingVideoProgressInput
}

export type MutationAdminRegenerateDafStatementsArgs = {
  input: RegenerateDafStatementsInput
}

export type MutationAdminRegisterAttendeesArgs = {
  input: RegisterAttendeesInput
}

export type MutationAdminRemoveSecondFactorsArgs = {
  input: RemoveSecondFactorsInput
}

export type MutationAdminReopenSageGiftAccountDifferencesArgs = {
  input: ReopenSageGiftAccountDifferencesInput
}

export type MutationAdminReorderHifoCascadeArgs = {
  input: ReorderHifoCascadeInput
}

export type MutationAdminReorderTrainingCourseModulesArgs = {
  input: ReorderTrainingCourseModulesInput
}

export type MutationAdminReorderTrainingCoursesArgs = {
  input: ReorderTrainingCoursesInput
}

export type MutationAdminReorderTrainingModulesArgs = {
  input: ReorderTrainingModulesInput
}

export type MutationAdminRequireTrainingRetakeArgs = {
  input: RequireTrainingRetakeInput
}

export type MutationAdminResendCharityContactInviteArgs = {
  input: ResendCharityContactInviteInput
}

export type MutationAdminResendConfirmationArgs = {
  input: ResendConfirmationInput
}

export type MutationAdminResolveContactDifferencesArgs = {
  input: ResolveContactDifferencesInput
}

export type MutationAdminRetireCharityBankAccountArgs = {
  input: RetireCharityBankAccountInput
}

export type MutationAdminReturnAssetArgs = {
  input: ReturnAssetInput
}

export type MutationAdminRevealAssetSecretArgs = {
  input: RevealAssetSecretInput
}

export type MutationAdminRunDuplicateCheckerArgs = {
  input: RunDuplicateCheckerInput
}

export type MutationAdminSendEventFollowUpsArgs = {
  input: SendEventFollowUpsInput
}

export type MutationAdminSendEventReminderArgs = {
  input: SendEventReminderInput
}

export type MutationAdminSendHeldUpdatesArgs = {
  input: SendHeldUpdatesInput
}

export type MutationAdminSendTestEventEmailArgs = {
  input: SendTestEmailInput
}

export type MutationAdminSendTrainingNudgesArgs = {
  input: SendTrainingNudgesInput
}

export type MutationAdminSetAssetExpectedReturnArgs = {
  input: SetAssetExpectedReturnInput
}

export type MutationAdminSetEarlyAccessArgs = {
  input: SetEarlyAccessInput
}

export type MutationAdminSetEmployeeLeavingArgs = {
  input: SetEmployeeLeavingInput
}

export type MutationAdminSetTrainingQuestionActiveArgs = {
  input: SetTrainingQuestionActiveInput
}

export type MutationAdminSnoozeGrantArgs = {
  input: SnoozeGrantInput
}

export type MutationAdminStartTrainingCourseArgs = {
  input: StartTrainingCourseInput
}

export type MutationAdminStartTrainingQuizAttemptArgs = {
  input: StartTrainingQuizAttemptInput
}

export type MutationAdminSubmitTrainingQuizAttemptArgs = {
  input: SubmitTrainingQuizAttemptInput
}

export type MutationAdminSyncSageRecordsArgs = {
  input: SyncSageRecordsInput
}

export type MutationAdminTerminateContractArgs = {
  input: TerminateContractInput
}

export type MutationAdminTestMutationArgs = {
  input: TestMutationInput
}

export type MutationAdminUndoCheckInArgs = {
  input: UndoCheckInInput
}

export type MutationAdminUnsnoozeGrantArgs = {
  input: UnsnoozeGrantInput
}

export type MutationAdminUpdateAmendedPledgeArgs = {
  input: UpdateAmendedPledgeInput
}

export type MutationAdminUpdateAssetArgs = {
  input: UpdateAssetInput
}

export type MutationAdminUpdateAttendeeDetailsArgs = {
  input: UpdateAttendeeDetailsInput
}

export type MutationAdminUpdateAttendeeStatusArgs = {
  input: UpdateAttendeeStatusInput
}

export type MutationAdminUpdateCaseNoteArgs = {
  input: UpdateCaseNoteInput
}

export type MutationAdminUpdateCaseRecordArgs = {
  input: UpdateCaseRecordInput
}

export type MutationAdminUpdateCharityBankAccountStatusArgs = {
  input: UpdateCharityBankAccountStatusInput
}

export type MutationAdminUpdateCharityCategoryArgs = {
  input: UpdateCharityCategoryInput
}

export type MutationAdminUpdateCharityContactArgs = {
  input: UpdateCharityContactInput
}

export type MutationAdminUpdateContractArgs = {
  input: UpdateContractInput
}

export type MutationAdminUpdateEmployeeArgs = {
  input: UpdateEmployeeInput
}

export type MutationAdminUpdateEmployeeTrainingFieldsArgs = {
  input: UpdateEmployeeTrainingFieldsInput
}

export type MutationAdminUpdateEventArgs = {
  input: UpdateEventInput
}

export type MutationAdminUpdateEventSettingsArgs = {
  input: UpdateEventSettingsInput
}

export type MutationAdminUpdateFundsDafInvestmentAllocationArgs = {
  input: UpdateFundsDafInvestmentAllocationInput
}

export type MutationAdminUpdateFundsDafPlanArgs = {
  input: UpdateFundsDafPlanInput
}

export type MutationAdminUpdateGrantCaseRecordArgs = {
  input: UpdateGrantCaseRecordInput
}

export type MutationAdminUpdateGrantComplianceCheckArgs = {
  input: UpdateGrantComplianceCheckInput
}

export type MutationAdminUpdateHifoArgs = {
  input: UpdateHifoInput
}

export type MutationAdminUpdateHifoCascadeArgs = {
  input: UpdateHifoCascadeInput
}

export type MutationAdminUpdateHifoCascadePitchArgs = {
  input: UpdateHifoCascadePitchInput
}

export type MutationAdminUpdateImpactMeasurementCategoryArgs = {
  input: UpdateImpactMeasurementCategoryInput
}

export type MutationAdminUpdateImpactMeasurementItemArgs = {
  input: UpdateImpactMeasurementItemInput
}

export type MutationAdminUpdateImpactRecordArgs = {
  input: UpdateImpactRecordInput
}

export type MutationAdminUpdateInvestmentPoolArgs = {
  input: UpdateInvestmentPoolInput
}

export type MutationAdminUpdateInvestmentPoolPerformanceArgs = {
  input: UpdateInvestmentPoolPerformanceInput
}

export type MutationAdminUpdateMatchCampaignArgs = {
  input: UpdateMatchCampaignInput
}

export type MutationAdminUpdateMatchCampaignCategoryArgs = {
  input: UpdateMatchCampaignCategoryInput
}

export type MutationAdminUpdateNewsItemArgs = {
  input: UpdateNewsItemInput
}

export type MutationAdminUpdatePledgeArgs = {
  input: UpdatePledgeInput
}

export type MutationAdminUpdatePolicyArgs = {
  input: UpdatePolicyInput
}

export type MutationAdminUpdateRoleArgs = {
  input: UpdateRoleInput
}

export type MutationAdminUpdateSageGiftAccountRecordArgs = {
  input: UpdateSageGiftAccountRecordInput
}

export type MutationAdminUpdateTargetAudienceArgs = {
  input: UpdateTargetAudienceInput
}

export type MutationAdminUpdateTeamArgs = {
  input: UpdateTeamInput
}

export type MutationAdminUpdateTrainingAssignmentArgs = {
  input: UpdateTrainingAssignmentInput
}

export type MutationAdminUpdateTrainingCategoryArgs = {
  input: UpdateTrainingCategoryInput
}

export type MutationAdminUpdateTrainingCourseArgs = {
  input: UpdateTrainingCourseInput
}

export type MutationAdminUpdateTrainingModuleArgs = {
  input: UpdateTrainingModuleInput
}

export type MutationAdminUpdateUsDueDiligenceArgs = {
  input: UpdateUsDueDiligenceInput
}

export type MutationAdminUpdateUsDueDiligenceNoteArgs = {
  input: UpdateUsDueDiligenceNoteInput
}

export type MutationAdminUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationAdminUpdateZeroHarmReviewArgs = {
  input: UpdateZeroHarmReviewInput
}

export type MutationAdminUpsertCharityBankAccountChecklistItemArgs = {
  input: UpsertCharityBankAccountChecklistItemInput
}

export type MutationAdminUpsertEventQuestionTemplateArgs = {
  input: UpsertEventQuestionTemplateInput
}

export type MutationAdminUpsertTrainingQuestionArgs = {
  input: UpsertTrainingQuestionInput
}

export type MyTraining = {
  __typename?: 'MyTraining'
  /** Every course the caller can see, mandatory and optional, in order */
  courses: Array<StaffTrainingCourseSummary>
  /** False when training is switched off for the caller, whose modules and policies are then empty */
  inScope: Scalars['Boolean']['output']
  /** Compliance modules, without the ones in courses */
  modules: Array<StaffTrainingModuleSummary>
  /** The first module still to do */
  nextModuleSlug?: Maybe<Scalars['String']['output']>
  overall: TrainingOverallStatusEnum
  policies: Array<StaffTrainingPolicy>
}

export type NewsItem = {
  __typename?: 'NewsItem'
  date?: Maybe<Scalars['ISO8601Date']['output']>
  eventType: NewsItemEvent
  id: Scalars['String']['output']
  order: Scalars['Int']['output']
  read: Scalars['Boolean']['output']
  tags?: Maybe<Array<Scalars['String']['output']>>
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type NewsItemAdmin = {
  __typename?: 'NewsItemAdmin'
  active: Scalars['Boolean']['output']
  date?: Maybe<Scalars['ISO8601Date']['output']>
  eventType: NewsItemEvent
  id: Scalars['String']['output']
  order: Scalars['Int']['output']
  read?: Maybe<Scalars['Boolean']['output']>
  showFrom: Scalars['ISO8601DateTime']['output']
  showTo: Scalars['ISO8601DateTime']['output']
  tags?: Maybe<Array<Scalars['String']['output']>>
  targetAudience?: Maybe<TargetAudience>
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

/** NewsItemAdminCollection type */
export type NewsItemAdminCollection = {
  __typename?: 'NewsItemAdminCollection'
  /** A collection of paginated NewsItemAdminCollection */
  collection: Array<NewsItemAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type NewsItemChangeInput = {
  active: Scalars['Boolean']['input']
  date?: InputMaybe<Scalars['ISO8601Date']['input']>
  newsItemTypeId: Scalars['String']['input']
  order?: InputMaybe<Scalars['Int']['input']>
  showFrom: Scalars['ISO8601DateTime']['input']
  showTo: Scalars['ISO8601DateTime']['input']
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  targetAudienceId?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  url?: InputMaybe<Scalars['String']['input']>
}

export type NewsItemEvent = {
  __typename?: 'NewsItemEvent'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export enum NewsItemsSearchEnum {
  All = 'All',
  CurrentAndFuture = 'CurrentAndFuture',
}

export type Note = {
  __typename?: 'Note'
  author: User
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type NumericFilterInput = {
  field: FundFilterFieldEnum
  operator: NumericOperatorEnum
  value?: InputMaybe<Scalars['Float']['input']>
}

export enum NumericOperatorEnum {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  Lt = 'LT',
  Lte = 'LTE',
}

export type PasswordChange = {
  currentPassword: Scalars['String']['input']
  newPassword: Scalars['String']['input']
}

export type Permission = {
  __typename?: 'Permission'
  id: Scalars['ID']['output']
  name: PermissionEnum
  permissionType?: Maybe<PermissionTypeEnum>
}

export enum PermissionEnum {
  CallHifoRecommendationAgent = 'CallHifoRecommendationAgent',
  ChangeUserPermissions = 'ChangeUserPermissions',
  CountersignAmendedPledge = 'CountersignAmendedPledge',
  CountersignPledge = 'CountersignPledge',
  CreateHifo = 'CreateHifo',
  CreateHifoCascade = 'CreateHifoCascade',
  CreatePledge = 'CreatePledge',
  CreateUsDisbursement = 'CreateUsDisbursement',
  CreateUser = 'CreateUser',
  DataUploads = 'DataUploads',
  DeleteHifo = 'DeleteHifo',
  DeleteHifoCascade = 'DeleteHifoCascade',
  DeleteIncompleteHifo = 'DeleteIncompleteHifo',
  DeletePledge = 'DeletePledge',
  DeleteUser = 'DeleteUser',
  EditCharityBankAccounts = 'EditCharityBankAccounts',
  EditCharityCategories = 'EditCharityCategories',
  EditCharityContacts = 'EditCharityContacts',
  EditDafFeeJournalEntries = 'EditDafFeeJournalEntries',
  EditDafFees = 'EditDafFees',
  EditDafStatements = 'EditDafStatements',
  EditDueDiligences = 'EditDueDiligences',
  EditEmployee = 'EditEmployee',
  EditFunds = 'EditFunds',
  EditGrants = 'EditGrants',
  EditGrantsComplianceChecks = 'EditGrantsComplianceChecks',
  EditHifo = 'EditHifo',
  EditHifoAppContent = 'EditHifoAppContent',
  EditHifoCascade = 'EditHifoCascade',
  EditImpactMeasurements = 'EditImpactMeasurements',
  EditInvestmentsPeriods = 'EditInvestmentsPeriods',
  EditInvestmentsPoolPerformances = 'EditInvestmentsPoolPerformances',
  EditInvestmentsPools = 'EditInvestmentsPools',
  EditMatchCampaignCategories = 'EditMatchCampaignCategories',
  EditMatchCampaigns = 'EditMatchCampaigns',
  EditNewsItems = 'EditNewsItems',
  EditRole = 'EditRole',
  EditTargetAudiences = 'EditTargetAudiences',
  EditTrainingContent = 'EditTrainingContent',
  EditUser = 'EditUser',
  ManageAssets = 'ManageAssets',
  ManageContracts = 'ManageContracts',
  ManageEvents = 'ManageEvents',
  ManagePolicies = 'ManagePolicies',
  ManageTraining = 'ManageTraining',
  McpCreateInteractions = 'McpCreateInteractions',
  McpEditContacts = 'McpEditContacts',
  McpReadPolicies = 'McpReadPolicies',
  McpTranscribeAudio = 'McpTranscribeAudio',
  McpUpsertContacts = 'McpUpsertContacts',
  McpUseSearchTools = 'McpUseSearchTools',
  RemoveUserSecondFactors = 'RemoveUserSecondFactors',
  RevealAssetSecrets = 'RevealAssetSecrets',
  SageIntacctApi = 'SageIntacctApi',
  SageSalesforceSync = 'SageSalesforceSync',
  ViewAmendedPledge = 'ViewAmendedPledge',
  ViewAsUser = 'ViewAsUser',
  ViewAssets = 'ViewAssets',
  ViewAuditLog = 'ViewAuditLog',
  ViewCaseProcessing = 'ViewCaseProcessing',
  ViewCases = 'ViewCases',
  ViewCharities = 'ViewCharities',
  ViewCharityBankAccounts = 'ViewCharityBankAccounts',
  ViewCompanies = 'ViewCompanies',
  ViewContacts = 'ViewContacts',
  ViewContracts = 'ViewContracts',
  ViewDafFees = 'ViewDafFees',
  ViewDueDiligences = 'ViewDueDiligences',
  ViewEmployees = 'ViewEmployees',
  ViewFunds = 'ViewFunds',
  ViewGrants = 'ViewGrants',
  ViewHifo = 'ViewHifo',
  ViewHifoCascade = 'ViewHifoCascade',
  ViewInvestments = 'ViewInvestments',
  ViewMatchCampaigns = 'ViewMatchCampaigns',
  ViewMemberInteractions = 'ViewMemberInteractions',
  ViewPgHero = 'ViewPgHero',
  ViewPledge = 'ViewPledge',
  ViewRequestsForFunding = 'ViewRequestsForFunding',
  ViewSidekiq = 'ViewSidekiq',
  ViewTargetAudiences = 'ViewTargetAudiences',
  ViewTrainingCompliance = 'ViewTrainingCompliance',
  ViewUser = 'ViewUser',
}

export enum PermissionTypeEnum {
  Admin = 'Admin',
  AmendedPledge = 'AmendedPledge',
  Assets = 'Assets',
  Charity = 'Charity',
  Contracts = 'Contracts',
  DafFees = 'DafFees',
  DafStatement = 'DafStatement',
  DataUpload = 'DataUpload',
  EventManagement = 'EventManagement',
  Fund = 'Fund',
  GrantProcessing = 'GrantProcessing',
  HifoCascade = 'HifoCascade',
  HifoManagement = 'HifoManagement',
  Infra = 'Infra',
  Investment = 'Investment',
  MatchCampaign = 'MatchCampaign',
  Mcp = 'Mcp',
  NewsItem = 'NewsItem',
  Other = 'Other',
  Pledge = 'Pledge',
  RequestForFunding = 'RequestForFunding',
  SageSalesforce = 'SageSalesforce',
  TargetAudience = 'TargetAudience',
  Training = 'Training',
  User = 'User',
}

export type PersonalisedHifoRecommendationAdmin = {
  __typename?: 'PersonalisedHifoRecommendationAdmin'
  hifo?: Maybe<HifoAdmin>
  id: Scalars['ID']['output']
  isUserInterested?: Maybe<Scalars['Boolean']['output']>
  reason?: Maybe<Scalars['String']['output']>
}

export type PitchOrderingInput = {
  pitchId: Scalars['ID']['input']
  trancheNumber: Scalars['Int']['input']
}

export type PlaidPayment = {
  __typename?: 'PlaidPayment'
  hasFailed: Scalars['Boolean']['output']
  paymentId: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type PlaidTransfer = {
  __typename?: 'PlaidTransfer'
  authorizationDecision?: Maybe<Scalars['String']['output']>
  authorizationRationaleCode?: Maybe<Scalars['String']['output']>
  authorizationRationaleDescription?: Maybe<Scalars['String']['output']>
  failureCode?: Maybe<Scalars['String']['output']>
  failureDescription?: Maybe<Scalars['String']['output']>
  failureType?: Maybe<Scalars['String']['output']>
  intentStatus: Scalars['String']['output']
  mode: Scalars['String']['output']
  transferId?: Maybe<Scalars['String']['output']>
  transferIntentId: Scalars['String']['output']
  transferStatus?: Maybe<Scalars['String']['output']>
}

export type PlanChange = {
  __typename?: 'PlanChange'
  newPlan: PlanEnum
  submittedBy: UserPrivate
}

export enum PlanEnum {
  Core = 'Core',
  Premium = 'Premium',
}

export type Pledge = {
  __typename?: 'Pledge'
  companyName: Scalars['String']['output']
  countersigned: Scalars['Boolean']['output']
  currentPercentage?: Maybe<Scalars['Float']['output']>
  dateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  id?: Maybe<Scalars['String']['output']>
  memberSignatureUrl?: Maybe<Scalars['String']['output']>
  shareholdingPercentage?: Maybe<Scalars['Float']['output']>
  valuation?: Maybe<Scalars['BigInt']['output']>
}

export type PledgeAdmin = {
  __typename?: 'PledgeAdmin'
  closer?: Maybe<Employee>
  companyName: Scalars['String']['output']
  countersignatureUrl?: Maybe<Scalars['String']['output']>
  countersigned: Scalars['Boolean']['output']
  createdDate: Scalars['ISO8601Date']['output']
  currentPercentage?: Maybe<Scalars['Float']['output']>
  dateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  memberSignatureUrl?: Maybe<Scalars['String']['output']>
  pledgorHomeCountry?: Maybe<Scalars['String']['output']>
  shareholdingPercentage?: Maybe<Scalars['Float']['output']>
  signed: Scalars['Boolean']['output']
  surname?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['String']['output']>
  valuation?: Maybe<Scalars['BigInt']['output']>
}

/** PledgeAdminCollection type */
export type PledgeAdminCollection = {
  __typename?: 'PledgeAdminCollection'
  /** A collection of paginated PledgeAdminCollection */
  collection: Array<PledgeAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type PledgeInProgress = {
  __typename?: 'PledgeInProgress'
  city?: Maybe<Scalars['String']['output']>
  companies?: Maybe<Array<Company>>
  countryCode?: Maybe<Scalars['Country']['output']>
  id?: Maybe<Scalars['String']['output']>
  percentage?: Maybe<Scalars['Int']['output']>
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  phoneNumberWithoutCountryCode?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  preferredMethodsOfCommunication?: Maybe<Array<Scalars['String']['output']>>
  region?: Maybe<RegionEnum>
  role?: Maybe<RoleEnum>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
}

export type PledgeInput = {
  address: AddressInput
  closerId?: InputMaybe<Scalars['ID']['input']>
  companies: Array<CompanyInput>
  percentage: Scalars['Int']['input']
  receiveComms: Scalars['Boolean']['input']
  region: RegionEnum
  role: RoleEnum
}

export enum PledgeSearchEnum {
  All = 'All',
  AwaitingFoundersPledgeSignature = 'AwaitingFoundersPledgeSignature',
  AwaitingMemberSignature = 'AwaitingMemberSignature',
}

export type PolicyAcknowledgement = {
  __typename?: 'PolicyAcknowledgement'
  acknowledgedAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  policyId: Scalars['ID']['output']
  policyTitle: Scalars['String']['output']
  source: Scalars['String']['output']
  version: Scalars['String']['output']
}

export type PolicyAcknowledgementTotals = {
  __typename?: 'PolicyAcknowledgementTotals'
  acknowledged: Scalars['Int']['output']
  /** People in scope whose mandatory training links the policy */
  appliesTo: Scalars['Int']['output']
  /** By name */
  outstanding: Array<PolicyOutstandingAcknowledgement>
}

export type PolicyAdmin = {
  __typename?: 'PolicyAdmin'
  /** The same figures as training compliance */
  acknowledgements: PolicyAcknowledgementTotals
  active: Scalars['Boolean']['output']
  attention: Array<PolicyAttentionEnum>
  /** The official copy of the current version */
  currentDocument?: Maybe<PolicyDocument>
  currentVersion: Scalars['String']['output']
  /** One per version, newest upload first */
  documents: Array<PolicyDocument>
  effectiveOn?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  keyPoints: Array<Scalars['String']['output']>
  lastReviewedOn?: Maybe<Scalars['ISO8601Date']['output']>
  nextReviewOn?: Maybe<Scalars['ISO8601Date']['output']>
  ownerId?: Maybe<Scalars['ID']['output']>
  /** The owner's leaving date, if they have one */
  ownerLeftOn?: Maybe<Scalars['ISO8601Date']['output']>
  ownerName?: Maybe<Scalars['String']['output']>
  reackWithinDays: Scalars['Int']['output']
  requireReackOnVersionChange: Scalars['Boolean']['output']
  reviewEveryMonths?: Maybe<Scalars['Int']['output']>
  /** Newest first */
  reviews: Array<PolicyReview>
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
  versionChangedOn?: Maybe<Scalars['ISO8601Date']['output']>
}

export enum PolicyAttentionEnum {
  /** No file has been uploaded for the current version */
  NoDocument = 'NO_DOCUMENT',
  /** Nobody owns the policy */
  NoOwner = 'NO_OWNER',
  /** No next review date is set */
  NoReviewDate = 'NO_REVIEW_DATE',
  /** The owner has a leaving date */
  OwnerLeaving = 'OWNER_LEAVING',
  /** The owner no longer works at FP */
  OwnerLeft = 'OWNER_LEFT',
  /** The next review is in the next 60 days */
  ReviewDueSoon = 'REVIEW_DUE_SOON',
  /** The next review date has passed */
  ReviewOverdue = 'REVIEW_OVERDUE',
}

export type PolicyDocument = {
  __typename?: 'PolicyDocument'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  originalFilename: Scalars['String']['output']
  pageCount?: Maybe<Scalars['Int']['output']>
  /** The text the MCP answers from, page by page */
  pages: Array<PolicyDocumentPage>
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  readError?: Maybe<Scalars['String']['output']>
  /** Whether Claude transcribed the pages, tables and diagrams included, or only the text layer was read */
  readMethod?: Maybe<PolicyDocumentReadMethodEnum>
  /** Reading the suggested summary from the file */
  readStatus?: Maybe<PolicyDocumentReadStatusEnum>
  suggestedKeyPoints: Array<Scalars['String']['output']>
  suggestedSummary?: Maybe<Scalars['String']['output']>
  /** When the summary was saved or the suggestion dismissed */
  suggestionDismissedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  /** When the file was last uploaded */
  updatedAt: Scalars['ISO8601DateTime']['output']
  uploadedByName?: Maybe<Scalars['String']['output']>
  /** Expires after 15 minutes */
  url: Scalars['String']['output']
  version: Scalars['String']['output']
}

export type PolicyDocumentLink = {
  __typename?: 'PolicyDocumentLink'
  originalFilename: Scalars['String']['output']
  policyTitle: Scalars['String']['output']
  /** Expires after 15 minutes */
  url: Scalars['String']['output']
  version: Scalars['String']['output']
}

export type PolicyDocumentPage = {
  __typename?: 'PolicyDocumentPage'
  number: Scalars['Int']['output']
  text: Scalars['String']['output']
}

export enum PolicyDocumentReadMethodEnum {
  TextOnly = 'TEXT_ONLY',
  Transcribed = 'TRANSCRIBED',
}

export enum PolicyDocumentReadStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Running = 'RUNNING',
  Unreadable = 'UNREADABLE',
}

export type PolicyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  currentVersion?: InputMaybe<Scalars['String']['input']>
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  keyPoints?: InputMaybe<Array<Scalars['String']['input']>>
  nextReviewOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  reackWithinDays?: InputMaybe<Scalars['Int']['input']>
  requireReackOnVersionChange?: InputMaybe<Scalars['Boolean']['input']>
  reviewEveryMonths?: InputMaybe<Scalars['Int']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type PolicyOutstandingAcknowledgement = {
  __typename?: 'PolicyOutstandingAcknowledgement'
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  employeeId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  overdue: Scalars['Boolean']['output']
}

export type PolicyReview = {
  __typename?: 'PolicyReview'
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  note?: Maybe<Scalars['String']['output']>
  outcome: PolicyReviewOutcomeEnum
  recordedByName?: Maybe<Scalars['String']['output']>
  reviewedOn: Scalars['ISO8601Date']['output']
  /** The version the policy was on once the review was recorded */
  version: Scalars['String']['output']
}

export enum PolicyReviewOutcomeEnum {
  NewVersion = 'NEW_VERSION',
  NoChanges = 'NO_CHANGES',
}

export type PotentialMatch = {
  __typename?: 'PotentialMatch'
  caseRecord?: Maybe<CaseRecord>
  matches?: Maybe<Array<PotentialMatchMatchDetail>>
  score?: Maybe<Scalars['Int']['output']>
}

export type PotentialMatchMatchDetail = {
  __typename?: 'PotentialMatchMatchDetail'
  text: Scalars['String']['output']
  type: Scalars['String']['output']
}

export enum PrimaryCauseAreaEnum {
  AiSafety = 'AI_SAFETY',
  AnimalWelfare = 'ANIMAL_WELFARE',
  ArtsCulture = 'ARTS_CULTURE',
  BiosecurityPandemicPreparedness = 'BIOSECURITY_PANDEMIC_PREPAREDNESS',
  CharitySectorDevelopmentSupport = 'CHARITY_SECTOR_DEVELOPMENT_SUPPORT',
  ClimateChangeMitigationAdaptation = 'CLIMATE_CHANGE_MITIGATION_ADAPTATION',
  CommunityReligion = 'COMMUNITY_RELIGION',
  CriminalJusticeReform = 'CRIMINAL_JUSTICE_REFORM',
  DemocracyPoliticalSystemChange = 'DEMOCRACY_POLITICAL_SYSTEM_CHANGE',
  DisasterReliefEmergencyAid = 'DISASTER_RELIEF_EMERGENCY_AID',
  EconomicEmpowermentDeveloped = 'ECONOMIC_EMPOWERMENT_DEVELOPED',
  EconomicEmpowermentDeveloping = 'ECONOMIC_EMPOWERMENT_DEVELOPING',
  EconomicSystemChange = 'ECONOMIC_SYSTEM_CHANGE',
  EducationDeveloped = 'EDUCATION_DEVELOPED',
  EducationDeveloping = 'EDUCATION_DEVELOPING',
  Energy = 'ENERGY',
  ExistentialRisk = 'EXISTENTIAL_RISK',
  FoodNutritionDeveloped = 'FOOD_NUTRITION_DEVELOPED',
  FoodNutritionDeveloping = 'FOOD_NUTRITION_DEVELOPING',
  GlobalSecurityPeace = 'GLOBAL_SECURITY_PEACE',
  HealthDeveloped = 'HEALTH_DEVELOPED',
  HealthDeveloping = 'HEALTH_DEVELOPING',
  HomelessnessReduction = 'HOMELESSNESS_REDUCTION',
  HumanRights = 'HUMAN_RIGHTS',
  LandUseReform = 'LAND_USE_REFORM',
  MentalHealthWellbeing = 'MENTAL_HEALTH_WELLBEING',
  MetaCharity = 'META_CHARITY',
  MigrationAntiSlavery = 'MIGRATION_ANTI_SLAVERY',
  NatureEnvironmentalConservation = 'NATURE_ENVIRONMENTAL_CONSERVATION',
  NuclearSafety = 'NUCLEAR_SAFETY',
  PromotingEffectiveAltruism = 'PROMOTING_EFFECTIVE_ALTRUISM',
  Psychedelics = 'PSYCHEDELICS',
  PublicPolicyDeveloped = 'PUBLIC_POLICY_DEVELOPED',
  PublicPolicyDeveloping = 'PUBLIC_POLICY_DEVELOPING',
  SafeguardingFuture = 'SAFEGUARDING_FUTURE',
  ScienceResearchTechnology = 'SCIENCE_RESEARCH_TECHNOLOGY',
  SportsRecreation = 'SPORTS_RECREATION',
  WaterSanitation = 'WATER_SANITATION',
  WomensEmpowermentDeveloped = 'WOMENS_EMPOWERMENT_DEVELOPED',
  WomensEmpowermentDeveloping = 'WOMENS_EMPOWERMENT_DEVELOPING',
}

export type PrivateSecurityItem = {
  __typename?: 'PrivateSecurityItem'
  additionalInstructions?: Maybe<Scalars['String']['output']>
  assetOwnerId?: Maybe<Scalars['String']['output']>
  companyContactEmail: Scalars['String']['output']
  companyContactName: Scalars['String']['output']
  companyName: Scalars['String']['output']
  giftAccountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  numOfShares: Scalars['Float']['output']
  status: Scalars['String']['output']
}

/** Autogenerated input type of ProcessCaseRecordGrantCompliance */
export type ProcessCaseRecordGrantComplianceInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of ProcessCaseRecordGrantCompliance. */
export type ProcessCaseRecordGrantCompliancePayload = {
  __typename?: 'ProcessCaseRecordGrantCompliancePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of PromoteFromWaitlist */
export type PromoteFromWaitlistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  registrationId: Scalars['ID']['input']
}

/** Autogenerated return type of PromoteFromWaitlist. */
export type PromoteFromWaitlistPayload = {
  __typename?: 'PromoteFromWaitlistPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  registration?: Maybe<EventRegistrationAdmin>
  warnings: Array<Scalars['String']['output']>
}

export type PublicSecurityItem = {
  __typename?: 'PublicSecurityItem'
  acquisitionDate?: Maybe<Scalars['ISO8601Date']['output']>
  additionalInstructions?: Maybe<Scalars['String']['output']>
  assetOwnerId?: Maybe<Scalars['String']['output']>
  brokerEmail?: Maybe<Scalars['String']['output']>
  brokerName?: Maybe<Scalars['String']['output']>
  brokerPhone?: Maybe<Scalars['String']['output']>
  estimatedShareValue: Money
  estimatedTotalValue: Money
  giftAccountId: Scalars['String']['output']
  hasRestrictions: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isin?: Maybe<Scalars['String']['output']>
  numOfShares: Scalars['Float']['output']
  portfolioAccountNumber?: Maybe<Scalars['String']['output']>
  restrictionDetails?: Maybe<Scalars['String']['output']>
  sedol?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
}

/** Autogenerated input type of PublishDafStatements */
export type PublishDafStatementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of PublishDafStatements. */
export type PublishDafStatementsPayload = {
  __typename?: 'PublishDafStatementsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of PublishTrainingCourse */
export type PublishTrainingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  courseId: Scalars['ID']['input']
}

/** Autogenerated return type of PublishTrainingCourse. */
export type PublishTrainingCoursePayload = {
  __typename?: 'PublishTrainingCoursePayload'
  assignedCount: Scalars['Int']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: TrainingCourseAdmin
}

/** Autogenerated input type of PublishTrainingModule */
export type PublishTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Defaults to today plus the module's due_within_days */
  dueOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of PublishTrainingModule. */
export type PublishTrainingModulePayload = {
  __typename?: 'PublishTrainingModulePayload'
  assignedCount: Scalars['Int']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

export type QueryAdmin = {
  __typename?: 'QueryAdmin'
  /** returns list of Admin Fee Sage Journal Entries */
  adminFeeSageJournalEntries: AdminFeeSageJournalEntryCollection
  /** returns a Admin Fee Sage Journal Entry */
  adminFeeSageJournalEntry: AdminFeeSageJournalEntry
  /** returns website amended pledge */
  amendedPledge: AmendedPledgeAdmin
  /** returns website amended pledges */
  amendedPledges: AmendedPledgeAdminCollection
  /** one asset with its history */
  asset: Asset
  /** how many devices are confirmed in LighthouseIT's RMM and Apple Business Manager */
  assetDeviceCheckSummary: AssetDeviceCheckSummary
  /** leavers with kit to come back or be wiped, soonest leaving date first */
  assetReturns: Array<AssetLeaver>
  /** returns all salesforce attachments (old and new version) for the object */
  attachments?: Maybe<Array<SfAttachments>>
  /** reconciles Salesforce fund account balances against Sage for one legal entity */
  balanceReconciliation: BalanceReconciliationResult
  /** Sage journal lines and Salesforce case lines behind the balance reconciliation */
  balanceReconciliationTransactions: BalanceReconciliationTransactions
  /** campaigns to link an event to, matched on name or Salesforce ID */
  campaigns: Array<EventCampaign>
  /** returns case processing records */
  caseProcessingRecords: Array<CaseProcessingRecord>
  /** returns a case record by case number or id */
  caseRecord?: Maybe<CaseRecord>
  /** returns a case's journal entries, Sage entries and money-related timeline */
  caseRecordAccountingHistory: AccountingHistory
  /** returns a list of case records */
  caseRecords: CaseRecordCollection
  /** returns a list of case types */
  caseTypes: Array<CaseType>
  /** returns a list of charities */
  charities: CharityCollection
  /** returns a charity */
  charity: Charity
  /** returns a charity bank account */
  charityBankAccount: AdminCharityBankAccount
  /** returns bank accounts for a charity, optionally filtered by status and checklist */
  charityBankAccounts: Array<AdminCharityBankAccount>
  /** returns charity categories */
  charityCategories: CharityCategoryAdminCollection
  /** returns a charity category */
  charityCategory: CharityCategoryAdmin
  /** returns pending or cancelled charity contact invitations for a charity */
  charityContactInvitations: Array<AdminCharityContactInvitation>
  /** returns a list of charity contacts */
  charityContacts: Array<AdminCharityContact>
  /** returns a list of companies */
  companies: CompanyAdminCollection
  /** returns a company */
  company: CompanyAdmin
  /** returns a list of company record types */
  companyRecordTypes: Array<CompanyRecord>
  /** returns a contact */
  contact: Contact
  /** returns a list of contact record types */
  contactRecordTypes: Array<ContactRecord>
  /** returns a list of contacts */
  contacts: ContactCollection
  /** one contract with its documents */
  contract: Contract
  /** what needs attention on the contract register */
  contractSummary: ContractSummary
  /** the official copy of a policy's current version, for anyone signed in */
  currentPolicyDocument?: Maybe<PolicyDocumentLink>
  /** returns a DAF Fee Period */
  dafAdminFeePeriod: DafAdminFeePeriod
  /** returns list of DAF Fee Periods */
  dafAdminFeePeriods: DafAdminFeePeriodCollection
  /** returns list of all the DAF Fees for a Fund */
  dafAdminFeesForFund: Array<FundAdminFee>
  /** returns list of all the DAF Advisor External OPEX Donations */
  dafAdvisorExternalOpexDonations: Array<DafAdvisorExternalOpexDonation>
  /** returns upcoming DAF Investment Allocation Changes */
  dafInvestmentAllocationChanges: DafInvestmentAllocationChangeCollection
  /** returns upcoming DAF Plan Changes */
  dafPlanChanges: DafPlanChangeCollection
  /** returns daf statement periods */
  dafStatementPeriods: Array<DafStatementPeriod>
  /** returns daf statements */
  dafStatements: Array<DafStatement>
  /** returns a data upload */
  dataUpload: DataUpload
  /** returns a list of data upload rows */
  dataUploadRows: Array<DataUploadRow>
  /** returns a list of data uploads */
  dataUploads: DataUploadCollection
  /** returns a employee */
  employee: Employee
  /** returns list of all employees */
  employees: Array<Employee>
  /** returns an event */
  event: EventAdmin
  /** one guest, with their activity, for the guest side panel */
  eventAttendee: EventAttendeeAdmin
  /** the org-wide reusable registration question library */
  eventQuestionTemplates: Array<EventQuestionTemplate>
  /** org-wide event defaults, e.g. the T&Cs new events start with */
  eventSettings: EventSettings
  /** whether the website has an event page in Strapi for this slug */
  eventWebsitePageStatus: EventWebsitePageStatusEnum
  /** returns events */
  events: EventAdminCollection
  /** upcoming/past counts for the events home header */
  eventsSummary: EventsSummary
  /** returns exchange rates */
  exchangeRates: ExchangeRateCollection
  /** returns a fund */
  fund: Fund
  /** returns fund account average monthly balances */
  fundAccountAverageMonthlyBalances: FundAccountAverageMonthlyBalanceCollection
  /** returns a list of fund accounts */
  fundAccounts: FundAccountCollection
  /** returns a fund group */
  fundGroup: FundGroup
  /** returns a list of fund groups */
  fundGroups: FundGroupCollection
  /** returns a list of fund record types */
  fundRecordTypes: Array<FundRecord>
  /** returns a list of funds */
  funds: FundCollection
  /** returns gift account balances */
  giftAccountBalances: Array<GiftAccountBalance>
  /** returns matching admin records for a search query */
  globalSearch: Array<GlobalSearchHit>
  /** returns grant basket items */
  grantBasketItems: GrantBasketItemAdminCollection
  /** returns case records that use a GrantCaseRecord delegate */
  grants: CaseRecordCollection
  /** returns a hifo */
  hifo: HifoAdmin
  /** returns Salesforce charity fields for HIFO form autofill */
  hifoAutofill?: Maybe<HifoAdmin>
  /** returns a hifo cascade */
  hifoCascade: HifoCascade
  /** returns hifo cascades */
  hifoCascades: HifoCascadeCollection
  /** returns hifos */
  hifos: HifoAdminCollection
  /** returns impact measurement categories */
  impactMeasurementCategories: Array<ImpactMeasurementCategory>
  /** returns a impact measurement category */
  impactMeasurementCategory: ImpactMeasurementCategory
  /** returns a impact measurement item */
  impactMeasurementItem: ImpactMeasurementItem
  /** returns investment account performances */
  investmentAccountPerformances: Array<InvestmentAccountPerformance>
  /** returns investment daily balances */
  investmentDailyBalances: Array<InvestmentDailyBalance>
  /** returns investment periods */
  investmentPeriods: Array<InvestmentPeriod>
  /** returns investment pool performances */
  investmentPoolPerformances: Array<InvestmentPoolPerformance>
  /** returns investment pools */
  investmentPools: Array<InvestmentPool>
  /** returns list of all legal entities */
  legalEntities: Array<LegalEntityAdmin>
  /** returns a legal entity by name */
  legalEntityByName: LegalEntityAdmin
  /** returns a match campaign */
  matchCampaign: MatchCampaignAdmin
  /** returns match campaign categories */
  matchCampaignCategories: Array<MatchCampaignCategory>
  /** returns a match campaign category */
  matchCampaignCategory: MatchCampaignCategory
  /** returns match campaigns */
  matchCampaigns: Array<MatchCampaignAdmin>
  /** a quiz attempt the caller owns */
  myQuizAttempt: StaffQuizAttempt
  /** the caller's training dashboard */
  myTraining: MyTraining
  /** one published course for the caller */
  myTrainingCourse: StaffTrainingCourse
  /** one published module for the caller */
  myTrainingModule: StaffTrainingModule
  /** returns news item */
  newsItem: NewsItemAdmin
  /** returns news item types */
  newsItemTypes: Array<NewsItemEvent>
  /** returns news items */
  newsItems: NewsItemAdminCollection
  /** returns list of all permissions */
  permissions: Array<Permission>
  /** preview personalised HIFO recommendations for the given preferences */
  personalisedHifoRecommendations: Array<PersonalisedHifoRecommendationAdmin>
  /** returns website pledge */
  pledge: PledgeAdmin
  /** returns website pledges */
  pledges: PledgeAdminCollection
  /** every policy */
  policies: Array<PolicyAdmin>
  /** one policy */
  policy: PolicyAdmin
  /** returns potential matches for a sage journal entry */
  potentialMatches: Array<PotentialMatch>
  /** returns a list of related case records */
  relatedCaseRecords: Array<RelatedCase>
  /** returns a request for funding */
  requestForFunding: RequestForFunding
  /** returns a list of requests for funding */
  requestsForFunding: RequestForFundingCollection
  /** returns a role */
  role: Role
  /** returns list of all roles */
  roles: Array<Role>
  /** returns a sage gift account */
  sageGiftAccount: SageGiftAccount
  /** counts of Sage gift account differences by status and kind */
  sageGiftAccountDifferenceCounts: SageGiftAccountDifferenceCounts
  /** differences between expected and actual Sage gift accounts */
  sageGiftAccountDifferences: SageGiftAccountDifferenceCollection
  /** returns a list of sage gift account records */
  sageGiftAccountRecords: SageGiftAccountCollection
  /** returns sage gift accounts */
  sageGiftAccounts: Array<SageGiftAccount>
  /** returns sage journal entries */
  sageJournalEntries: SageJournalEntryCollection
  /** returns a sage journal entry */
  sageJournalEntry: SageJournalEntry
  /** returns a sage salesforce metric */
  sageSalesforceMetric: SageSalesforceMetric
  /** the asset register, newest FPH number first */
  searchAssets: AssetCollection
  /** the contract register, soonest deadline first */
  searchContracts: ContractCollection
  /** returns a list of employees */
  searchEmployees: EmployeeCollection
  /** one row per person in scope, by name */
  searchTrainingCompliance: TrainingComplianceRowCollection
  /** active employees with training switched off */
  searchTrainingOutOfScope: EmployeeCollection
  /** returns session info for current user */
  sessionInfo: User
  /** returns a target audience */
  targetAudience: TargetAudience
  /** returns target audiences */
  targetAudiences: Array<TargetAudience>
  /** every team by name, active ones only unless include_archived */
  teams: Array<Team>
  test: Scalars['String']['output']
  /** course categories, in order */
  trainingCategories: Array<TrainingCategory>
  /** the tracker's column headers: published modules of mandatory courses, in course order */
  trainingComplianceModules: Array<StaffTrainingModuleSummary>
  /** headline figures for everyone in scope */
  trainingComplianceSummary: TrainingComplianceSummary
  /** one course with its modules and employees */
  trainingCourse: TrainingCourseAdmin
  /** one row per person who can see the course or has started it, by name, with a cell per published module */
  trainingCourseProgress: Array<TrainingCourseProgressRow>
  /** every course, including drafts and archived, in order */
  trainingCourses: Array<TrainingCourseAdmin>
  /** every assignment, attempt and acknowledgement for one person */
  trainingEmployeeDetail: TrainingEmployeeDetail
  /** one module with its question bank, correct answers and stats */
  trainingModule: TrainingModuleAdmin
  /** every compliance module, including drafts and archived. Course modules come with their course */
  trainingModules: Array<TrainingModuleAdmin>
  /** every training Slack message, newest first */
  trainingNudges: TrainingNudgeAdminCollection
  /** returns a US due diligence */
  usDueDiligence?: Maybe<UsDueDiligence>
  /** returns website user */
  user: User
  /** returns website users */
  users: UserCollection
}

export type QueryAdminAdminFeeSageJournalEntriesArgs = {
  journalEntryTypes?: InputMaybe<Array<AdminFeeSageJournalEntryGrouping>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<AdminFeeSageJournalEntryStatus>>
}

export type QueryAdminAdminFeeSageJournalEntryArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminAmendedPledgeArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminAmendedPledgesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  status: PledgeSearchEnum
}

export type QueryAdminAssetArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminAssetReturnsArgs = {
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryAdminAttachmentsArgs = {
  recordId: Scalars['ID']['input']
  recordType: Scalars['String']['input']
}

export type QueryAdminBalanceReconciliationArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>
  exceptionThresholdMinorUnits?: InputMaybe<Scalars['Int']['input']>
  fundCategories?: InputMaybe<Array<FundCategory>>
  legalEntity: ReconciliationLegalEntity
}

export type QueryAdminBalanceReconciliationTransactionsArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>
  fundCategories?: InputMaybe<Array<FundCategory>>
  legalEntity: ReconciliationLegalEntity
}

export type QueryAdminCampaignsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminCaseProcessingRecordsArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  dateTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type QueryAdminCaseRecordArgs = {
  caseNumber?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminCaseRecordAccountingHistoryArgs = {
  caseRecordId: Scalars['ID']['input']
}

export type QueryAdminCaseRecordsArgs = {
  balanceType?: InputMaybe<BalanceTypeEnum>
  filterGroup?: InputMaybe<CaseRecordFilterGroupInput>
  fundAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>
  includeSageJournalEntries?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminCharitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  stringFilters?: InputMaybe<Array<CharityStringFilterInput>>
}

export type QueryAdminCharityArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminCharityBankAccountArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminCharityBankAccountsArgs = {
  charityId: Scalars['ID']['input']
  checklistIncomplete?: InputMaybe<Scalars['Boolean']['input']>
  hasFlaggedChecklistItems?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Array<InputMaybe<CharityBankAccountStatusEnum>>>
}

export type QueryAdminCharityCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminCharityCategoryArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminCharityContactInvitationsArgs = {
  charityId: Scalars['ID']['input']
  status: CharityContactInvitationListStatusEnum
}

export type QueryAdminCharityContactsArgs = {
  charityId: Scalars['ID']['input']
}

export type QueryAdminCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  stringFilters?: InputMaybe<Array<CompanyStringFilterInput>>
}

export type QueryAdminCompanyArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminContactArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminContactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  stringFilters?: InputMaybe<Array<ContactStringFilterInput>>
}

export type QueryAdminContractArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminCurrentPolicyDocumentArgs = {
  policyId: Scalars['ID']['input']
}

export type QueryAdminDafAdminFeePeriodArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminDafAdminFeePeriodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminDafAdminFeesForFundArgs = {
  fundId: Scalars['ID']['input']
}

export type QueryAdminDafAdvisorExternalOpexDonationsArgs = {
  dateFrom: Scalars['ISO8601Date']['input']
  dateTo: Scalars['ISO8601Date']['input']
}

export type QueryAdminDafInvestmentAllocationChangesArgs = {
  fundId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAdminDafPlanChangesArgs = {
  fundId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAdminDafStatementsArgs = {
  endDate: Scalars['ISO8601Date']['input']
  startDate: Scalars['ISO8601Date']['input']
}

export type QueryAdminDataUploadArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminDataUploadRowsArgs = {
  dataUploadId: Scalars['ID']['input']
}

export type QueryAdminDataUploadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAdminEmployeeArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminEventArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminEventAttendeeArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminEventWebsitePageStatusArgs = {
  slug: Scalars['String']['input']
}

export type QueryAdminEventsArgs = {
  city?: InputMaybe<Scalars['String']['input']>
  eventType?: InputMaybe<EventTypeEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  period?: InputMaybe<EventPeriodEnum>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<EventStatusEnum>
}

export type QueryAdminExchangeRatesArgs = {
  currency?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminFundArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminFundAccountAverageMonthlyBalancesArgs = {
  fundAccountId: Scalars['ID']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminFundAccountsArgs = {
  adminFeeIssueFilter?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminFundGroupArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminFundGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminFundsArgs = {
  dateFilters?: InputMaybe<Array<DateFilterInput>>
  legalEntityFilters?: InputMaybe<Array<Scalars['ID']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  numericFilters?: InputMaybe<Array<NumericFilterInput>>
  page?: InputMaybe<Scalars['Int']['input']>
  recordTypeFilters?: InputMaybe<Array<Scalars['ID']['input']>>
  sortBy?: InputMaybe<Scalars['String']['input']>
  stringFilters?: InputMaybe<Array<StringFilterInput>>
}

export type QueryAdminGiftAccountBalancesArgs = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']['input']>
  dateTo?: InputMaybe<Scalars['ISO8601Date']['input']>
}

export type QueryAdminGlobalSearchArgs = {
  limitPerType?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QueryAdminGrantBasketItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  status: GrantBasketItemsSearchEnum
}

export type QueryAdminGrantsArgs = {
  filterGroup?: InputMaybe<GrantFilterGroupInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  senderLegalEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>
  sortBy?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<GrantCaseRecordStatusEnum>>
}

export type QueryAdminHifoArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminHifoAutofillArgs = {
  charityId?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminHifoCascadeArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminHifoCascadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<HifoCascadeStatusEnum>
}

export type QueryAdminHifosArgs = {
  hifoTypes?: InputMaybe<Array<HifoTypeEnum>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<HifoStatus>>
}

export type QueryAdminImpactMeasurementCategoryArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminImpactMeasurementItemArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminInvestmentDailyBalancesArgs = {
  currencyFilter?: InputMaybe<Scalars['String']['input']>
  investmentPeriodId: Scalars['ID']['input']
  legalEntityName: Scalars['String']['input']
}

export type QueryAdminLegalEntityByNameArgs = {
  name: Scalars['String']['input']
}

export type QueryAdminMatchCampaignArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminMatchCampaignCategoryArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminMyQuizAttemptArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminMyTrainingCourseArgs = {
  slug: Scalars['String']['input']
}

export type QueryAdminMyTrainingModuleArgs = {
  slug: Scalars['String']['input']
}

export type QueryAdminNewsItemArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminNewsItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  searchFilter: NewsItemsSearchEnum
}

export type QueryAdminPersonalisedHifoRecommendationsArgs = {
  preferences: GivingPreferencesInput
}

export type QueryAdminPledgeArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminPledgesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  status: PledgeSearchEnum
}

export type QueryAdminPolicyArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminPotentialMatchesArgs = {
  amountRange?: InputMaybe<Scalars['Int']['input']>
  currencyMustMatch?: InputMaybe<Scalars['Boolean']['input']>
  dateRange?: InputMaybe<Scalars['Int']['input']>
  includeCasesAlreadyMatched?: InputMaybe<Scalars['Boolean']['input']>
  limitByDate?: InputMaybe<Scalars['Boolean']['input']>
  limitByDescription?: InputMaybe<Scalars['Boolean']['input']>
  limitByLegalEntity?: InputMaybe<Scalars['Boolean']['input']>
  limitBySageGiftAccount?: InputMaybe<Scalars['Boolean']['input']>
  limitByValue?: InputMaybe<Scalars['Boolean']['input']>
  sageJournalEntryId: Scalars['ID']['input']
}

export type QueryAdminRelatedCaseRecordsArgs = {
  caseRecordId: Scalars['ID']['input']
}

export type QueryAdminRequestForFundingArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminRequestsForFundingArgs = {
  formType?: InputMaybe<RequestForFundingFormTypeEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminRoleArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminSageGiftAccountArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminSageGiftAccountDifferencesArgs = {
  fundAccountId?: InputMaybe<Scalars['ID']['input']>
  kinds?: InputMaybe<Array<SageGiftAccountDifferenceKind>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sageGiftAccountId?: InputMaybe<Scalars['ID']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<SageGiftAccountDifferenceStatus>>
}

export type QueryAdminSageGiftAccountRecordsArgs = {
  filters?: InputMaybe<Array<SageGiftAccountFilterConditionInput>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminSageJournalEntriesArgs = {
  filters?: InputMaybe<Array<SageJournalEntryFilterConditionInput>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminSageJournalEntryArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminSageSalesforceMetricArgs = {
  forMonth?: InputMaybe<Scalars['ISO8601Date']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  metricType: SageSalesforceMetricTypeEnum
}

export type QueryAdminSearchAssetsArgs = {
  categories?: InputMaybe<Array<AssetCategoryEnum>>
  deviceCheck?: InputMaybe<AssetDeviceCheckFilterEnum>
  employeeId?: InputMaybe<Scalars['ID']['input']>
  entity?: InputMaybe<AssetEntityEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  productTypes?: InputMaybe<Array<AssetProductTypeEnum>>
  search?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<AssetStatusEnum>>
}

export type QueryAdminSearchContractsArgs = {
  attention?: InputMaybe<ContractAttentionEnum>
  autoRenews?: InputMaybe<Scalars['Boolean']['input']>
  contractTypes?: InputMaybe<Array<ContractTypeEnum>>
  legalEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  purposes?: InputMaybe<Array<ContractPurposeEnum>>
  search?: InputMaybe<Scalars['String']['input']>
  statuses?: InputMaybe<Array<ContractStatusEnum>>
  teamId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminSearchEmployeesArgs = {
  booleanFilters?: InputMaybe<Array<EmployeeBooleanFilterInput>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  stringFilters?: InputMaybe<Array<EmployeeStringFilterInput>>
}

export type QueryAdminSearchTrainingComplianceArgs = {
  accessStatus?: InputMaybe<TrainingAccessStatusEnum>
  categoryId?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  overall?: InputMaybe<TrainingOverallStatusEnum>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  teamId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminSearchTrainingOutOfScopeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminTargetAudienceArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminTeamsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryAdminTrainingCategoriesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryAdminTrainingComplianceModulesArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminTrainingComplianceSummaryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminTrainingCourseArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminTrainingCourseProgressArgs = {
  courseId: Scalars['ID']['input']
}

export type QueryAdminTrainingCoursesArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryAdminTrainingEmployeeDetailArgs = {
  employeeId: Scalars['ID']['input']
}

export type QueryAdminTrainingModuleArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminTrainingNudgesArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>
  kind?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdminUsDueDiligenceArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminUserArgs = {
  id: Scalars['ID']['input']
}

export type QueryAdminUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  searchType?: InputMaybe<UserSearchEnum>
  sortBy?: InputMaybe<Scalars['String']['input']>
}

export type QuizAnswerInput = {
  optionId: Scalars['ID']['input']
  questionId: Scalars['ID']['input']
}

/** Autogenerated input type of ReadContractDocumentAgain */
export type ReadContractDocumentAgainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of ReadContractDocumentAgain. */
export type ReadContractDocumentAgainPayload = {
  __typename?: 'ReadContractDocumentAgainPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of ReadPolicyDocumentAgain */
export type ReadPolicyDocumentAgainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  documentId: Scalars['ID']['input']
}

/** Autogenerated return type of ReadPolicyDocumentAgain. */
export type ReadPolicyDocumentAgainPayload = {
  __typename?: 'ReadPolicyDocumentAgainPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policy: PolicyAdmin
}

/** Autogenerated input type of RecalculateDafAdminFees */
export type RecalculateDafAdminFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of RecalculateDafAdminFees. */
export type RecalculateDafAdminFeesPayload = {
  __typename?: 'RecalculateDafAdminFeesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Legal entities with a Sage location */
export enum ReconciliationLegalEntity {
  FpiUs = 'FPI_US',
  FplUk = 'FPL_UK',
  Germany = 'GERMANY',
}

export type ReconciliationSageTransaction = {
  __typename?: 'ReconciliationSageTransaction'
  batchDate: Scalars['ISO8601Date']['output']
  batchReference?: Maybe<Scalars['String']['output']>
  generalLedgerAccount: Scalars['String']['output']
  generalLedgerName: Scalars['String']['output']
  giftAccountCode: Scalars['String']['output']
  giftAccountName?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  matched: Scalars['Boolean']['output']
  memo?: Maybe<Scalars['String']['output']>
  reportingAmount: Money
}

export type ReconciliationSalesforceTransaction = {
  __typename?: 'ReconciliationSalesforceTransaction'
  amount: Money
  caseNumber?: Maybe<Scalars['String']['output']>
  caseRecordId: Scalars['String']['output']
  giftAccountCode?: Maybe<Scalars['String']['output']>
  giftAccountName: Scalars['String']['output']
  id: Scalars['String']['output']
  matched: Scalars['Boolean']['output']
  recordType: Scalars['String']['output']
  side: Scalars['String']['output']
  subject?: Maybe<Scalars['String']['output']>
  transactionDate?: Maybe<Scalars['ISO8601Date']['output']>
}

/** Autogenerated input type of RecordAssetCheck */
export type RecordAssetCheckInput = {
  assetId: Scalars['ID']['input']
  checkedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The device's name or ID in that system */
  externalRef?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  result: AssetCheckResultEnum
  source: AssetCheckSourceEnum
}

/** Autogenerated return type of RecordAssetCheck. */
export type RecordAssetCheckPayload = {
  __typename?: 'RecordAssetCheckPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of RecordContractRenewalDecision */
export type RecordContractRenewalDecisionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Defaults to today; for notice, the day it was sent */
  decidedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Null clears a decision made by mistake */
  decision?: InputMaybe<ContractRenewalDecisionEnum>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of RecordContractRenewalDecision. */
export type RecordContractRenewalDecisionPayload = {
  __typename?: 'RecordContractRenewalDecisionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of RecordPolicyAcknowledgement */
export type RecordPolicyAcknowledgementInput = {
  /** Defaults to now */
  acknowledgedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeId: Scalars['ID']['input']
  policyId: Scalars['ID']['input']
}

/** Autogenerated return type of RecordPolicyAcknowledgement. */
export type RecordPolicyAcknowledgementPayload = {
  __typename?: 'RecordPolicyAcknowledgementPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policyAcknowledgement: PolicyAcknowledgement
}

/** Autogenerated input type of RecordPolicyReview */
export type RecordPolicyReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** When a new version takes effect */
  effectiveOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** Required for a new version */
  newVersion?: InputMaybe<Scalars['String']['input']>
  /** Defaults to the review date plus the policy's review cycle */
  nextReviewOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  outcome: PolicyReviewOutcomeEnum
  policyId: Scalars['ID']['input']
  /** Defaults to today */
  reviewedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
}

/** Autogenerated return type of RecordPolicyReview. */
export type RecordPolicyReviewPayload = {
  __typename?: 'RecordPolicyReviewPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policy: PolicyAdmin
}

/** Autogenerated input type of RecordTrainingVideoProgress */
export type RecordTrainingVideoProgressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
  percent: Scalars['Int']['input']
}

/** Autogenerated return type of RecordTrainingVideoProgress. */
export type RecordTrainingVideoProgressPayload = {
  __typename?: 'RecordTrainingVideoProgressPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: StaffTrainingModule
}

export type RecurringGrant = {
  __typename?: 'RecurringGrant'
  amount: Money
  createdAt: Scalars['ISO8601DateTime']['output']
  frequency: RecurringGrantFrequency
  giftAccountId: Scalars['String']['output']
  hasSufficientFundsForNextGrant: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  nextGrantDate: Scalars['ISO8601Date']['output']
  nextGrantStatus: RecurringGrantNextGrantStatus
  recipientName: Scalars['String']['output']
  submittedBy: Scalars['String']['output']
}

export enum RecurringGrantFrequency {
  /** Grant repeats every month */
  Monthly = 'MONTHLY',
  /** Grant repeats every year */
  Yearly = 'YEARLY',
}

export enum RecurringGrantNextGrantStatus {
  FailedInsufficientFunds = 'FAILED_INSUFFICIENT_FUNDS',
  FailedOther = 'FAILED_OTHER',
  Pending = 'PENDING',
}

/** Autogenerated input type of RegenerateDafStatements */
export type RegenerateDafStatementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of RegenerateDafStatements. */
export type RegenerateDafStatementsPayload = {
  __typename?: 'RegenerateDafStatementsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export enum RegionEnum {
  Europe = 'EUROPE',
  Other = 'OTHER',
  Us = 'US',
}

/** Autogenerated input type of RegisterAttendees */
export type RegisterAttendeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
  lead: AttendeeDetailsInput
  notify?: InputMaybe<Scalars['Boolean']['input']>
  plusOnes?: InputMaybe<Array<AttendeeDetailsInput>>
  target?: InputMaybe<RegistrationTargetEnum>
}

/** Autogenerated return type of RegisterAttendees. */
export type RegisterAttendeesPayload = {
  __typename?: 'RegisterAttendeesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  registration?: Maybe<EventRegistrationAdmin>
  state: Scalars['String']['output']
}

export enum RegistrationTargetEnum {
  /** Confirm if capacity allows, waitlist otherwise (normal allocation) */
  Confirmed = 'CONFIRMED',
  /** Join the waitlist directly, even while capacity remains */
  Waitlisted = 'WAITLISTED',
}

export type RelatedCase = {
  __typename?: 'RelatedCase'
  caseType: Scalars['String']['output']
  id: Scalars['ID']['output']
  relatedCase: CaseRecord
}

/** Autogenerated input type of RemoveSecondFactors */
export type RemoveSecondFactorsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  code: Scalars['String']['input']
  userId: Scalars['ID']['input']
}

/** Autogenerated return type of RemoveSecondFactors. */
export type RemoveSecondFactorsPayload = {
  __typename?: 'RemoveSecondFactorsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of ReopenSageGiftAccountDifferences */
export type ReopenSageGiftAccountDifferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  ids: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of ReopenSageGiftAccountDifferences. */
export type ReopenSageGiftAccountDifferencesPayload = {
  __typename?: 'ReopenSageGiftAccountDifferencesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  results: Array<SageGiftAccountDifferenceActionResult>
}

/** Autogenerated input type of ReorderHifoCascade */
export type ReorderHifoCascadeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadeId: Scalars['ID']['input']
  pitchOrdering: Array<PitchOrderingInput>
}

/** Autogenerated return type of ReorderHifoCascade. */
export type ReorderHifoCascadePayload = {
  __typename?: 'ReorderHifoCascadePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  hifoCascade?: Maybe<HifoCascade>
}

/** Autogenerated input type of ReorderTrainingCourseModules */
export type ReorderTrainingCourseModulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  courseId: Scalars['ID']['input']
  /** Every module in the course, in the new order */
  moduleIds: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of ReorderTrainingCourseModules. */
export type ReorderTrainingCourseModulesPayload = {
  __typename?: 'ReorderTrainingCourseModulesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: TrainingCourseAdmin
}

/** Autogenerated input type of ReorderTrainingCourses */
export type ReorderTrainingCoursesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Every course, in the new order */
  courseIds: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of ReorderTrainingCourses. */
export type ReorderTrainingCoursesPayload = {
  __typename?: 'ReorderTrainingCoursesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourses: Array<TrainingCourseAdmin>
}

/** Autogenerated input type of ReorderTrainingModules */
export type ReorderTrainingModulesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Every module, in the new order */
  moduleIds: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of ReorderTrainingModules. */
export type ReorderTrainingModulesPayload = {
  __typename?: 'ReorderTrainingModulesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModules: Array<TrainingModuleAdmin>
}

export type RequestForFunding = {
  __typename?: 'RequestForFunding'
  budget?: Maybe<Scalars['String']['output']>
  clientRequestId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentBudget?: Maybe<Scalars['String']['output']>
  educationReach?: Maybe<Scalars['String']['output']>
  evidenceLinks?: Maybe<Scalars['String']['output']>
  formType: RequestForFundingFormTypeEnum
  id: Scalars['ID']['output']
  incomeIncreases?: Maybe<Scalars['String']['output']>
  jobTrainingReach?: Maybe<Scalars['String']['output']>
  literacyOrNumeracyGains?: Maybe<Scalars['String']['output']>
  primaryContactEmail: Scalars['String']['output']
  program?: Maybe<Scalars['String']['output']>
  programCategory?: Maybe<Scalars['String']['output']>
  rawPayload: Scalars['JSON']['output']
  submissionIp?: Maybe<Scalars['String']['output']>
  submissionUserAgent?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  website?: Maybe<Scalars['String']['output']>
  whatYourProgramDoes?: Maybe<Scalars['String']['output']>
}

/** RequestForFundingCollection type */
export type RequestForFundingCollection = {
  __typename?: 'RequestForFundingCollection'
  /** A collection of paginated RequestForFundingCollection */
  collection: Array<RequestForFunding>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export enum RequestForFundingFormTypeEnum {
  ExpressionOfInterest = 'ExpressionOfInterest',
  MakeUsAware = 'MakeUsAware',
}

/** Autogenerated input type of RequireTrainingRetake */
export type RequireTrainingRetakeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dueOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of RequireTrainingRetake. */
export type RequireTrainingRetakePayload = {
  __typename?: 'RequireTrainingRetakePayload'
  assignedCount: Scalars['Int']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ResendCharityContactInvite */
export type ResendCharityContactInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  invitationId: Scalars['ID']['input']
}

/** Autogenerated return type of ResendCharityContactInvite. */
export type ResendCharityContactInvitePayload = {
  __typename?: 'ResendCharityContactInvitePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of ResendConfirmation */
export type ResendConfirmationInput = {
  attendeeId?: InputMaybe<Scalars['ID']['input']>
  attendeeUuid?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of ResendConfirmation. */
export type ResendConfirmationPayload = {
  __typename?: 'ResendConfirmationPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ResolveContactDifferences */
export type ResolveContactDifferencesInput = {
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Fields whose difference is fine as is */
  dismiss?: InputMaybe<Array<EventContactFieldEnum>>
  /** Fields to copy from the guest to Salesforce */
  updateSalesforce?: InputMaybe<Array<EventContactFieldEnum>>
  /** Fields to copy from Salesforce onto the guest */
  useSalesforce?: InputMaybe<Array<EventContactFieldEnum>>
}

/** Autogenerated return type of ResolveContactDifferences. */
export type ResolveContactDifferencesPayload = {
  __typename?: 'ResolveContactDifferencesPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of RetireCharityBankAccount */
export type RetireCharityBankAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of RetireCharityBankAccount. */
export type RetireCharityBankAccountPayload = {
  __typename?: 'RetireCharityBankAccountPayload'
  bankAccount: AdminCharityBankAccount
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of ReturnAsset */
export type ReturnAssetInput = {
  assetId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Where it is now */
  location?: InputMaybe<AssetLocationEnum>
  notes?: InputMaybe<Scalars['String']['input']>
  returnCondition?: InputMaybe<AssetConditionEnum>
  /** KEPT records the asset as disposed */
  returnMethod: AssetReturnMethodEnum
  returnedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** What happens next. Defaults to TO_WIPE */
  status?: InputMaybe<AssetStatusEnum>
}

/** Autogenerated return type of ReturnAsset. */
export type ReturnAssetPayload = {
  __typename?: 'ReturnAssetPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of RevealAssetSecret */
export type RevealAssetSecretInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  reason: Scalars['String']['input']
}

/** Autogenerated return type of RevealAssetSecret. */
export type RevealAssetSecretPayload = {
  __typename?: 'RevealAssetSecretPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  secret: AssetSecret
  secretValue: Scalars['String']['output']
}

export type Role = {
  __typename?: 'Role'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  permissions: Array<Permission>
}

export enum RoleEnum {
  Founder = 'FOUNDER',
  Investor = 'INVESTOR',
  Shareholder = 'SHAREHOLDER',
  Vc = 'VC',
}

export type RoleInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** Autogenerated input type of RunDuplicateChecker */
export type RunDuplicateCheckerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of RunDuplicateChecker. */
export type RunDuplicateCheckerPayload = {
  __typename?: 'RunDuplicateCheckerPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type SageGiftAccount = {
  __typename?: 'SageGiftAccount'
  differences: Array<SageGiftAccountDifference>
  fundAccount?: Maybe<FundAccount>
  /** @deprecated Replaced with Sage to Fund Associations */
  giftAccountId?: Maybe<Scalars['String']['output']>
  /** @deprecated Replaced with Sage to Fund Associations */
  giftAccountName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastSageSyncDate: Scalars['ISO8601DateTime']['output']
  name: Scalars['String']['output']
  openDifferenceCount: Scalars['Int']['output']
  sageClass?: Maybe<Scalars['String']['output']>
  sageCurrency?: Maybe<Scalars['String']['output']>
  sageDepartment?: Maybe<Scalars['String']['output']>
  sageId: Scalars['String']['output']
  sageLastModifiedDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>
  sageLocation?: Maybe<Scalars['String']['output']>
  sageName: Scalars['String']['output']
  status?: Maybe<Scalars['String']['output']>
  syncTransactions: Scalars['Boolean']['output']
  type?: Maybe<Scalars['String']['output']>
}

/** SageGiftAccountCollection type */
export type SageGiftAccountCollection = {
  __typename?: 'SageGiftAccountCollection'
  /** A collection of paginated SageGiftAccountCollection */
  collection: Array<SageGiftAccount>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type SageGiftAccountDifference = {
  __typename?: 'SageGiftAccountDifference'
  acceptDescription?: Maybe<Scalars['String']['output']>
  acceptable: Scalars['Boolean']['output']
  actionedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  actionedByName?: Maybe<Scalars['String']['output']>
  actualValue?: Maybe<Scalars['String']['output']>
  applyError?: Maybe<Scalars['String']['output']>
  expectedValue?: Maybe<Scalars['String']['output']>
  field?: Maybe<Scalars['String']['output']>
  firstSeenAt: Scalars['ISO8601DateTime']['output']
  fundAccount?: Maybe<FundAccount>
  id: Scalars['ID']['output']
  kind: SageGiftAccountDifferenceKind
  lastSeenAt: Scalars['ISO8601DateTime']['output']
  note?: Maybe<Scalars['String']['output']>
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  sageGiftAccount?: Maybe<SageGiftAccount>
  status: SageGiftAccountDifferenceStatus
}

export type SageGiftAccountDifferenceActionResult = {
  __typename?: 'SageGiftAccountDifferenceActionResult'
  difference: SageGiftAccountDifference
  error?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  success: Scalars['Boolean']['output']
}

/** SageGiftAccountDifferenceCollection type */
export type SageGiftAccountDifferenceCollection = {
  __typename?: 'SageGiftAccountDifferenceCollection'
  /** A collection of paginated SageGiftAccountDifferenceCollection */
  collection: Array<SageGiftAccountDifference>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type SageGiftAccountDifferenceCounts = {
  __typename?: 'SageGiftAccountDifferenceCounts'
  acceptedCount: Scalars['Int']['output']
  ignoredCount: Scalars['Int']['output']
  openByKind: Array<SageGiftAccountDifferenceKindCount>
  openCount: Scalars['Int']['output']
  resolvedCount: Scalars['Int']['output']
}

export enum SageGiftAccountDifferenceKind {
  ClassMismatch = 'CLASS_MISMATCH',
  CurrencyMismatch = 'CURRENCY_MISMATCH',
  InactiveWithActivity = 'INACTIVE_WITH_ACTIVITY',
  LocationMismatch = 'LOCATION_MISMATCH',
  MissingGiftAccount = 'MISSING_GIFT_ACCOUNT',
  NameMismatch = 'NAME_MISMATCH',
  UnlinkedMatch = 'UNLINKED_MATCH',
  UnmatchedSageProject = 'UNMATCHED_SAGE_PROJECT',
}

export type SageGiftAccountDifferenceKindCount = {
  __typename?: 'SageGiftAccountDifferenceKindCount'
  count: Scalars['Int']['output']
  kind: SageGiftAccountDifferenceKind
}

export enum SageGiftAccountDifferenceStatus {
  Accepted = 'ACCEPTED',
  Ignored = 'IGNORED',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
}

export type SageGiftAccountFilterConditionInput = {
  field: SageGiftAccountFilterFieldEnum
  operator: FilterOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export enum SageGiftAccountFilterFieldEnum {
  FundAccountId = 'FUND_ACCOUNT_ID',
  FundAccountName = 'FUND_ACCOUNT_NAME',
  SageClass = 'SAGE_CLASS',
  SageCurrency = 'SAGE_CURRENCY',
  SageDepartment = 'SAGE_DEPARTMENT',
  SageId = 'SAGE_ID',
  SageLocation = 'SAGE_LOCATION',
  SageName = 'SAGE_NAME',
  SageStatus = 'SAGE_STATUS',
  SageType = 'SAGE_TYPE',
  SyncSageJournalEntries = 'SYNC_SAGE_JOURNAL_ENTRIES',
}

export type SageJournalEntry = {
  __typename?: 'SageJournalEntry'
  accountNumber: Scalars['String']['output']
  accountTitle: Scalars['String']['output']
  amountIssue?: Maybe<Scalars['Boolean']['output']>
  batchDate: Scalars['ISO8601Date']['output']
  batchNumber: Scalars['String']['output']
  batchReference?: Maybe<Scalars['String']['output']>
  batchTitle: Scalars['String']['output']
  caseAmount?: Maybe<Money>
  caseFundAccount?: Maybe<FundAccount>
  caseLegalEntity?: Maybe<Scalars['String']['output']>
  caseRecord?: Maybe<CaseRecord>
  classId?: Maybe<Scalars['String']['output']>
  className?: Maybe<Scalars['String']['output']>
  currencyIssue?: Maybe<Scalars['Boolean']['output']>
  dateIssue?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  entryDate?: Maybe<Scalars['ISO8601Date']['output']>
  exchangeRate?: Maybe<Scalars['Float']['output']>
  exchangeRateDate?: Maybe<Scalars['ISO8601Date']['output']>
  fundAccountIssue?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  lastSageSyncDate: Scalars['ISO8601DateTime']['output']
  legalEntityIssue?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  locationName?: Maybe<Scalars['String']['output']>
  numberOfIssues?: Maybe<Scalars['Int']['output']>
  sageGiftAccount: SageGiftAccount
  sageId?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  transactionType?: Maybe<Scalars['String']['output']>
  txnAmount: Money
  whenCreated?: Maybe<Scalars['ISO8601DateTime']['output']>
  whenModified?: Maybe<Scalars['ISO8601DateTime']['output']>
}

/** SageJournalEntryCollection type */
export type SageJournalEntryCollection = {
  __typename?: 'SageJournalEntryCollection'
  /** A collection of paginated SageJournalEntryCollection */
  collection: Array<SageJournalEntry>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type SageJournalEntryFilterConditionInput = {
  field: SageJournalEntryFilterFieldEnum
  operator: FilterOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export enum SageJournalEntryFilterFieldEnum {
  AccountNumber = 'ACCOUNT_NUMBER',
  AccountTitle = 'ACCOUNT_TITLE',
  BaseAmount = 'BASE_AMOUNT',
  BatchDate = 'BATCH_DATE',
  BatchNumber = 'BATCH_NUMBER',
  BatchReference = 'BATCH_REFERENCE',
  BatchTitle = 'BATCH_TITLE',
  ClassId = 'CLASS_ID',
  ClassName = 'CLASS_NAME',
  Currency = 'CURRENCY',
  Description = 'DESCRIPTION',
  EntryDate = 'ENTRY_DATE',
  ExchangeRate = 'EXCHANGE_RATE',
  ExchangeRateDate = 'EXCHANGE_RATE_DATE',
  LastSageSyncDate = 'LAST_SAGE_SYNC_DATE',
  Location = 'LOCATION',
  LocationName = 'LOCATION_NAME',
  SageGiftAccountId = 'SAGE_GIFT_ACCOUNT_ID',
  State = 'STATE',
  TransactionType = 'TRANSACTION_TYPE',
  TxnAmount = 'TXN_AMOUNT',
  WhenCreated = 'WHEN_CREATED',
  WhenModified = 'WHEN_MODIFIED',
}

export type SageLedgerEntry = {
  __typename?: 'SageLedgerEntry'
  accountNumber: Scalars['String']['output']
  accountTitle: Scalars['String']['output']
  amount: Money
  batchNumber: Scalars['String']['output']
  batchTitle: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  /** When the entry was made in Sage, which can be weeks after entry_date */
  enteredAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  entryDate?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  /** False for an unlinked entry with the same description on the same project */
  linkedToCase: Scalars['Boolean']['output']
  sageId?: Maybe<Scalars['String']['output']>
  transactionType?: Maybe<Scalars['String']['output']>
}

export type SageSalesforceMetric = {
  __typename?: 'SageSalesforceMetric'
  metricType: SageSalesforceMetricTypeEnum
  otherValue?: Maybe<Scalars['Int']['output']>
  value: Scalars['Int']['output']
}

export enum SageSalesforceMetricTypeEnum {
  Balances = 'BALANCES',
  CaseRecords = 'CASE_RECORDS',
  JournalEntries = 'JOURNAL_ENTRIES',
  SageGiftAccounts = 'SAGE_GIFT_ACCOUNTS',
}

export type SavedHifoAdmin = {
  __typename?: 'SavedHifoAdmin'
  hifo: HifoAdmin
  id: Scalars['ID']['output']
}

/** Autogenerated input type of SendEventFollowUps */
export type SendEventFollowUpsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
  segment: EventFollowUpSegmentEnum
}

/** Autogenerated return type of SendEventFollowUps. */
export type SendEventFollowUpsPayload = {
  __typename?: 'SendEventFollowUpsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Emails newly queued; guests already sent this follow-up are skipped */
  queuedCount: Scalars['Int']['output']
}

/** Autogenerated input type of SendEventReminder */
export type SendEventReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventId: Scalars['ID']['input']
  kind: EventReminderKindEnum
}

/** Autogenerated return type of SendEventReminder. */
export type SendEventReminderPayload = {
  __typename?: 'SendEventReminderPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Emails newly queued; guests already sent this reminder are skipped */
  queuedCount: Scalars['Int']['output']
}

/** Autogenerated input type of SendHeldUpdates */
export type SendHeldUpdatesInput = {
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of SendHeldUpdates. */
export type SendHeldUpdatesPayload = {
  __typename?: 'SendHeldUpdatesPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of SendTestEmail */
export type SendTestEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  emailKind: Scalars['String']['input']
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of SendTestEmail. */
export type SendTestEmailPayload = {
  __typename?: 'SendTestEmailPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deliveredTo: Scalars['String']['output']
}

/** Autogenerated input type of SendTrainingNudges */
export type SendTrainingNudgesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeIds: Array<Scalars['ID']['input']>
}

/** Autogenerated return type of SendTrainingNudges. */
export type SendTrainingNudgesPayload = {
  __typename?: 'SendTrainingNudgesPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  results: Array<TrainingNudgeResult>
}

export enum SenderRecipientTypeEnum {
  Charity = 'Charity',
  Company = 'Company',
  Contact = 'Contact',
  FundAccount = 'FundAccount',
}

/** Autogenerated input type of SetAssetExpectedReturn */
export type SetAssetExpectedReturnInput = {
  assignmentId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  expectedReturnMethod: AssetReturnMethodEnum
}

/** Autogenerated return type of SetAssetExpectedReturn. */
export type SetAssetExpectedReturnPayload = {
  __typename?: 'SetAssetExpectedReturnPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  item: AssetReturnItem
}

/** Autogenerated input type of SetEarlyAccess */
export type SetEarlyAccessInput = {
  attendeeIds: Array<Scalars['ID']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  enabled: Scalars['Boolean']['input']
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of SetEarlyAccess. */
export type SetEarlyAccessPayload = {
  __typename?: 'SetEarlyAccessPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Interested guests changed; anyone else is skipped */
  updatedCount: Scalars['Int']['output']
}

/** Autogenerated input type of SetEmployeeLeaving */
export type SetEmployeeLeavingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeId: Scalars['ID']['input']
  /** Their last day. The morning after, they're offboarded. null cancels their leaving */
  leftOn?: InputMaybe<Scalars['ISO8601Date']['input']>
}

/** Autogenerated return type of SetEmployeeLeaving. */
export type SetEmployeeLeavingPayload = {
  __typename?: 'SetEmployeeLeavingPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  employee: Employee
}

/** Autogenerated input type of SetTrainingQuestionActive */
export type SetTrainingQuestionActiveInput = {
  active: Scalars['Boolean']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  questionId: Scalars['ID']['input']
}

/** Autogenerated return type of SetTrainingQuestionActive. */
export type SetTrainingQuestionActivePayload = {
  __typename?: 'SetTrainingQuestionActivePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

export type SfAttachments = {
  __typename?: 'SfAttachments'
  /** Content type */
  contentType: Scalars['String']['output']
  /** File name */
  fileName: Scalars['String']['output']
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Int']['output']>
  /** Human-readable file size (e.g. 100 KB, 1 MB, etc.) */
  fileSizeHumanReadable: Scalars['String']['output']
  /** Attachment ID (salesforce id) */
  id: Scalars['String']['output']
  /** Parent record ID */
  parentId?: Maybe<Scalars['String']['output']>
  /** System modification timestamp */
  systemModstamp: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated input type of SnoozeGrant */
export type SnoozeGrantInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  snoozedUntil: Scalars['ISO8601Date']['input']
}

/** Autogenerated return type of SnoozeGrant. */
export type SnoozeGrantPayload = {
  __typename?: 'SnoozeGrantPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  grantCaseRecord: GrantCaseRecord
}

export type StaffQuizAttempt = {
  __typename?: 'StaffQuizAttempt'
  expiresAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  moduleSlug: Scalars['String']['output']
  passMark: Scalars['Int']['output']
  passed?: Maybe<Scalars['Boolean']['output']>
  /** In the order shown, with no correctness */
  questions: Array<StaffQuizQuestion>
  /** Correct answers and explanations; null until submitted */
  review?: Maybe<Array<StaffQuizReview>>
  score?: Maybe<Scalars['Int']['output']>
  startedAt: Scalars['ISO8601DateTime']['output']
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type StaffQuizOption = {
  __typename?: 'StaffQuizOption'
  id: Scalars['ID']['output']
  text: Scalars['String']['output']
}

export type StaffQuizQuestion = {
  __typename?: 'StaffQuizQuestion'
  id: Scalars['ID']['output']
  options: Array<StaffQuizOption>
  prompt: Scalars['String']['output']
}

export type StaffQuizReview = {
  __typename?: 'StaffQuizReview'
  correct: Scalars['Boolean']['output']
  correctOptionId: Scalars['ID']['output']
  explanation?: Maybe<Scalars['String']['output']>
  options: Array<StaffQuizOption>
  prompt: Scalars['String']['output']
  questionId: Scalars['ID']['output']
  selectedOptionId?: Maybe<Scalars['ID']['output']>
}

export type StaffTrainingCategory = {
  __typename?: 'StaffTrainingCategory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type StaffTrainingCourse = {
  __typename?: 'StaffTrainingCourse'
  category?: Maybe<StaffTrainingCategory>
  completeCount: Scalars['Int']['output']
  /** Days until due_on; negative when overdue */
  daysLeft?: Maybe<Scalars['Int']['output']>
  /** When what's left is due, for a mandatory course */
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  mandatory: Scalars['Boolean']['output']
  moduleCount: Scalars['Int']['output']
  /** Its only module, when it has one: staff go straight there */
  moduleSlug?: Maybe<Scalars['String']['output']>
  /** Its published modules, in course order */
  modules: Array<StaffTrainingModuleSummary>
  /** The first module still to do */
  nextModuleSlug?: Maybe<Scalars['String']['output']>
  /** The course's poster, or its first module's */
  posterUrl?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  /** False for an optional course the caller hasn't started */
  started: Scalars['Boolean']['output']
  /** NOT_STARTED, IN_PROGRESS, OVERDUE or COMPLETE */
  status: TrainingAssignmentStatusEnum
  /** The course's, or its module's when it has only one */
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type StaffTrainingCourseSummary = {
  __typename?: 'StaffTrainingCourseSummary'
  category?: Maybe<StaffTrainingCategory>
  completeCount: Scalars['Int']['output']
  /** Days until due_on; negative when overdue */
  daysLeft?: Maybe<Scalars['Int']['output']>
  /** When what's left is due, for a mandatory course */
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  mandatory: Scalars['Boolean']['output']
  moduleCount: Scalars['Int']['output']
  /** Its only module, when it has one: staff go straight there */
  moduleSlug?: Maybe<Scalars['String']['output']>
  /** The first module still to do */
  nextModuleSlug?: Maybe<Scalars['String']['output']>
  /** The course's poster, or its first module's */
  posterUrl?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  /** False for an optional course the caller hasn't started */
  started: Scalars['Boolean']['output']
  /** NOT_STARTED, IN_PROGRESS, OVERDUE or COMPLETE */
  status: TrainingAssignmentStatusEnum
  /** The course's, or its module's when it has only one */
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type StaffTrainingModule = {
  __typename?: 'StaffTrainingModule'
  bestScore?: Maybe<Scalars['Int']['output']>
  /** Markdown, for reading */
  body?: Maybe<Scalars['String']['output']>
  /** A module without a quiz can be marked as done now */
  canComplete: Scalars['Boolean']['output']
  captionsUrl?: Maybe<Scalars['String']['output']>
  /** WebVTT text, for a same-origin blob URL */
  captionsVtt?: Maybe<Scalars['String']['output']>
  /** Why a module without a quiz isn't complete yet */
  completeBlockedReason?: Maybe<Scalars['String']['output']>
  controlReference: Scalars['String']['output']
  /** The course it's part of; course modules have no due date */
  course?: Maybe<StaffTrainingCourseSummary>
  /** Days until the due date while the assignment is outstanding; negative when overdue */
  daysLeft?: Maybe<Scalars['Int']['output']>
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  durationLabel?: Maybe<Scalars['String']['output']>
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  hasQuiz: Scalars['Boolean']['output']
  hasVideo: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  keyPoints: Array<Scalars['String']['output']>
  links: Array<TrainingModuleLink>
  /** Waiting for the earlier modules in its course */
  locked: Scalars['Boolean']['output']
  maxWatchPercent: Scalars['Int']['output']
  minWatchPercent: Scalars['Int']['output']
  /** The module after this one in its course */
  nextInCourseSlug?: Maybe<Scalars['String']['output']>
  passedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  policies: Array<StaffTrainingPolicy>
  posterUrl?: Maybe<Scalars['String']['output']>
  quiz: StaffTrainingQuizInfo
  slug: Scalars['String']['output']
  status: TrainingAssignmentStatusEnum
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  videoCompleted: Scalars['Boolean']['output']
  /** Short-lived signed URL, generated per request */
  videoUrl?: Maybe<Scalars['String']['output']>
}

export type StaffTrainingModuleSummary = {
  __typename?: 'StaffTrainingModuleSummary'
  bestScore?: Maybe<Scalars['Int']['output']>
  controlReference: Scalars['String']['output']
  /** Days until the due date while the assignment is outstanding; negative when overdue */
  daysLeft?: Maybe<Scalars['Int']['output']>
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  durationLabel?: Maybe<Scalars['String']['output']>
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  hasQuiz: Scalars['Boolean']['output']
  hasVideo: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  /** Waiting for the earlier modules in its course */
  locked: Scalars['Boolean']['output']
  passedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  posterUrl?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  status: TrainingAssignmentStatusEnum
  title: Scalars['String']['output']
}

export type StaffTrainingPolicy = {
  __typename?: 'StaffTrainingPolicy'
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  overdue: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
  version: Scalars['String']['output']
}

export type StaffTrainingQuizInfo = {
  __typename?: 'StaffTrainingQuizInfo'
  /** Why the quiz can't start yet, in words to show the user */
  blockedReason?: Maybe<Scalars['String']['output']>
  canStart: Scalars['Boolean']['output']
  /** An unfinished, unexpired attempt to resume */
  openAttemptId?: Maybe<Scalars['ID']['output']>
  passMark: Scalars['Int']['output']
  questionsPerAttempt: Scalars['Int']['output']
}

/** Autogenerated input type of StartTrainingCourse */
export type StartTrainingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** Autogenerated return type of StartTrainingCourse. */
export type StartTrainingCoursePayload = {
  __typename?: 'StartTrainingCoursePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: StaffTrainingCourse
}

/** Autogenerated input type of StartTrainingQuizAttempt */
export type StartTrainingQuizAttemptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
}

/** Autogenerated return type of StartTrainingQuizAttempt. */
export type StartTrainingQuizAttemptPayload = {
  __typename?: 'StartTrainingQuizAttemptPayload'
  attempt: StaffQuizAttempt
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

export type Statement = {
  __typename?: 'Statement'
  createdAt: Scalars['ISO8601DateTime']['output']
  currency: Scalars['String']['output']
  endDate: Scalars['ISO8601Date']['output']
  giftAccountId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  legalEntity: LegalEntity
  startDate: Scalars['ISO8601Date']['output']
}

export type StringFilterInput = {
  field: FundFilterFieldEnum
  operator: StringOperatorEnum
  value?: InputMaybe<Scalars['String']['input']>
}

export enum StringOperatorEnum {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Eq = 'EQ',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  StartsWith = 'STARTS_WITH',
}

/** Autogenerated input type of SubmitTrainingQuizAttempt */
export type SubmitTrainingQuizAttemptInput = {
  answers: Array<QuizAnswerInput>
  attemptId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of SubmitTrainingQuizAttempt. */
export type SubmitTrainingQuizAttemptPayload = {
  __typename?: 'SubmitTrainingQuizAttemptPayload'
  attempt: StaffQuizAttempt
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of SyncSageRecords */
export type SyncSageRecordsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  matchTransactionRecords: Scalars['Boolean']['input']
  syncSageAccounts: Scalars['Boolean']['input']
  syncSageTransactions: Scalars['Boolean']['input']
}

/** Autogenerated return type of SyncSageRecords. */
export type SyncSageRecordsPayload = {
  __typename?: 'SyncSageRecordsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

export type TargetAudience = {
  __typename?: 'TargetAudience'
  filters: Array<TargetAudienceFilter>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type TargetAudienceFilter = {
  __typename?: 'TargetAudienceFilter'
  filterType: Scalars['String']['output']
  id: Scalars['ID']['output']
  record: Scalars['String']['output']
  recordType: Scalars['String']['output']
}

export type TargetAudienceFilterInput = {
  filterType: TargetAudienceFilterTypeEnum
  id?: InputMaybe<Scalars['String']['input']>
  record: Scalars['String']['input']
  recordType: TargetAudienceFilterRecordTypeEnum
}

export enum TargetAudienceFilterRecordTypeEnum {
  Daf = 'DAF',
  MailingCountry = 'MAILING_COUNTRY',
  Member = 'MEMBER',
}

export enum TargetAudienceFilterTypeEnum {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE',
}

export type TargetAudienceInput = {
  filters?: InputMaybe<Array<TargetAudienceFilterInput>>
  name: Scalars['String']['input']
}

export type TaxInformation = {
  __typename?: 'TaxInformation'
  hasUsPassport?: Maybe<Scalars['Boolean']['output']>
  nationalityCountryCode?: Maybe<Scalars['Country']['output']>
  taxResidencyCountryCode?: Maybe<Scalars['Country']['output']>
  ukDomiciled?: Maybe<Scalars['Boolean']['output']>
}

export type Team = {
  __typename?: 'Team'
  activeEmployeeCount: Scalars['Int']['output']
  archived: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** Autogenerated input type of TerminateContract */
export type TerminateContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  /** Defaults to today */
  terminatedOn?: InputMaybe<Scalars['ISO8601Date']['input']>
}

/** Autogenerated return type of TerminateContract. */
export type TerminateContractPayload = {
  __typename?: 'TerminateContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of TestMutation */
export type TestMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  test: Scalars['String']['input']
}

/** Autogenerated return type of TestMutation. */
export type TestMutationPayload = {
  __typename?: 'TestMutationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  test: Scalars['String']['output']
}

export type TieredFee = {
  __typename?: 'TieredFee'
  amount: Money
  fee: Money
  rate: Scalars['Float']['output']
}

export enum TrainingAccessStatusEnum {
  Archived = 'ARCHIVED',
  NotAdmin = 'NOT_ADMIN',
  No_2Fa = 'NO_2FA',
  NoLogin = 'NO_LOGIN',
  Ok = 'OK',
}

export type TrainingAnswerOptionAdmin = {
  __typename?: 'TrainingAnswerOptionAdmin'
  correct: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  position?: Maybe<Scalars['Int']['output']>
  text: Scalars['String']['output']
}

export type TrainingAnswerOptionInput = {
  correct: Scalars['Boolean']['input']
  /** Omit for a new option */
  id?: InputMaybe<Scalars['ID']['input']>
  text: Scalars['String']['input']
}

export type TrainingAssignmentAdmin = {
  __typename?: 'TrainingAssignmentAdmin'
  assignedOn: Scalars['ISO8601Date']['output']
  attemptsCount: Scalars['Int']['output']
  bestScore?: Maybe<Scalars['Int']['output']>
  /** Empty for a course module */
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  exemptReason?: Maybe<Scalars['String']['output']>
  exemptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  id: Scalars['ID']['output']
  maxWatchPercent: Scalars['Int']['output']
  moduleId: Scalars['ID']['output']
  moduleTitle: Scalars['String']['output']
  passedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  source: Scalars['String']['output']
  videoCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export enum TrainingAssignmentStatusEnum {
  Complete = 'COMPLETE',
  Exempt = 'EXEMPT',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Overdue = 'OVERDUE',
  Unassigned = 'UNASSIGNED',
}

export type TrainingCategory = {
  __typename?: 'TrainingCategory'
  /** Archived categories stay on their courses but can't be chosen for new ones */
  archived: Scalars['Boolean']['output']
  courseCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  position?: Maybe<Scalars['Int']['output']>
}

export type TrainingComplianceCell = {
  __typename?: 'TrainingComplianceCell'
  bestScore?: Maybe<Scalars['Int']['output']>
  dueOn?: Maybe<Scalars['ISO8601Date']['output']>
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>
  moduleId: Scalars['ID']['output']
  passedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status: TrainingAssignmentStatusEnum
}

export type TrainingComplianceRow = {
  __typename?: 'TrainingComplianceRow'
  accessStatus: TrainingAccessStatusEnum
  /** One per published module, in module order */
  cells: Array<TrainingComplianceCell>
  email?: Maybe<Scalars['String']['output']>
  employeeId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  overall: TrainingOverallStatusEnum
  policiesAcknowledged: Scalars['Int']['output']
  policiesTotal: Scalars['Int']['output']
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  team?: Maybe<Team>
}

/** TrainingComplianceRowCollection type */
export type TrainingComplianceRowCollection = {
  __typename?: 'TrainingComplianceRowCollection'
  /** A collection of paginated TrainingComplianceRowCollection */
  collection: Array<TrainingComplianceRow>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type TrainingComplianceSummary = {
  __typename?: 'TrainingComplianceSummary'
  complete: Scalars['Int']['output']
  completePercent: Scalars['Int']['output']
  inScope: Scalars['Int']['output']
  newStarters: Scalars['Int']['output']
  /** Active employees with training_required off */
  notInScope: Scalars['Int']['output']
  overdue: Scalars['Int']['output']
  /** In scope with at least one policy still to acknowledge */
  peopleYetToAcknowledge: Scalars['Int']['output']
  policyAcknowledgedPercent: Scalars['Int']['output']
  renewalsDueIn30Days: Scalars['Int']['output']
  /** In scope but no admin login, not an admin, or no 2FA */
  withoutPortalAccess: Scalars['Int']['output']
}

export type TrainingCourseAdmin = {
  __typename?: 'TrainingCourseAdmin'
  /** all_staff, teams, employees or new_starters */
  audience: Scalars['String']['output']
  /** People in scope it's for if it's mandatory, or who have started it if it's optional */
  audienceCount: Scalars['Int']['output']
  category?: Maybe<TrainingCategory>
  /** Internal code */
  controlReference: Scalars['String']['output']
  dueWithinDays: Scalars['Int']['output']
  /** The people an employees-audience course is for, by name */
  employees: Array<Employee>
  id: Scalars['ID']['output']
  /** In course order, including drafts */
  modules: Array<TrainingModuleAdmin>
  position?: Maybe<Scalars['Int']['output']>
  posterUrl?: Maybe<Scalars['String']['output']>
  /** When it was first published. New starters are people starting on or after this */
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  publishedModuleCount: Scalars['Int']['output']
  /** Empty when it doesn't renew */
  renewalMonths?: Maybe<Scalars['Int']['output']>
  renewalNoticeDays: Scalars['Int']['output']
  /** mandatory or optional */
  requirement: Scalars['String']['output']
  slug: Scalars['String']['output']
  status: Scalars['String']['output']
  summary?: Maybe<Scalars['String']['output']>
  teams: Array<Team>
  title: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type TrainingCourseInput = {
  /** all_staff, teams, employees or new_starters */
  audience?: InputMaybe<Scalars['String']['input']>
  categoryId?: InputMaybe<Scalars['ID']['input']>
  controlReference?: InputMaybe<Scalars['String']['input']>
  /** Mandatory courses only */
  dueWithinDays?: InputMaybe<Scalars['Int']['input']>
  /** The people an employees-audience course is for */
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>
  /** Mandatory courses only. Empty means it doesn't renew */
  renewalMonths?: InputMaybe<Scalars['Int']['input']>
  /** Mandatory courses only */
  renewalNoticeDays?: InputMaybe<Scalars['Int']['input']>
  /** mandatory or optional */
  requirement?: InputMaybe<Scalars['String']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  /** The teams a teams-audience course is for */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type TrainingCourseProgressRow = {
  __typename?: 'TrainingCourseProgressRow'
  /** One per published module, in course order */
  cells: Array<TrainingComplianceCell>
  completeCount: Scalars['Int']['output']
  email?: Maybe<Scalars['String']['output']>
  employeeId: Scalars['ID']['output']
  /** False when training is switched off for them, so they can't take the course */
  inScope: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  team?: Maybe<Team>
}

export type TrainingEmployeeDetail = {
  __typename?: 'TrainingEmployeeDetail'
  accessStatus?: Maybe<TrainingAccessStatusEnum>
  /** Every period of the compliance modules, newest first */
  assignments: Array<TrainingAssignmentAdmin>
  cells: Array<TrainingComplianceCell>
  email?: Maybe<Scalars['String']['output']>
  employeeId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  /** Null when the person isn't in scope */
  overall?: Maybe<TrainingOverallStatusEnum>
  policyAcknowledgements: Array<PolicyAcknowledgement>
  quizAttempts: Array<TrainingQuizAttemptAdmin>
  startDate?: Maybe<Scalars['ISO8601Date']['output']>
  team?: Maybe<Team>
  trainingRequired: Scalars['Boolean']['output']
}

export type TrainingModuleAdmin = {
  __typename?: 'TrainingModuleAdmin'
  activeQuestionCount: Scalars['Int']['output']
  /** The course's */
  audience: Scalars['String']['output']
  /** Who publishing assigns: the course's audience if it's mandatory, or who has started it */
  audienceCount: Scalars['Int']['output']
  /** Markdown, for reading */
  body?: Maybe<Scalars['String']['output']>
  controlReference: Scalars['String']['output']
  /** The course it's part of. Course modules are self-led: no due date or renewal */
  course?: Maybe<TrainingCourseAdmin>
  /** The course's */
  dueWithinDays: Scalars['Int']['output']
  estimatedMinutes?: Maybe<Scalars['Int']['output']>
  hasCaptions: Scalars['Boolean']['output']
  hasVideo: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  keyPoints: Array<Scalars['String']['output']>
  links: Array<TrainingModuleLink>
  minWatchPercent: Scalars['Int']['output']
  passMark: Scalars['Int']['output']
  policies: Array<PolicyAdmin>
  position?: Maybe<Scalars['Int']['output']>
  posterUrl?: Maybe<Scalars['String']['output']>
  questions: Array<TrainingQuestionAdmin>
  questionsPerAttempt: Scalars['Int']['output']
  /** False for a module completed by watching or reading it */
  quizRequired: Scalars['Boolean']['output']
  /** The course's. Empty when it doesn't renew */
  renewalMonths?: Maybe<Scalars['Int']['output']>
  /** The course's */
  renewalNoticeDays: Scalars['Int']['output']
  slug: Scalars['String']['output']
  status: Scalars['String']['output']
  summary?: Maybe<Scalars['String']['output']>
  /** The course's */
  teams: Array<Team>
  title: Scalars['String']['output']
  /** Can't be completed until the earlier modules in its course are */
  unlocksAfterPrevious: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  videoDurationSeconds?: Maybe<Scalars['Int']['output']>
  videoFileName?: Maybe<Scalars['String']['output']>
  /** Short-lived signed URL, for previewing */
  videoUrl?: Maybe<Scalars['String']['output']>
}

export type TrainingModuleInput = {
  /** @deprecated Set on the course */
  audience?: InputMaybe<Scalars['String']['input']>
  /** Markdown, for reading */
  body?: InputMaybe<Scalars['String']['input']>
  controlReference?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Set on the course */
  dueWithinDays?: InputMaybe<Scalars['Int']['input']>
  estimatedMinutes?: InputMaybe<Scalars['Int']['input']>
  keyPoints?: InputMaybe<Array<Scalars['String']['input']>>
  links?: InputMaybe<Array<TrainingModuleLinkInput>>
  minWatchPercent?: InputMaybe<Scalars['Int']['input']>
  passMark?: InputMaybe<Scalars['Int']['input']>
  policyIds?: InputMaybe<Array<Scalars['ID']['input']>>
  questionsPerAttempt?: InputMaybe<Scalars['Int']['input']>
  /** False for a module completed by watching or reading it */
  quizRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated Set on the course */
  renewalMonths?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated Set on the course */
  renewalNoticeDays?: InputMaybe<Scalars['Int']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  summary?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Set on the course */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
  /** Can't be completed until the earlier modules in its course are */
  unlocksAfterPrevious?: InputMaybe<Scalars['Boolean']['input']>
  videoDurationSeconds?: InputMaybe<Scalars['Int']['input']>
}

export type TrainingModuleLink = {
  __typename?: 'TrainingModuleLink'
  id: Scalars['ID']['output']
  kind: Scalars['String']['output']
  label: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type TrainingModuleLinkInput = {
  kind?: InputMaybe<Scalars['String']['input']>
  label: Scalars['String']['input']
  url: Scalars['String']['input']
}

export type TrainingNudgeAdmin = {
  __typename?: 'TrainingNudgeAdmin'
  employeeId?: Maybe<Scalars['ID']['output']>
  employeeName?: Maybe<Scalars['String']['output']>
  error?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** What it covered, e.g. "Phishing · reminder_d3" */
  items: Array<Scalars['String']['output']>
  kind: Scalars['String']['output']
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  sentByName?: Maybe<Scalars['String']['output']>
  sentOn: Scalars['ISO8601Date']['output']
  skipReason?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  /** The message's opening line */
  summary?: Maybe<Scalars['String']['output']>
}

/** TrainingNudgeAdminCollection type */
export type TrainingNudgeAdminCollection = {
  __typename?: 'TrainingNudgeAdminCollection'
  /** A collection of paginated TrainingNudgeAdminCollection */
  collection: Array<TrainingNudgeAdmin>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type TrainingNudgeResult = {
  __typename?: 'TrainingNudgeResult'
  employeeId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  /** queued, not_in_scope, not_started, nothing_outstanding or already_messaged_today */
  outcome: Scalars['String']['output']
}

export enum TrainingOverallStatusEnum {
  Complete = 'COMPLETE',
  NewStarter = 'NEW_STARTER',
  OnTrack = 'ON_TRACK',
  Overdue = 'OVERDUE',
}

export type TrainingQuestionAdmin = {
  __typename?: 'TrainingQuestionAdmin'
  active: Scalars['Boolean']['output']
  /** Submitted attempts that included this question */
  attempts: Scalars['Int']['output']
  explanation?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  options: Array<TrainingAnswerOptionAdmin>
  /** Null until someone has answered it */
  percentCorrect?: Maybe<Scalars['Int']['output']>
  position?: Maybe<Scalars['Int']['output']>
  prompt: Scalars['String']['output']
}

export type TrainingQuizAttemptAdmin = {
  __typename?: 'TrainingQuizAttemptAdmin'
  abandonedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  assignmentId: Scalars['ID']['output']
  id: Scalars['ID']['output']
  moduleTitle: Scalars['String']['output']
  passed?: Maybe<Scalars['Boolean']['output']>
  questionCount: Scalars['Int']['output']
  score?: Maybe<Scalars['Int']['output']>
  startedAt: Scalars['ISO8601DateTime']['output']
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
}

export type TransferDetails = {
  __typename?: 'TransferDetails'
  json: Scalars['JSON']['output']
}

/** Autogenerated input type of UndoCheckIn */
export type UndoCheckInInput = {
  attendeeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UndoCheckIn. */
export type UndoCheckInPayload = {
  __typename?: 'UndoCheckInPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  guest: EventCheckInGuest
}

export type UnmappedBalance = {
  __typename?: 'UnmappedBalance'
  balance: Money
  currency: Scalars['String']['output']
  fundAccountId?: Maybe<Scalars['String']['output']>
  fundAccountName?: Maybe<Scalars['String']['output']>
  fundCategory?: Maybe<FundCategory>
  fundId?: Maybe<Scalars['String']['output']>
  fundRecordType?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  legalEntity?: Maybe<Scalars['String']['output']>
  sageClass?: Maybe<Scalars['String']['output']>
  sageGiftAccountId?: Maybe<Scalars['String']['output']>
  sageId?: Maybe<Scalars['String']['output']>
  sageName?: Maybe<Scalars['String']['output']>
  side: UnmappedBalanceSide
}

export enum UnmappedBalanceSide {
  SageOnly = 'SAGE_ONLY',
  SalesforceOnly = 'SALESFORCE_ONLY',
}

/** Autogenerated input type of UnsnoozeGrant */
export type UnsnoozeGrantInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UnsnoozeGrant. */
export type UnsnoozeGrantPayload = {
  __typename?: 'UnsnoozeGrantPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  grantCaseRecord: GrantCaseRecord
}

/** Autogenerated input type of UpdateAmendedPledge */
export type UpdateAmendedPledgeInput = {
  amendedPledgeId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  countersigned: Scalars['Boolean']['input']
}

/** Autogenerated return type of UpdateAmendedPledge. */
export type UpdateAmendedPledgePayload = {
  __typename?: 'UpdateAmendedPledgePayload'
  amendedPledge: AmendedPledgeAdmin
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateAsset */
export type UpdateAssetInput = {
  attributes: AssetAttributesInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateAsset. */
export type UpdateAssetPayload = {
  __typename?: 'UpdateAssetPayload'
  asset: Asset
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateAttendeeDetails */
export type UpdateAttendeeDetailsInput = {
  attendeeId: Scalars['ID']['input']
  changes: AttendeeDetailsChangesInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** Email the guest their updated RSVP, if anything changed */
  notify?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of UpdateAttendeeDetails. */
export type UpdateAttendeeDetailsPayload = {
  __typename?: 'UpdateAttendeeDetailsPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateAttendeeStatus */
export type UpdateAttendeeStatusInput = {
  attendeeId?: InputMaybe<Scalars['ID']['input']>
  attendeeUuid?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** False holds the guest's email and calendar update, for sendHeldUpdates to send later */
  notify?: InputMaybe<Scalars['Boolean']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  status: EventAttendeeStatusEnum
  /** On a lead guest, also moves each plus-one who is where the lead is now */
  wholeParty?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of UpdateAttendeeStatus. */
export type UpdateAttendeeStatusPayload = {
  __typename?: 'UpdateAttendeeStatusPayload'
  attendee?: Maybe<EventAttendeeAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateCaseNote */
export type UpdateCaseNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateCaseNote. */
export type UpdateCaseNotePayload = {
  __typename?: 'UpdateCaseNotePayload'
  caseNote: Note
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateCaseRecord */
export type UpdateCaseRecordInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  grantUseRestrictions?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  ownerId?: InputMaybe<Scalars['ID']['input']>
  senderAmount?: InputMaybe<MoneyInput>
  shareEmailWithCharity?: InputMaybe<Scalars['Boolean']['input']>
  shareNameWithCharity?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of UpdateCaseRecord. */
export type UpdateCaseRecordPayload = {
  __typename?: 'UpdateCaseRecordPayload'
  caseRecord: CaseRecord
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateCharityBankAccountStatus */
export type UpdateCharityBankAccountStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  status: CharityBankAccountStatusEnum
}

/** Autogenerated return type of UpdateCharityBankAccountStatus. */
export type UpdateCharityBankAccountStatusPayload = {
  __typename?: 'UpdateCharityBankAccountStatusPayload'
  bankAccount: AdminCharityBankAccount
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateCharityCategory */
export type UpdateCharityCategoryInput = {
  charityCategoryId: Scalars['ID']['input']
  charityCategoryInput: CharityCategoryChangeInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpdateCharityCategory. */
export type UpdateCharityCategoryPayload = {
  __typename?: 'UpdateCharityCategoryPayload'
  charityCategory?: Maybe<CharityCategoryAdmin>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateCharityContact */
export type UpdateCharityContactInput = {
  charityContactId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<CharityContactEnum>
}

/** Autogenerated return type of UpdateCharityContact. */
export type UpdateCharityContactPayload = {
  __typename?: 'UpdateCharityContactPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of UpdateContract */
export type UpdateContractInput = {
  attributes: ContractAttributesInput
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  /** DRAFT or ACTIVE, to move a draft on or back */
  status?: InputMaybe<ContractStatusEnum>
}

/** Autogenerated return type of UpdateContract. */
export type UpdateContractPayload = {
  __typename?: 'UpdateContractPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  contract: Contract
}

/** Autogenerated input type of UpdateEmployee */
export type UpdateEmployeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  employeeInput: EmployeeChangeInput
}

/** Autogenerated return type of UpdateEmployee. */
export type UpdateEmployeePayload = {
  __typename?: 'UpdateEmployeePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  employee?: Maybe<Employee>
}

/** Autogenerated input type of UpdateEmployeeTrainingFields */
export type UpdateEmployeeTrainingFieldsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** One or more, for bulk "Add to training" */
  employeeIds: Array<Scalars['ID']['input']>
  /** null clears it */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  /** null clears it. Needs EDIT_EMPLOYEE */
  teamId?: InputMaybe<Scalars['ID']['input']>
  trainingRequired?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of UpdateEmployeeTrainingFields. */
export type UpdateEmployeeTrainingFieldsPayload = {
  __typename?: 'UpdateEmployeeTrainingFieldsPayload'
  assignedCount: Scalars['Int']['output']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  employees: Array<Employee>
}

/** Autogenerated input type of UpdateEvent */
export type UpdateEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  eventChanges: EventChangeInput
  eventId: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateEvent. */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  event?: Maybe<EventAdmin>
}

/** Autogenerated input type of UpdateEventSettings */
export type UpdateEventSettingsInput = {
  /** Also move upcoming events on the current default T&Cs onto the new ones */
  applyToUpcomingEvents?: InputMaybe<Scalars['Boolean']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  termsUrl?: InputMaybe<Scalars['String']['input']>
  termsVersion?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpdateEventSettings. */
export type UpdateEventSettingsPayload = {
  __typename?: 'UpdateEventSettingsPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  eventSettings: EventSettings
  updatedEventsCount: Scalars['Int']['output']
}

/** Autogenerated input type of UpdateFundsDafInvestmentAllocation */
export type UpdateFundsDafInvestmentAllocationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dateApplied?: InputMaybe<Scalars['ISO8601Date']['input']>
  fundId: Scalars['ID']['input']
  newInvestmentAllocation: InvestmentAllocation
}

/** Autogenerated return type of UpdateFundsDafInvestmentAllocation. */
export type UpdateFundsDafInvestmentAllocationPayload = {
  __typename?: 'UpdateFundsDafInvestmentAllocationPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of UpdateFundsDafPlan */
export type UpdateFundsDafPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dateApplied?: InputMaybe<Scalars['ISO8601Date']['input']>
  fundId: Scalars['ID']['input']
  newPlan: PlanEnum
}

/** Autogenerated return type of UpdateFundsDafPlan. */
export type UpdateFundsDafPlanPayload = {
  __typename?: 'UpdateFundsDafPlanPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

/** Autogenerated input type of UpdateGrantCaseRecord */
export type UpdateGrantCaseRecordInput = {
  caseRecordId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  readyForRelease?: InputMaybe<Scalars['Boolean']['input']>
  riskLevelTier?: InputMaybe<GrantRiskLevelTierEnum>
}

/** Autogenerated return type of UpdateGrantCaseRecord. */
export type UpdateGrantCaseRecordPayload = {
  __typename?: 'UpdateGrantCaseRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  grantCaseRecord: GrantCaseRecord
}

/** Autogenerated input type of UpdateGrantComplianceCheck */
export type UpdateGrantComplianceCheckInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  grantComplianceCheckId: Scalars['ID']['input']
  status: GrantComplianceCheckStatusEnum
}

/** Autogenerated return type of UpdateGrantComplianceCheck. */
export type UpdateGrantComplianceCheckPayload = {
  __typename?: 'UpdateGrantComplianceCheckPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  grantComplianceCheck: GrantComplianceCheck
}

/** Autogenerated input type of UpdateHifoCascade */
export type UpdateHifoCascadeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadeInput: HifoCascadeChangeInput
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateHifoCascade. */
export type UpdateHifoCascadePayload = {
  __typename?: 'UpdateHifoCascadePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  hifoCascade?: Maybe<HifoCascade>
}

/** Autogenerated input type of UpdateHifoCascadePitch */
export type UpdateHifoCascadePitchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  hifoCascadePitchInput: HifoCascadePitchChangeInput
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateHifoCascadePitch. */
export type UpdateHifoCascadePitchPayload = {
  __typename?: 'UpdateHifoCascadePitchPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  hifoCascadePitch?: Maybe<HifoCascadePitch>
}

/** Autogenerated input type of UpdateHifo */
export type UpdateHifoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  comment?: InputMaybe<Scalars['String']['input']>
  hifoInput: HifoChangeInput
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateHifo. */
export type UpdateHifoPayload = {
  __typename?: 'UpdateHifoPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  errors: Array<Scalars['String']['output']>
  hifo?: Maybe<HifoAdmin>
}

/** Autogenerated input type of UpdateImpactMeasurementCategory */
export type UpdateImpactMeasurementCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactMeasurementCategoryId: Scalars['ID']['input']
  impactMeasurementCategoryInput: ImpactMeasurementCategoryInput
}

/** Autogenerated return type of UpdateImpactMeasurementCategory. */
export type UpdateImpactMeasurementCategoryPayload = {
  __typename?: 'UpdateImpactMeasurementCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactMeasurementCategory?: Maybe<ImpactMeasurementCategory>
}

/** Autogenerated input type of UpdateImpactMeasurementItem */
export type UpdateImpactMeasurementItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactMeasurementItemId: Scalars['ID']['input']
  impactMeasurementItemInput: ImpactMeasurementItemInput
}

/** Autogenerated return type of UpdateImpactMeasurementItem. */
export type UpdateImpactMeasurementItemPayload = {
  __typename?: 'UpdateImpactMeasurementItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactMeasurementItem?: Maybe<ImpactMeasurementItem>
}

/** Autogenerated input type of UpdateImpactRecord */
export type UpdateImpactRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  impactRecordId: Scalars['ID']['input']
  impactRecordInput: ImpactRecordInput
}

/** Autogenerated return type of UpdateImpactRecord. */
export type UpdateImpactRecordPayload = {
  __typename?: 'UpdateImpactRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  impactRecord?: Maybe<ImpactData>
}

/** Autogenerated input type of UpdateInvestmentPool */
export type UpdateInvestmentPoolInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  investmentPoolInput: InvestmentPoolInput
}

/** Autogenerated return type of UpdateInvestmentPool. */
export type UpdateInvestmentPoolPayload = {
  __typename?: 'UpdateInvestmentPoolPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  investmentPool?: Maybe<InvestmentPool>
}

/** Autogenerated input type of UpdateInvestmentPoolPerformance */
export type UpdateInvestmentPoolPerformanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  investmentPoolPerformanceInput: InvestmentPoolPerformanceInput
}

/** Autogenerated return type of UpdateInvestmentPoolPerformance. */
export type UpdateInvestmentPoolPerformancePayload = {
  __typename?: 'UpdateInvestmentPoolPerformancePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  investmentPoolPerformance?: Maybe<InvestmentPoolPerformance>
}

/** Autogenerated input type of UpdateMatchCampaignCategory */
export type UpdateMatchCampaignCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  matchCampaignCategoryInput: MatchCampaignCategoryInput
}

/** Autogenerated return type of UpdateMatchCampaignCategory. */
export type UpdateMatchCampaignCategoryPayload = {
  __typename?: 'UpdateMatchCampaignCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  matchCampaignCategory?: Maybe<MatchCampaignCategory>
}

/** Autogenerated input type of UpdateMatchCampaign */
export type UpdateMatchCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  matchCampaignInput: MatchCampaignInput
}

/** Autogenerated return type of UpdateMatchCampaign. */
export type UpdateMatchCampaignPayload = {
  __typename?: 'UpdateMatchCampaignPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  matchCampaign?: Maybe<MatchCampaignAdmin>
}

/** Autogenerated input type of UpdateNewsItem */
export type UpdateNewsItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  newsItemChanges: NewsItemChangeInput
  newsItemId: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateNewsItem. */
export type UpdateNewsItemPayload = {
  __typename?: 'UpdateNewsItemPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  newsItem?: Maybe<NewsItemAdmin>
}

/** Autogenerated input type of UpdatePledge */
export type UpdatePledgeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  closerId?: InputMaybe<Scalars['ID']['input']>
  countersigned: Scalars['Boolean']['input']
  pledgeId: Scalars['ID']['input']
}

/** Autogenerated return type of UpdatePledge. */
export type UpdatePledgePayload = {
  __typename?: 'UpdatePledgePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  pledge: PledgeAdmin
}

/** Autogenerated input type of UpdatePolicy */
export type UpdatePolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  policyId: Scalars['ID']['input']
  policyInput: PolicyInput
}

/** Autogenerated return type of UpdatePolicy. */
export type UpdatePolicyPayload = {
  __typename?: 'UpdatePolicyPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  policy: PolicyAdmin
}

/** Autogenerated input type of UpdateRole */
export type UpdateRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  roleInput: RoleInput
}

/** Autogenerated return type of UpdateRole. */
export type UpdateRolePayload = {
  __typename?: 'UpdateRolePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  role?: Maybe<Role>
}

/** Autogenerated input type of UpdateSageGiftAccountRecord */
export type UpdateSageGiftAccountRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  fundAccountId?: InputMaybe<Scalars['ID']['input']>
  sageGiftAccountId: Scalars['ID']['input']
  syncSageJournalEntries: Scalars['Boolean']['input']
}

/** Autogenerated return type of UpdateSageGiftAccountRecord. */
export type UpdateSageGiftAccountRecordPayload = {
  __typename?: 'UpdateSageGiftAccountRecordPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated input type of UpdateTargetAudience */
export type UpdateTargetAudienceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  targetAudienceId: Scalars['ID']['input']
  targetAudienceInput: TargetAudienceInput
}

/** Autogenerated return type of UpdateTargetAudience. */
export type UpdateTargetAudiencePayload = {
  __typename?: 'UpdateTargetAudiencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  targetAudience?: Maybe<TargetAudience>
}

/** Autogenerated input type of UpdateTeam */
export type UpdateTeamInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpdateTeam. */
export type UpdateTeamPayload = {
  __typename?: 'UpdateTeamPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  team: Team
}

/** Autogenerated input type of UpdateTrainingAssignment */
export type UpdateTrainingAssignmentInput = {
  assignmentId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  dueOn?: InputMaybe<Scalars['ISO8601Date']['input']>
  exempt?: InputMaybe<Scalars['Boolean']['input']>
  exemptReason?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpdateTrainingAssignment. */
export type UpdateTrainingAssignmentPayload = {
  __typename?: 'UpdateTrainingAssignmentPayload'
  assignment: TrainingAssignmentAdmin
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpdateTrainingCategory */
export type UpdateTrainingCategoryInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpdateTrainingCategory. */
export type UpdateTrainingCategoryPayload = {
  __typename?: 'UpdateTrainingCategoryPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCategory: TrainingCategory
}

/** Autogenerated input type of UpdateTrainingCourse */
export type UpdateTrainingCourseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  courseId: Scalars['ID']['input']
  courseInput: TrainingCourseInput
}

/** Autogenerated return type of UpdateTrainingCourse. */
export type UpdateTrainingCoursePayload = {
  __typename?: 'UpdateTrainingCoursePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingCourse: TrainingCourseAdmin
}

/** Autogenerated input type of UpdateTrainingModule */
export type UpdateTrainingModuleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
  moduleInput: TrainingModuleInput
}

/** Autogenerated return type of UpdateTrainingModule. */
export type UpdateTrainingModulePayload = {
  __typename?: 'UpdateTrainingModulePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

/** Autogenerated input type of UpdateUsDueDiligence */
export type UpdateUsDueDiligenceInput = {
  boardMembers?: InputMaybe<Array<UsDueDiligenceBoardMemberInput>>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  foundationCode?: InputMaybe<Scalars['String']['input']>
  isCaliforniaAttorneyGeneralRegistryCompliant?: InputMaybe<
    Scalars['Boolean']['input']
  >
  isCaliforniaFranchiseTaxBoardCompliant?: InputMaybe<
    Scalars['Boolean']['input']
  >
  isFlaggedInOfac?: InputMaybe<Scalars['Boolean']['input']>
  isIrsPub78Compliant?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  rulingDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  status?: InputMaybe<UsDueDiligenceStatusEnum>
  subsectionCode?: InputMaybe<Scalars['String']['input']>
  usDueDiligenceId: Scalars['ID']['input']
  yearOfIncorporation?: InputMaybe<Scalars['Int']['input']>
}

/** Autogenerated input type of UpdateUsDueDiligenceNote */
export type UpdateUsDueDiligenceNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  id: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateUsDueDiligenceNote. */
export type UpdateUsDueDiligenceNotePayload = {
  __typename?: 'UpdateUsDueDiligenceNotePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  usDueDiligenceNote: Note
}

/** Autogenerated return type of UpdateUsDueDiligence. */
export type UpdateUsDueDiligencePayload = {
  __typename?: 'UpdateUsDueDiligencePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  usDueDiligence: UsDueDiligence
}

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  displayPriority?: InputMaybe<Scalars['Int']['input']>
  featureFlagsChanges?: InputMaybe<Array<FeatureFlagChangeInput>>
  firstName?: InputMaybe<Scalars['String']['input']>
  fullTitleOverride?: InputMaybe<Scalars['String']['input']>
  isMemberAppUser?: InputMaybe<Scalars['Boolean']['input']>
  memberPageVisibility?: InputMaybe<Scalars['Boolean']['input']>
  password?: InputMaybe<PasswordChange>
  permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>
  quote?: InputMaybe<Scalars['String']['input']>
  salesforceId?: InputMaybe<Scalars['String']['input']>
  surname?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
}

/** Autogenerated input type of UpdateZeroHarmReview */
export type UpdateZeroHarmReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<ZeroHarmReviewStatusEnum>
  zeroHarmReviewId: Scalars['ID']['input']
}

/** Autogenerated return type of UpdateZeroHarmReview. */
export type UpdateZeroHarmReviewPayload = {
  __typename?: 'UpdateZeroHarmReviewPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  zeroHarmReview: ZeroHarmReview
}

/** Autogenerated input type of UpsertCharityBankAccountChecklistItem */
export type UpsertCharityBankAccountChecklistItemInput = {
  charityBankAccountId: Scalars['ID']['input']
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  itemKey: BankAccountChecklistItemKeyEnum
  notes?: InputMaybe<Scalars['String']['input']>
  status: BankAccountChecklistItemStatusEnum
}

/** Autogenerated return type of UpsertCharityBankAccountChecklistItem. */
export type UpsertCharityBankAccountChecklistItemPayload = {
  __typename?: 'UpsertCharityBankAccountChecklistItemPayload'
  checklistItem: AdminCharityBankAccountChecklistItem
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** Autogenerated input type of UpsertEventQuestionTemplate */
export type UpsertEventQuestionTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  label: Scalars['String']['input']
  options?: InputMaybe<Scalars['JSON']['input']>
  questionType: Scalars['String']['input']
  sfField?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of UpsertEventQuestionTemplate. */
export type UpsertEventQuestionTemplatePayload = {
  __typename?: 'UpsertEventQuestionTemplatePayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  questionTemplate: EventQuestionTemplate
}

/** Autogenerated input type of UpsertTrainingQuestion */
export type UpsertTrainingQuestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  explanation?: InputMaybe<Scalars['String']['input']>
  moduleId: Scalars['ID']['input']
  options: Array<TrainingAnswerOptionInput>
  prompt: Scalars['String']['input']
  /** Omit to add a question */
  questionId?: InputMaybe<Scalars['ID']['input']>
}

/** Autogenerated return type of UpsertTrainingQuestion. */
export type UpsertTrainingQuestionPayload = {
  __typename?: 'UpsertTrainingQuestionPayload'
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>
  trainingModule: TrainingModuleAdmin
}

export type UsDueDiligence = {
  __typename?: 'UsDueDiligence'
  attachments: Array<UsDueDiligenceAttachment>
  boardMembers: Scalars['JSON']['output']
  charity: Charity
  createdAt: Scalars['ISO8601DateTime']['output']
  editHistory: Array<EditHistory>
  ein?: Maybe<Scalars['String']['output']>
  foundationCode: UsDueDiligenceStringField
  id: Scalars['ID']['output']
  isCaliforniaAttorneyGeneralRegistryCompliant: UsDueDiligenceBooleanField
  isCaliforniaFranchiseTaxBoardCompliant: UsDueDiligenceBooleanField
  isExpired: Scalars['Boolean']['output']
  isFlaggedInOfac: UsDueDiligenceBooleanField
  isIrsPub78Compliant: UsDueDiligenceBooleanField
  location?: Maybe<Scalars['String']['output']>
  notes: Array<Note>
  organizationName?: Maybe<Scalars['String']['output']>
  rulingDate: UsDueDiligenceDateField
  status: UsDueDiligenceStatusEnum
  subsectionCode: UsDueDiligenceStringField
  suggestedStatus: UsDueDiligenceSuggestedStatusResult
  updatedAt: Scalars['ISO8601DateTime']['output']
  yearOfIncorporation?: Maybe<Scalars['Int']['output']>
  zeroHarmReview?: Maybe<ZeroHarmReview>
}

export type UsDueDiligenceAttachment = {
  __typename?: 'UsDueDiligenceAttachment'
  createdAt: Scalars['ISO8601DateTime']['output']
  downloadUrl?: Maybe<Scalars['String']['output']>
  fileName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type UsDueDiligenceBoardMemberInput = {
  name: Scalars['String']['input']
  title: Scalars['String']['input']
}

export type UsDueDiligenceBooleanField = {
  __typename?: 'UsDueDiligenceBooleanField'
  reason: Scalars['String']['output']
  suggestedStatus: UsDueDiligenceSuggestedStatusEnum
  value?: Maybe<Scalars['Boolean']['output']>
}

export type UsDueDiligenceDateField = {
  __typename?: 'UsDueDiligenceDateField'
  reason: Scalars['String']['output']
  suggestedStatus: UsDueDiligenceSuggestedStatusEnum
  value?: Maybe<Scalars['ISO8601Date']['output']>
}

export enum UsDueDiligenceStatusEnum {
  Failed = 'Failed',
  Passed = 'Passed',
  Pending = 'Pending',
}

export type UsDueDiligenceStringField = {
  __typename?: 'UsDueDiligenceStringField'
  reason: Scalars['String']['output']
  suggestedStatus: UsDueDiligenceSuggestedStatusEnum
  value?: Maybe<Scalars['String']['output']>
}

export enum UsDueDiligenceSuggestedStatusEnum {
  Failed = 'Failed',
  NeedsReview = 'NeedsReview',
  Passed = 'Passed',
}

export type UsDueDiligenceSuggestedStatusResult = {
  __typename?: 'UsDueDiligenceSuggestedStatusResult'
  reasons: Array<Scalars['String']['output']>
  status: UsDueDiligenceSuggestedStatusEnum
}

export type User = {
  __typename?: 'User'
  activeAdvisorInvitations: Array<AdvisorInvitation>
  admin: Scalars['Boolean']['output']
  advisedDafAccounts: Array<AdvisedDafAccountAdmin>
  archived: Scalars['Boolean']['output']
  avatarUrl?: Maybe<Scalars['String']['output']>
  bio?: Maybe<Scalars['String']['output']>
  canAccessOnboardingFlow: Scalars['Boolean']['output']
  canViewAsUser: Scalars['Boolean']['output']
  causeAreaGroups?: Maybe<Array<Scalars['String']['output']>>
  city?: Maybe<Scalars['String']['output']>
  communityManager: CommunityManager
  companyLogoUrl?: Maybe<Scalars['String']['output']>
  contactId?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentlyViewingAsUser: Scalars['Boolean']['output']
  displayPriority?: Maybe<Scalars['Int']['output']>
  email: Scalars['String']['output']
  /** Their linked employee record, with VIEW_EMPLOYEES */
  employee?: Maybe<Employee>
  employeePermissions?: Maybe<Array<Permission>>
  engagementPreferences?: Maybe<Array<Scalars['String']['output']>>
  featureFlags: Array<FeatureFlagEnum>
  firstName?: Maybe<Scalars['String']['output']>
  firstPledgeDateSigned?: Maybe<Scalars['ISO8601Date']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  fullTitleOverride?: Maybe<Scalars['String']['output']>
  givingPreferences?: Maybe<GivingPreferences>
  grantBasketItem: GrantBasketItemAdmin
  grantBasketItems: Array<GrantBasketItemAdmin>
  grants: Array<GrantAdmin>
  /** Is an offline pledgor or has signed a pledge */
  hasASignedPledge: Scalars['Boolean']['output']
  hasClaimedToHaveBookedWelcomeCall: Scalars['Boolean']['output']
  /** Has a salesforce_id linking this user to a Salesforce contact */
  hasContactLink: Scalars['Boolean']['output']
  homepage?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isAdminUnsubscribed: Scalars['Boolean']['output']
  isArchived: Scalars['Boolean']['output']
  isCleaned: Scalars['Boolean']['output']
  isGranteePortalUser: Scalars['Boolean']['output']
  isMember: Scalars['Boolean']['output']
  isMemberAppUser: Scalars['Boolean']['output']
  isPledger: Scalars['Boolean']['output']
  isSubscribedToClimateFund: Scalars['Boolean']['output']
  isSubscribedToGlobalCatastrophicRisksFund: Scalars['Boolean']['output']
  isSubscribedToGlobalHealthAndDevelopmentFund: Scalars['Boolean']['output']
  isSubscribedToNewFundingOpportunitiesAndMatchCampaigns: Scalars['Boolean']['output']
  isSubscribedToNewsletter: Scalars['Boolean']['output']
  isSubscriptionPending: Scalars['Boolean']['output']
  isUnsubscribed: Scalars['Boolean']['output']
  matchCampaigns: Array<MatchCampaign>
  memberAppSettings: MemberAppSettings
  /** If the user wants to show up in public member's page */
  memberPageVisibility: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  newsItems: Array<NewsItem>
  passwordChangeRequired: Scalars['Boolean']['output']
  permissions: Array<PermissionEnum>
  personalisedHifoRecommendations: Array<PersonalisedHifoRecommendationAdmin>
  phoneCountryCode?: Maybe<Scalars['String']['output']>
  /** Phone number with country code */
  phoneNumber?: Maybe<Scalars['String']['output']>
  phoneNumberWithoutCountryCode?: Maybe<Scalars['String']['output']>
  /** Returns the pledge that is currently being worked on and not yet signed. */
  pledgeInProgress?: Maybe<PledgeInProgress>
  /** If this user has an offline pledge or a countersigned online pledge */
  pledgeSigningComplete: Scalars['Boolean']['output']
  pledges: Array<Pledge>
  postalCode?: Maybe<Scalars['String']['output']>
  preferredMethodsOfCommunication?: Maybe<Array<Scalars['String']['output']>>
  quote?: Maybe<Scalars['String']['output']>
  roles: Array<Scalars['String']['output']>
  salesforceId?: Maybe<Scalars['String']['output']>
  savedHifos: Array<SavedHifoAdmin>
  showImpactAnalyticsFields: Scalars['Boolean']['output']
  signUpSource?: Maybe<Scalars['String']['output']>
  signingCompleted?: Maybe<Scalars['Boolean']['output']>
  state?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
  supportsFoundersPledge?: Maybe<Scalars['Boolean']['output']>
  surname?: Maybe<Scalars['String']['output']>
  taxInformation?: Maybe<TaxInformation>
  title?: Maybe<Scalars['String']['output']>
  totalPledgeValue?: Maybe<Scalars['Float']['output']>
  /** Whether training is switched on for their employee record */
  trainingInScope: Scalars['Boolean']['output']
  twoFactorEnabled: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  userPermissions?: Maybe<Array<Permission>>
  wasPreviouslyUnsubscribed: Scalars['Boolean']['output']
  /** If this profile matches the criteria to show on the website members page */
  websiteProfileOnline: Scalars['Boolean']['output']
  websiteTitle?: Maybe<Scalars['String']['output']>
}

export type UserGrantBasketItemArgs = {
  id: Scalars['String']['input']
}

export type UserGrantBasketItemsArgs = {
  statuses: Array<GrantBasketItemStatus>
}

/** UserCollection type */
export type UserCollection = {
  __typename?: 'UserCollection'
  /** A collection of paginated UserCollection */
  collection: Array<User>
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata
}

export type UserPrivate = {
  __typename?: 'UserPrivate'
  avatarUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export enum UserSearchEnum {
  AdminsOnly = 'AdminsOnly',
  All = 'All',
  GranteePortalUsersOnly = 'GranteePortalUsersOnly',
  MembersOnly = 'MembersOnly',
  NoAccess = 'NoAccess',
}

export enum VerificationCallOutcomeEnum {
  Completed = 'completed',
  Failed = 'failed',
  NoAnswer = 'no_answer',
  Other = 'other',
  WrongContact = 'wrong_contact',
}

export type WebsiteProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>
  displayPriority?: InputMaybe<Scalars['Int']['input']>
  fullTitleOverride?: InputMaybe<Scalars['String']['input']>
  includeOnCommunityPage?: InputMaybe<Scalars['Boolean']['input']>
  includeOnHomepage?: InputMaybe<Scalars['Boolean']['input']>
  includeOnHowItWorksPage?: InputMaybe<Scalars['Boolean']['input']>
  quote?: InputMaybe<Scalars['String']['input']>
  showOnWebsite?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export enum WorldviewEnum {
  Animals = 'ANIMALS',
  CurrentGenerations = 'CURRENT_GENERATIONS',
  LongTermClimate = 'LONG_TERM_CLIMATE',
  LongTermExclClimate = 'LONG_TERM_EXCL_CLIMATE',
  MultipleWorldviews = 'MULTIPLE_WORLDVIEWS',
}

export type ZeroHarmFlagDetail = {
  __typename?: 'ZeroHarmFlagDetail'
  flagged: ZeroHarmFlagDetailFlaggedEnum
  label: Scalars['String']['output']
}

export enum ZeroHarmFlagDetailFlaggedEnum {
  Flagged = 'FLAGGED',
  Inconclusive = 'INCONCLUSIVE',
  NotFlagged = 'NOT_FLAGGED',
}

export type ZeroHarmReview = {
  __typename?: 'ZeroHarmReview'
  aiReviewStatus: ZeroHarmReviewAiReviewStatusEnum
  createdAt: Scalars['ISO8601DateTime']['output']
  flagDetails?: Maybe<Array<ZeroHarmFlagDetail>>
  granteeIdentificationConfidence?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  report?: Maybe<Scalars['String']['output']>
  status: ZeroHarmReviewStatusEnum
  taskId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum ZeroHarmReviewAiReviewStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export enum ZeroHarmReviewStatusEnum {
  Failed = 'FAILED',
  Passed = 'PASSED',
  Pending = 'PENDING',
}
